const html = document.documentElement,
  getDir = html.getAttribute("dir"),
  isRTL = getDir == "rtl",
  adnmEvts = {
    select: "shopify:block:select",
    deselect: "shopify:block:deselect",
    seSelect: "shopify:section:select",
    seDeselect: "shopify:section:deselect",
    seLoad: "shopify:section:load",
    seUnload: "shopify:section:unload",
    seReorder: "shopify:section:reorder",
  };
var $4 = (t, e = document) => e.querySelector(t),
  $id4 = (t) => document.getElementById(t),
  $$4 = (t, e = document) => [...e.querySelectorAll(t)],
  checkObj = (t, e, i, n = !0) => {
    if (n ? !e.has(t) : e.has(t)) throw TypeError("Cannot " + i);
  },
  fnCheck = (t, e, i) => (checkObj(t, e, "access private method"), i),
  collectableAdd = (t, e, i) => {
    (checkObj(t, e, "Cannot add the same private member more than once", !1),
      e instanceof WeakSet ? e.add(t) : e.set(t, i));
  },
  collectableSet = (t, e, i, n) => (
    checkObj(t, e, "write to private field"),
    n ? n.call(t, i) : e.set(t, i),
    i
  ),
  collectableGet = (t, e, i) => (
    checkObj(t, e, "read from private field"),
    i ? i.call(t) : e.get(t)
  ),
  getterAdd = (t, e, i, n = !1) => {
    (!n && t.has(e)) || (t instanceof WeakSet ? t.add(e) : t.set(e, i));
  },
  getterGet = (t, e, i) => {
    if (!t.has(e)) {
      if (!i) return !1;
      getterAdd(t, e, i, !0);
    }
    return t.get(e);
  },
  getterRunFn = (t, e, i) => {
    if (!t.has(e)) throw TypeError(t + "no exist");
    return i;
  },
  getterDelete = (t, e) => {
    t.has(e) && t.delete(e);
  },
  _thu = { nvt: 1 };
function formatMoney(t, e = "") {
  typeof t == "string" && (t = t.replace(".", ""));
  const i = /\{\{\s*(\w+)\s*\}\}/,
    n = e || window.themeHDN.settings.moneyFormat;
  function s(t2, e2) {
    return t2 == null || t2 != t2 ? e2 : t2;
  }
  function r(t2, e2, i2, n2) {
    if (
      ((e2 = s(e2, 2)),
      (i2 = s(i2, ",")),
      (n2 = s(n2, ".")),
      isNaN(t2) || t2 == null)
    )
      return 0;
    let r2 = (t2 = (t2 / 100).toFixed(e2)).split(".");
    return (
      r2[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i2) +
      (r2[1] ? n2 + r2[1] : "")
    );
  }
  let a = "";
  switch (n.match(i)[1]) {
    case "amount":
      a = r(t, 2);
      break;
    case "amount_no_decimals":
      a = r(t, 0);
      break;
    case "amount_with_space_separator":
      a = r(t, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      a = r(t, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      a = r(t, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      a = r(t, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      a = r(t, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      a = r(t, 0, "'");
  }
  return (n.indexOf("with_comma_separator"), n.replace(i, a));
}
function throttle(t) {
  let e,
    i = null;
  const n = (...n2) => {
    var s;
    ((e = n2),
      i === null &&
        (i = requestAnimationFrame(
          ((s = this),
          () => {
            ((i = null), t.apply(s, e));
          }),
        )));
  };
  return (
    (n.cancel = () => {
      (cancelAnimationFrame(i), (i = null));
    }),
    n
  );
}
function debounce(t, e) {
  let i;
  return (...n) => {
    (clearTimeout(i), (i = setTimeout(() => t.apply(this, n), e)));
  };
}
function waitForEvent(t, e) {
  return new Promise((i) => {
    const n = (s) => {
      s.target === t && (t.removeEventListener(e, n), i(s));
    };
    t.addEventListener(e, n);
  });
}
function getUID(t = "hdt") {
  do t += crypto.randomUUID ? crypto.randomUUID() : ~~(1e6 * Math.random());
  while ($id4(t));
  return t;
}
function _matchMedia(t, e) {
  switch (t) {
    case "phone":
      return window.matchMedia("screen and (max-width: 767px)").matches;
    case "tablet":
      return window.matchMedia(
        "screen and (min-width: 768px) and (max-width: 1149px)",
      ).matches;
    case "supports-hover":
      return window.matchMedia("screen and (hover: hover) and (pointer: fine)")
        .matches;
    case "motion":
      return window.matchMedia("(prefers-reduced-motion: no-preference)")
        .matches;
    case "motion-reduce":
      return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    default:
      return (window.matchMedia(t).onchange = e);
  }
}
function createImg(t) {
  const e = new Image(t.width, t.height),
    i = t.attrs || {};
  for (const t2 in i) e.setAttribute(t2, i[t2]);
  return (
    (e.alt = t.alt || ""),
    (e.src = t.src),
    (e.srcset = renderSrcset(t.src, JSON.parse(t.attrs["data-widths"]))),
    t.onload &&
      e.addEventListener(
        "load",
        function () {
          const t2 = e.parentElement;
          t2 && (t2.removeAttribute("loading"), t2.setAttribute("loaded", ""));
        },
        { once: !0 },
      ),
    e
  );
}
function renderSrcset(t, e) {
  let i = new URL(t.startsWith("//") ? `https:${t}` : t),
    n = parseInt(i.searchParams.get("width") || e[e.length - 1]);
  return e
    .filter((t2) => t2 <= n)
    .map(
      (t2) => (i.searchParams.set("width", t2.toString()), `${i.href} ${t2}w`),
    )
    .join(", ");
}
function isFunction(t) {
  return typeof t == "function";
}
const _cachedFetch = new Map();
async function cachedFetch(t, e = "", i) {
  const n = t + e;
  if (_cachedFetch.has(n))
    return Promise.resolve(new Response(new Blob([_cachedFetch.get(n)])));
  const s = await fetch(t, i);
  if (s.status === 200) {
    const t2 = s.headers.get("Content-Type");
    ((t2 && t2.match(/text\//i)) || t2.match(/application\/json/i)) &&
      s
        .clone()
        .text()
        .then((t3) => {
          _cachedFetch.set(n, t3);
        });
  }
  return s;
}
const JSONProducts = {};
class getJSONProduct {
  static load(t) {
    if (t)
      return (
        JSONProducts[t] ||
          (JSONProducts[t] = new Promise(async (e, i) => {
            const n = await fetch(`${Shopify.routes.root}products/${t}.js`);
            n.ok ? e(await n.json()) : i(`${t} not loaded json`);
          })),
        JSONProducts[t]
      );
  }
}
function visibilitychangeFn(t) {
  t.observes &&
    document.addEventListener("visibilitychange", () => {
      document.visibilityState === "visible"
        ? isFunction(t.play) && t.observes.isInview && t.play()
        : isFunction(t.pause) && t.pause();
    });
}
function rteWrapTable(t = document) {
  const e = $$4(".hdt-rte table:not(.hdt-wrapper-added)", t);
  e.length != 0 &&
    e.forEach((t2) => {
      (t2.classList.add("hdt-wrapper-added"),
        (t2.outerHTML = `<div class="hdt-scrollable-wrapper">${t2.outerHTML}</div>`));
    });
}
function accessibleLinks(t = document) {
  const { hostname: e } = window.location,
    i = $$4("a[href]:not([aria-describedby])", t);
  i.length != 0 &&
    i.forEach((t2) => {
      const i2 = t2.hostname !== e;
      if (t2.getAttribute("target") === "_blank") {
        t2.setAttribute(
          "aria-describedby",
          i2 ? "a11y-new-window-external-message" : "a11y-new-window-message",
        );
        let e2 = t2.getAttribute("rel");
        if (!e2 || e2.indexOf("noopener") === -1) {
          let i3 = e2 === void 0 ? "" : e2 + " ";
          ((i3 += "noopener"), t2.setAttribute("rel", i3));
        }
      } else i2 && t2.setAttribute("aria-describedby", "a11y-external-message");
    });
}
function localeUrl(t = document) {
  const { root: e } = Shopify.routes,
    { hostname: i } = window.location;
  e != "/" &&
    ($$4('a[href="/"]', t).forEach((t2) => t2.setAttribute("href", e)),
    $$4(
      `a[href*="${i}/"]:not([href*="${
        i + e
      }"],[href*="@"],[href*="preview_theme_id="])`,
      t,
    ).forEach((t2) =>
      t2.setAttribute("href", t2.getAttribute("href").replace(`${i}/`, i + e)),
    ));
}
var _config2,
  _userConfig2,
  _mouseTrack,
  mouseTrack_fn,
  _mouseCompare,
  mouseCompare_fn,
  _mouseenterHandler,
  mouseenterHandler_fn,
  _mouseleaveHandler,
  mouseleaveHandler_fn,
  _handleHover,
  handleHover_fn,
  _defaultOptions2,
  _timeoutId,
  _onEnter,
  _onExit,
  _elem2,
  _keyid;
class HoverIntent {
  constructor(t, e, i) {
    const n = { key: i || t };
    ((this.keyid_ = n),
      getterAdd(_keyid, n, n),
      getterAdd(_elem2, n, t),
      getterAdd(_userConfig2, n, e),
      getterAdd(_mouseTrack, n, mouseTrack_fn.bind(this)),
      getterAdd(_mouseCompare, n),
      getterAdd(_handleHover, n),
      getterAdd(_mouseenterHandler, n),
      getterAdd(_mouseleaveHandler, n),
      getterAdd(_timeoutId, n, void 0),
      getterAdd(_onEnter, n),
      getterAdd(_onExit, n),
      (getterGet(_elem2, n).isActive = !1),
      getterGet(_elem2, n)?.addEventListener(
        "mouseenter",
        getterRunFn(_handleHover, n, handleHover_fn).bind(this, n),
      ),
      getterGet(_elem2, n)?.addEventListener(
        "mouseleave",
        getterRunFn(_handleHover, n, handleHover_fn).bind(this, n),
      ));
  }
  get config() {
    return getterGet(
      _config2,
      getterGet(_keyid, this.keyid_),
      Object.assign(
        getterGet(_defaultOptions2, _thu),
        getterGet(_userConfig2, getterGet(_keyid, this.keyid_)),
      ),
    );
  }
}
((_keyid = new WeakMap()),
  (_config2 = new WeakMap()),
  (_userConfig2 = new WeakMap()),
  (_mouseTrack = new WeakMap()),
  (_mouseCompare = new WeakSet()),
  (_mouseenterHandler = new WeakSet()),
  (_mouseleaveHandler = new WeakSet()),
  (_handleHover = new WeakSet()),
  (_defaultOptions2 = new Map()),
  getterAdd(_defaultOptions2, _thu, {
    exitDelay: 0,
    interval: 100,
    sensitivity: 6,
  }),
  (_timeoutId = new WeakMap()),
  (_elem2 = new WeakMap()),
  (_onEnter = new WeakSet()),
  (_onExit = new WeakSet()),
  (mouseTrack_fn = function (t) {
    ((this.cX = t.pageX), (this.cY = t.pageY));
  }),
  (mouseCompare_fn = function (t, e) {
    if (
      Math.sqrt(
        (this.prevX - this.cX) * (this.prevX - this.cX) +
          (this.prevY - this.cY) * (this.prevY - this.cY),
      ) < this.config.sensitivity
    )
      return (
        t?.removeEventListener("mousemove", getterGet(_mouseTrack, e)),
        getterDelete(_timeoutId, e),
        t.isActive && (this.config.onExit(t), (t.isActive = !1)),
        (t.isActive = !0),
        (this.ev.pageX = this.cX),
        (this.ev.pageY = this.cY),
        delete this.prevX,
        delete this.prevY,
        this.config.onEnter(t)
      );
    ((this.prevX = this.cX),
      (this.prevY = this.cY),
      getterAdd(
        _timeoutId,
        e,
        setTimeout(() => {
          getterRunFn(_mouseCompare, e, mouseCompare_fn).call(this, t, e);
        }, this.config.interval),
        !0,
      ));
  }),
  (mouseenterHandler_fn = function (t, e) {
    t.isActive ||
      ((this.prevX = this.ev.pageX),
      (this.prevY = this.ev.pageY),
      t?.removeEventListener("mousemove", getterGet(_mouseTrack, e)),
      t?.addEventListener(
        "mousemove",
        getterGet(_mouseTrack, e, mouseTrack_fn.bind(this)),
      ),
      getterAdd(
        _timeoutId,
        e,
        setTimeout(() => {
          getterRunFn(_mouseCompare, e, mouseCompare_fn).call(this, t, e);
        }, this.config.interval),
        !0,
      ));
  }),
  (mouseleaveHandler_fn = function (t, e) {
    t.isActive &&
      (t?.removeEventListener("mousemove", getterGet(_mouseTrack, e)),
      getterAdd(
        _timeoutId,
        e,
        setTimeout(() => {
          (this.config.onExit(t), (t.isActive = !1));
        }, this.config.exitDelay),
        !0,
      ));
  }),
  (handleHover_fn = function (t, e) {
    ((this.ev = Object.assign({}, e)),
      getterAdd(_timeoutId, t, clearTimeout(getterGet(_timeoutId, t)), !0),
      getterRunFn(
        e.type === "mouseenter" ? _mouseenterHandler : _mouseleaveHandler,
        t,
        e.type === "mouseenter" ? mouseenterHandler_fn : mouseleaveHandler_fn,
      ).call(this, getterGet(_elem2, t), t));
  }));
import {
  Carousel,
  ClassNames,
  AutoHeight,
  navUICenter,
  Autoplay,
  navHandlers,
  dotHandlers,
  FocusTrap,
  Delegate,
  animate,
  scroll,
  timeline,
  inView,
  stagger,
} from "vendor";
Carousel.globalOptions = { direction: getDir };
var _delegate1,
  _control_ui,
  control_ui_fn,
  _control_slider,
  control_slider_fn,
  _control_items,
  _slider_api,
  _options_slider,
  _toggle_slider_ready,
  toggle_slider_ready_fn,
  _destroy_slider,
  destroy_slider_fn,
  _on_select_slider,
  on_select_slider_fn,
  _slideshow_animate,
  slideshow_animate_fn,
  _slider_classes = {
    noSlides: "is-no-slides",
    prepared: "is--prepared",
    enabled: "is--enabled",
  },
  _slider_defaults = {
    loop: !1,
    align: "start",
    containScroll: "trimSnaps",
    skipSnaps: !0,
    watchSlides: !1,
    watchDrag: "smart",
    slidesToScroll: "auto",
    inViewThreshold: 0.5,
    classNames: !0,
    autoHeight: !1,
    autoPlay: 0,
    pauseOnHover: !1,
    navUI: !1,
    navUICenter: !1,
    dotUI: !1,
    controlUI: !1,
    a11ySlide: !0,
    a11yKeyBoard: !0,
    a11yControls: !0,
    inView: "is-in-view",
  },
  str_slide = "hdt-slider__slide";
class Slider extends HTMLElement {
  constructor() {
    (super(),
      getterAdd(_control_ui, this),
      getterAdd(_delegate1, this, new Delegate(document.body)),
      getterAdd(_toggle_slider_ready, this),
      getterAdd(_destroy_slider, this),
      getterAdd(_on_select_slider, this),
      getterAdd(_control_slider, this),
      getterAdd(
        _options_slider,
        this,
        Object.assign(
          {},
          _slider_defaults,
          JSON.parse(this.getAttribute("config") || "{}"),
        ),
      ),
      getterAdd(
        _control_items,
        this,
        $$4(`[hdt-slider-controls][aria-controls="${this.id}"] > button`),
      ),
      getterGet(_options_slider, this).watchDrag == "onlyTypeImage"
        ? (getterGet(_options_slider, this).watchDrag = (t, e) => {
            const i = e.target.closest("[data-media-type]");
            return !i || i.getAttribute("data-media-type") == "image";
          })
        : getterGet(_options_slider, this).watchDrag == "smart" &&
          (getterGet(_options_slider, this).watchDrag = (t, e) =>
            t.scrollSnapList().length > 1),
      getterGet(_options_slider, this).watchResize == "#65" &&
        (getterGet(_options_slider, this).watchResize = (t, e) => {
          for (const i of e) {
            if (
              t.containerNode() === i.target &&
              i.contentRect.height != i.target.prevHeight
            )
              return ((i.target.prevHeight = i.contentRect.height), !0);
            if (t.containerNode() === i.target) return !1;
            window.requestAnimationFrame(() => {
              (t.reInit(), t.emit("resize"));
            });
            break;
          }
          return !1;
        }),
      this.id || (this.id = getUID()));
  }
  goToTarget(t, e) {
    this.goToIndex(
      getterGet(_slider_api, this).slideNodes().indexOf(t),
      e || !_matchMedia("motion"),
    );
  }
  goToIndex(t, e) {
    let i,
      n = parseInt(t);
    const s = getterGet(_slider_api, this).scrollSnapList().length;
    if (getterGet(_slider_api, this).slideNodes().length !== s) {
      const { slideRegistry: t2 } = getterGet(
        _slider_api,
        this,
      ).internalEngine();
      for (i = 0; i < t2.length; i++)
        if (t2[i].indexOf(n) > -1) {
          n = i;
          break;
        }
    }
    getterGet(_slider_api, this).scrollTo(
      Math.min(n, s - 1),
      e || !_matchMedia("motion"),
    );
  }
  get isActive() {
    return getterGet(_slider_api, this).internalEngine().options.active;
  }
  reInit() {
    getterGet(_slider_api, this).reInit();
  }
  connectedCallback() {
    const t = [];
    if (
      (getterGet(_options_slider, this).classNames &&
        t.push(ClassNames({ inView: "is-in-view" })),
      getterGet(_options_slider, this).autoHeight && t.push(AutoHeight()),
      getterGet(_options_slider, this).navUI &&
        getterGet(_options_slider, this).navUICenter &&
        t.push(navUICenter()),
      getterGet(_options_slider, this).autoPlay)
    ) {
      const e = {
        delay: getterGet(_options_slider, this).autoPlay,
        stopOnInteraction: !1,
        stopOnMouseEnter: getterGet(_options_slider, this).pauseOnHover,
      };
      t.push(Autoplay(e));
    }
    if (
      (getterAdd(
        _slider_api,
        this,
        Carousel(
          $4(".hdt-slider__viewport", this) || this,
          getterGet(_options_slider, this),
          t,
        ),
      ),
      getterGet(_slider_api, this)
        .on(
          "init",
          getterRunFn(_toggle_slider_ready, this, toggle_slider_ready_fn).bind(
            this,
          ),
        )
        .on(
          "resize",
          getterRunFn(_toggle_slider_ready, this, toggle_slider_ready_fn).bind(
            this,
          ),
        )
        .on(
          "reInit",
          getterRunFn(_toggle_slider_ready, this, toggle_slider_ready_fn).bind(
            this,
          ),
        )
        .on(
          "select",
          getterRunFn(_on_select_slider, this, on_select_slider_fn).bind(this),
        )
        .on(
          "destroy",
          getterRunFn(_destroy_slider, this, destroy_slider_fn).bind(this),
        ),
      getterGet(_options_slider, this).navUI)
    ) {
      const t2 = $$4(`button[name="next"][aria-controls="${this.id}"]`);
      $$4(`button[name="previous"][aria-controls="${this.id}"]`).forEach(
        (e, i) => {
          if (e && t2[i]) {
            const n = navHandlers(getterGet(_slider_api, this), e, t2[i]);
            getterGet(_slider_api, this).on("destroy", n);
          }
        },
      );
    }
    (getterGet(_options_slider, this).dotUI &&
      $$4(`[hdt-slider-dots][aria-controls="${this.id}"]`).forEach((t2) => {
        if (t2) {
          const e = dotHandlers(getterGet(_slider_api, this), t2);
          getterGet(_slider_api, this).on("destroy", e);
        }
      }),
      getterGet(_options_slider, this).controlUI &&
        getterGet(_control_items, this).length > 0 &&
        (getterGet(_delegate1, this).on(
          "click",
          `[hdt-slider-controls][aria-controls="${this.id}"] > button`,
          getterRunFn(_control_slider, this, control_slider_fn).bind(this),
        ),
        getterGet(_slider_api, this)
          .on("init", getterRunFn(_control_ui, this, control_ui_fn).bind(this))
          .on(
            "reInit",
            getterRunFn(_control_ui, this, control_ui_fn).bind(this),
          )
          .on(
            "select",
            getterRunFn(_control_ui, this, control_ui_fn).bind(this),
          )
          .on(
            "destroy",
            getterRunFn(_control_ui, this, control_ui_fn).bind(this),
          )),
      Shopify.designMode &&
        this.addEventListener(adnmEvts.select, (t2) => {
          let e = t2.target;
          (e.classList.contains(str_slide) || (e = e.closest(`.${str_slide}`)),
            this.goToTarget(e, t2.detail.load));
        }));
  }
  disconnectedCallback() {
    getterGet(_slider_api, this) && getterGet(_slider_api, this).destroy();
  }
}
((_slider_api = new WeakMap()),
  (_options_slider = new WeakMap()),
  (_delegate1 = new WeakMap()),
  (_control_items = new WeakMap()),
  (_toggle_slider_ready = new WeakSet()),
  (toggle_slider_ready_fn = function (t, e) {
    const i = e === "resize",
      n = i ? "remove" : "add",
      s = this.hasAttribute("isfade");
    (this.classList[n](_slider_classes.enabled),
      i &&
        s &&
        (clearTimeout(this.timeout),
        (this.timeout = setTimeout(() => {
          t.reInit();
        }, 4))),
      !i &&
        s &&
        (t.internalEngine().translate.toggleActive(!1),
        t.internalEngine().translate.clear()));
  }),
  (_destroy_slider = new WeakSet()),
  (destroy_slider_fn = function () {
    (this.classList.remove(_slider_classes.enabled),
      getterGet(_delegate1, this).off());
  }),
  (_control_ui = new WeakSet()),
  (control_ui_fn = function (t) {
    if (!this.isActive) return;
    const e = t.selectedScrollSnap();
    getterGet(_control_items, this).forEach((t2) =>
      t2.setAttribute("aria-current", t2.value == e),
    );
  }),
  (_control_slider = new WeakSet()),
  (control_slider_fn = function (t, e) {
    e.getAttribute("aria-current") !== "true" && this.goToIndex(e.value);
  }),
  (_on_select_slider = new WeakSet()),
  (on_select_slider_fn = function (t, e) {
    this.dispatchEvent(
      new CustomEvent(`${e}:slide`, {
        bubbles: !1,
        detail: { sliderApi: t, eventName: e },
      }),
    );
  }));
class SliderLazy extends Slider {
  constructor() {
    super();
  }
  connectedCallback() {}
  InitLazy() {
    super.connectedCallback();
  }
}
class SlideShow extends Slider {
  constructor() {
    (super(), getterAdd(_slideshow_animate, this));
  }
  connectedCallback() {
    (super.connectedCallback(),
      getterGet(_slider_api, this).on(
        "init",
        getterRunFn(_slideshow_animate, this, slideshow_animate_fn).bind(this),
      ),
      getterGet(_slider_api, this).on(
        "reInit",
        getterRunFn(_slideshow_animate, this, slideshow_animate_fn).bind(this),
      ),
      getterGet(_slider_api, this).on(
        "select",
        getterRunFn(_slideshow_animate, this, slideshow_animate_fn).bind(this),
      ),
      getterGet(_slider_api, this).on(
        "destroy",
        getterRunFn(_slideshow_animate, this, slideshow_animate_fn).bind(this),
      ));
  }
  isVisible(t) {
    return t.offsetWidth > 0 || t.offsetHeight > 0;
  }
}
((_slideshow_animate = new WeakSet()),
  (slideshow_animate_fn = function (t) {
    const e = t.selectedScrollSnap(),
      i = t.previousScrollSnap(),
      n = $$4("[reval]", t.slideNodes()[e]),
      s = $$4("[reval]", t.slideNodes()[i]),
      r = n.filter((t2) => this.isVisible(t2)),
      a = s.filter((t2) => this.isVisible(t2));
    r.length != 0 &&
      (animate(
        r,
        { opacity: [0, 1], transform: ["translateY(150px)", "translateY(0)"] },
        {
          duration: 0.25,
          easing: "ease",
          delay: stagger(0.15, { start: 0.4, easing: [0, 0.87, 0.58, 1] }),
        },
      ),
      a.length > 0 &&
        e != i &&
        animate(
          a,
          { opacity: [1, 0], transform: ["translateY(0)", "translateY(25px)"] },
          {
            duration: 0.15,
            easing: "ease",
            delay: stagger(0.1, { start: 0.4, easing: [0, 0.87, 0.58, 1] }),
          },
        ));
  }));
var _slider_sync_select,
  slider_sync_select_fn,
  _slider_sync_control_select,
  slider_sync_control_select_fn,
  _slider_sync_control = new WeakMap();
class SliderSync extends Slider {
  constructor() {
    (super(),
      getterAdd(
        _slider_sync_control,
        this,
        $id4(this.getAttribute("aria-controls")),
      ),
      getterAdd(_slider_sync_select, this),
      getterAdd(_slider_sync_control_select, this));
  }
  connectedCallback() {
    (super.connectedCallback(),
      getterGet(_slider_api, getterGet(_slider_sync_control, this)) &&
        (getterGet(_slider_api, getterGet(_slider_sync_control, this)).on(
          "select",
          getterRunFn(
            _slider_sync_control_select,
            this,
            slider_sync_control_select_fn,
          ).bind(this),
        ),
        getterGet(_slider_api, this).on(
          "select",
          getterRunFn(_slider_sync_select, this, slider_sync_select_fn).bind(
            this,
          ),
        ),
        getterGet(_slider_api, getterGet(_slider_sync_control, this)).on(
          "destroy",
          () => {
            getterGet(_slider_api, this).off(
              "select",
              getterRunFn(
                _slider_sync_select,
                this,
                slider_sync_select_fn,
              ).bind(this),
            );
          },
        ),
        getterGet(_slider_api, this).on("destroy", () => {
          getterGet(_slider_api, getterGet(_slider_sync_control, this)).off(
            "select",
            getterRunFn(
              _slider_sync_control_select,
              this,
              slider_sync_control_select_fn,
            ).bind(this),
          );
        })));
  }
}
((_slider_sync_select = new WeakSet()),
  (slider_sync_select_fn = function (t) {
    getterGet(
      _slider_api,
      getterGet(_slider_sync_control, this),
    ).selectedScrollSnap() != t.selectedScrollSnap() &&
      getterGet(_slider_api, getterGet(_slider_sync_control, this)).scrollTo(
        t.selectedScrollSnap(),
      );
  }),
  (_slider_sync_control_select = new WeakSet()),
  (slider_sync_control_select_fn = function (t) {
    getterGet(_slider_api, this).selectedScrollSnap() !=
      t.selectedScrollSnap() &&
      getterGet(_slider_api, this).scrollTo(t.selectedScrollSnap());
  }));
var _add_thumb_btns_click_handlers,
  add_thumb_btns_click_handlers_fn,
  _add_toggle_thumb_btns_active,
  add_toggle_thumb_btns_active_fn,
  _slider_thumbs_control = new WeakMap();
class SlideThumb extends Slider {
  connectedCallback() {
    if (
      (getterAdd(
        _slider_thumbs_control,
        this,
        $id4(this.getAttribute("aria-controls")),
      ),
      this.hasAttribute("stagger") &&
        animate(
          $$4("[reval]", this),
          {
            opacity: [0, 1],
            transform: [
              "scale(.5) rotate(90deg) skew(15deg)",
              "scale(1) rotate(0deg) skew(0deg)",
            ],
          },
          { duration: 0.2, delay: stagger(0.3, { easing: "ease-out" }) },
        ).finished.then(() => {
          this.classList.add("stagger-finished");
        }),
      !getterGet(_slider_thumbs_control, this))
    )
      return;
    super.connectedCallback();
    const t = getterGet(_slider_api, getterGet(_slider_thumbs_control, this)),
      e = getterGet(_slider_api, this);
    (_matchMedia("phone") ||
      _matchMedia("tablet") ||
      e
        .containerNode()
        .style.setProperty(
          "max-height",
          `${t.slideNodes()[t.selectedScrollSnap()].clientHeight + 10}px`,
        ),
      getterAdd(_add_thumb_btns_click_handlers, this),
      getterAdd(_add_toggle_thumb_btns_active, this));
    const i = getterRunFn(
        _add_thumb_btns_click_handlers,
        this,
        add_thumb_btns_click_handlers_fn,
      ).call(this, t, e),
      n = getterRunFn(
        _add_toggle_thumb_btns_active,
        this,
        add_toggle_thumb_btns_active_fn,
      ).call(this, t, e);
    (t.on("destroy", i).on("destroy", n), e.on("destroy", i).on("destroy", n));
  }
}
((_add_thumb_btns_click_handlers = new WeakSet()),
  (add_thumb_btns_click_handlers_fn = function (t, e) {
    const i = $$4(".hdt-slider__slide", this),
      n = (t2) => {
        const i2 = e.slideNodes().indexOf(t2);
        i2 > -1 && getterGet(_slider_thumbs_control, this).goToIndex(i2);
      };
    return (
      i.forEach((t2) => t2.addEventListener("click", n.bind(this, t2), !1)),
      () => {
        i.forEach((t2) =>
          t2.removeEventListener("click", n.bind(this, t2), !1),
        );
      }
    );
  }),
  (_add_toggle_thumb_btns_active = new WeakSet()),
  (add_toggle_thumb_btns_active_fn = function (t, e) {
    const i = () => {
      (this.goToIndex(t.selectedScrollSnap()),
        $4(".is-thumb-selected", this)?.classList.remove("is-thumb-selected"),
        e
          .slideNodes()
          [t.selectedScrollSnap()].classList.add("is-thumb-selected"));
    };
    return (
      t.on("select", i),
      e.on("init", i),
      e.on("reInit", i),
      () => {
        e.slideNodes()[t.selectedScrollSnap()].classList.remove(
          "is-thumb-selected",
        );
      }
    );
  }));
var _update_total_counter,
  update_total_counter_fn,
  _update_current_counter,
  update_current_counter_fn,
  _slider_counter = new WeakMap();
class SlideCounter extends HTMLElement {
  #t;
  constructor() {
    (super(),
      getterAdd(_update_total_counter, this),
      getterAdd(_update_current_counter, this));
  }
  connectedCallback() {
    ((this.#t = new AbortController()),
      getterAdd(_slider_counter, this, $id4(this.getAttribute("slider"))),
      getterGet(_slider_counter, this) &&
        (getterGet(_slider_api, getterGet(_slider_counter, this)).on(
          "init",
          getterRunFn(
            _update_total_counter,
            this,
            update_total_counter_fn,
          ).bind(this),
          { signal: this.#t.signal },
        ),
        getterGet(_slider_api, getterGet(_slider_counter, this)).on(
          "reInit",
          getterRunFn(
            _update_total_counter,
            this,
            update_total_counter_fn,
          ).bind(this),
          { signal: this.#t.signal },
        ),
        getterGet(_slider_api, getterGet(_slider_counter, this)).on(
          "select",
          getterRunFn(
            _update_current_counter,
            this,
            update_current_counter_fn,
          ).bind(this),
          { signal: this.#t.signal },
        )));
  }
  disconnectedCallback() {
    this.#t.abort();
  }
  get total() {
    return $4("[update-total]", this);
  }
  get current() {
    return (this._current = this._current || $4("[update-current]", this));
  }
}
((_update_total_counter = new WeakSet()),
  (update_total_counter_fn = function (t) {
    getterGet(_slider_counter, this).isActive &&
      ((this.total.textContent = t.scrollSnapList().length),
      getterRunFn(
        _update_current_counter,
        this,
        update_current_counter_fn,
      ).call(this, t));
  }),
  (_update_current_counter = new WeakSet()),
  (update_current_counter_fn = function (t) {
    this.current.textContent = t.selectedScrollSnap() + 1;
  }),
  customElements.define("hdt-slider", Slider),
  customElements.define("hdt-slider-lazy", SliderLazy),
  customElements.define("hdt-slideshow", SlideShow),
  customElements.define("hdt-slider-sync", SliderSync),
  customElements.define("hdt-slider-thumb", SlideThumb),
  customElements.define("hdt-slider-counter", SlideCounter));
class Scrollnap extends HTMLElement {
  constructor() {
    (super(),
      (this.slider = $4('[id^="Scroller-"]', this) || this),
      (this.sliderItems = $$4('[id^="Scroll-"]', this)),
      (this.enableSliderLooping = !1),
      (this.currentPageElement = $4(".hdt-scrollsnap-counter--current", this)),
      (this.pageTotalElement = $4(".hdt-scrollsnap-counter--total", this)),
      (this.prevButton = $4('button[name="previous"]', this)),
      (this.nextButton = $4('button[name="next"]', this)),
      (this.dotButtons = $$4(".hdt-scrollsnap-dot__link", this)),
      (this.sliderFirstItemNode = this.sliderItems[0]),
      this.slider &&
        (this.initPages(),
        new ResizeObserver((t) => this.initPages()).observe(this.slider),
        this.slider.addEventListener("scroll", this.update.bind(this)),
        this.nextButton &&
          (this.prevButton.addEventListener(
            "click",
            this.onButtonClick.bind(this),
          ),
          this.nextButton.addEventListener(
            "click",
            this.onButtonClick.bind(this),
          )),
        this.dotButtons.length &&
          this.dotButtons.forEach((t) =>
            t.addEventListener("click", this.linkToSlide.bind(this)),
          )));
  }
  get isScrollable() {
    return this.slider.scrollWidth !== this.slider.clientWidth;
  }
  initPages() {
    ((this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (t) => t.clientWidth > 0,
    )),
      this.sliderItemsToShow.length < 2 ||
        ((this.sliderItemOffset =
          this.sliderItemsToShow[1].offsetLeft -
          this.sliderItemsToShow[0].offsetLeft),
        (this.slidesPerPage = Math.floor(
          (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
            this.sliderItemOffset,
        )),
        (this.totalPages =
          this.sliderItemsToShow.length - this.slidesPerPage + 1),
        this.update(),
        this.classList.toggle("is-scrollable", this.isScrollable)));
  }
  resetPages() {
    ((this.sliderItems = $$4('[id^="Scroll-"]', this)), this.initPages());
  }
  update() {
    if (!this.slider) return;
    const t = this.currentPage;
    ((this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1),
      this.currentPageElement &&
        this.pageTotalElement &&
        ((this.currentPageElement.textContent = this.currentPage),
        (this.pageTotalElement.textContent = this.totalPages)),
      this.currentPage != t &&
        this.dispatchEvent(
          new CustomEvent("slideChanged", {
            detail: {
              currentPage: this.currentPage,
              currentElement: this.sliderItemsToShow[this.currentPage - 1],
            },
          }),
        ),
      this.dotButtons.length &&
        (this.dotButtons.forEach((t2) => {
          (t2.classList.remove("hdt-scrollsnap-dot__link--active"),
            t2.removeAttribute("aria-current"));
        }),
        this.dotButtons[this.currentPage - 1]?.classList.add(
          "hdt-scrollsnap-dot__link--active",
        ),
        this.dotButtons[this.currentPage - 1]?.setAttribute(
          "aria-current",
          !0,
        )),
      !this.enableSliderLooping &&
        this.nextButton &&
        (this.isSlideVisible(this.sliderItemsToShow[0]) &&
        this.slider.scrollLeft === 0
          ? this.prevButton.setAttribute("disabled", "disabled")
          : this.prevButton.removeAttribute("disabled"),
        this.isSlideVisible(
          this.sliderItemsToShow[this.sliderItemsToShow.length - 1],
        )
          ? this.nextButton.setAttribute("disabled", "disabled")
          : this.nextButton.removeAttribute("disabled")));
  }
  isSlideVisible(t, e = 0) {
    const i = this.slider.clientWidth + this.slider.scrollLeft - e;
    return (
      t.offsetLeft + t.clientWidth <= i &&
      t.offsetLeft >= this.slider.scrollLeft
    );
  }
  onButtonClick(t) {
    t.preventDefault();
    const e = t.currentTarget.dataset.step || 1;
    ((this.slideScrollPosition =
      t.currentTarget.name === "next"
        ? this.slider.scrollLeft + e * this.sliderItemOffset
        : this.slider.scrollLeft - e * this.sliderItemOffset),
      this.setSlidePosition(this.slideScrollPosition));
  }
  linkToSlide(t) {
    t.preventDefault();
    const e =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.dotButtons.indexOf(t.currentTarget) + 1 - this.currentPage);
    this.setSlidePosition(e);
  }
  setSlidePosition(t) {
    this.slider.scrollTo({
      left: t,
      behavior: _matchMedia("motion") ? "smooth" : "auto",
    });
  }
}
customElements.define("hdt-scrollsnap", Scrollnap);
class ScrollBar extends HTMLElement {
  connectedCallback() {
    this.scrolledElement &&
      (this.scrolledElement.addEventListener(
        "scroll",
        throttle(this._updateScrollProgress.bind(this)),
      ),
      window.ResizeObserver &&
        new ResizeObserver(this._updateScrollProgress.bind(this)).observe(
          this.scrolledElement,
        ));
  }
  get scrolledElement() {
    return (this._scrolledElement =
      this._scrolledElement || $id4(this.getAttribute("observes")));
  }
  _updateScrollProgress() {
    const t =
      ((isRTL
        ? Math.abs(this.scrolledElement.scrollLeft)
        : this.scrolledElement.scrollLeft) +
        this.scrolledElement.clientWidth) /
      this.scrolledElement.scrollWidth;
    this.style.setProperty(
      "--scrollbar-progress",
      Math.max(0, Math.min(t, 1)).toFixed(6),
    );
  }
}
customElements.define("hdt-scrollbar", ScrollBar);
var _focusTrap,
  _config,
  _updateSlot,
  updateSlot_fn,
  _toggleClicked,
  toggleClicked_fn,
  _locked,
  locked_fn,
  _isLocked,
  _allowOutsideClick,
  allowOutsideClick_fn,
  _allowOutsideClickTouch,
  allowOutsideClickTouch_fn,
  _allowOutsideClickMouse,
  allowOutsideClickMouse_fn,
  _originalParentBeforeAppend,
  _roundByDPR,
  roundByDPR_fn,
  _translateByDPR,
  translateByDPR_fn,
  _init,
  init_fn,
  _dpr,
  _delegate = new WeakMap(),
  _controller = new WeakMap(),
  counterDialogOpened = 0;
class DialogBase extends HTMLElement {
  constructor() {
    (super(),
      getterAdd(_delegate, this, new Delegate(document.body)),
      getterAdd(_controller, this, void 0),
      collectableAdd(this, _focusTrap, void 0),
      collectableAdd(this, _config, void 0),
      collectableAdd(this, _toggleClicked),
      collectableAdd(this, _updateSlot),
      collectableAdd(this, _originalParentBeforeAppend, void 0),
      collectableAdd(this, _allowOutsideClick),
      collectableAdd(this, _allowOutsideClickTouch),
      collectableAdd(this, _allowOutsideClickMouse),
      collectableAdd(this, _isLocked, !1),
      collectableAdd(this, _locked),
      this.shadowDomTemplate &&
        (() => {
          const template = $id4(this.shadowDomTemplate);
          if (template && template.content) {
            this.attachShadow({ mode: "open" }).appendChild(
              template.content.cloneNode(!0),
            );
            this.shadowRoot.addEventListener("slotchange", (t) =>
              fnCheck(this, _updateSlot, updateSlot_fn).call(this, t.target),
            );
          }
        })(),
      this.addEventListener("dialog:forceClose", (t) => {
        (this.closeDialog(), t.stopPropagation());
      }));
  }
  static get observedAttributes() {
    return ["id", "open"];
  }
  updateBtbsOpen(t) {
    this.id &&
      t &&
      (t.removeEventListener(
        "click",
        getterRunFn(_toggleClicked, this, toggleClicked_fn).bind(this),
      ),
      t.addEventListener(
        "click",
        getterRunFn(_toggleClicked, this, toggleClicked_fn).bind(this),
      ));
  }
  connectedCallback() {
    (this.config.appendToBody == "smart" &&
      (this.config.appendToBody = _matchMedia("phone")),
      this.config.noScroll == "smart" &&
        (this.config.noScroll = _matchMedia("phone")),
      this.id &&
        this.delegate
          .off()
          .on(
            "click",
            this.stringControls,
            getterRunFn(_toggleClicked, this, toggleClicked_fn).bind(this),
          ),
      collectableSet(this, _controller, new AbortController()),
      this.setAttribute("role", "dialog"),
      this.shadowDomTemplate &&
        (this.selectorPartName("overlay")?.addEventListener(
          "click",
          this.closeDialog.bind(this),
          {
            signal: this.abortController.signal,
          },
        ),
        this.shadowRoot &&
          $$4("slot", this.shadowRoot).forEach((t) =>
            fnCheck(this, _updateSlot, updateSlot_fn).call(this, t),
          )),
      Shopify.designMode &&
        !this.hasAttribute("un-detect") &&
        (this.addEventListener(
          adnmEvts.select,
          (t) => this.openDialog(t.detail.load),
          {
            signal: this.abortController.signal,
          },
        ),
        this.addEventListener(adnmEvts.deselect, () => this.closeDialog(!1), {
          signal: this.abortController.signal,
        }),
        (this._shopifySection =
          this._shopifySection || this.closest(".shopify-section")),
        this._shopifySection &&
          (this.hasAttribute("detect-adm-se-evt") &&
            (this._shopifySection.addEventListener(
              adnmEvts.seSelect,
              (t) => this.openDialog(!t.detail.load),
              { signal: this.abortController.signal },
            ),
            this._shopifySection.addEventListener(
              adnmEvts.seDeselect,
              this.closeDialog.bind(this),
              {
                signal: this.abortController.signal,
              },
            )),
          this._shopifySection.addEventListener(
            adnmEvts.seUnload,
            () => this.remove(),
            {
              signal: this.abortController.signal,
            },
          ))));
  }
  disconnectedCallback() {
    (this.abortController.abort(),
      this.delegate.off(),
      this.focusTrap?.deactivate({ onDeactivate: () => {} }),
      collectableGet(this, _isLocked) &&
        (collectableSet(this, _isLocked, !1),
        fnCheck(this, _locked, locked_fn).call(this)));
  }
  get delegate() {
    return getterGet(_delegate, this);
  }
  get abortController() {
    return getterGet(_controller, this);
  }
  get open() {
    return this.hasAttribute("open");
  }
  get defaultTemplate() {
    return null;
  }
  get shadowDomTemplate() {
    return this.getAttribute("template") || this.defaultTemplate;
  }
  get defaultConfig() {
    return {
      catchFocus: !0,
      preventScrollFocus: !0,
      allowOutsideClick: !0,
      noScroll: !0,
      appendToBody: !1,
    };
  }
  get userConfig() {
    return Object.assign(JSON.parse(this.getAttribute("config") || "{}"));
  }
  get config() {
    return collectableSet(
      this,
      _config,
      collectableGet(this, _config) ||
        Object.assign(this.defaultConfig, this.userConfig),
    );
  }
  attributeChangedCallback(t, e, i) {
    switch (t) {
      case "id":
        i &&
          this.delegate
            .off()
            .on(
              "click",
              this.stringControls,
              getterRunFn(_toggleClicked, this, toggleClicked_fn).bind(this),
            );
        break;
      case "open":
        if (
          (collectableSet(this, _isLocked, this.open),
          this.allButton.forEach((t2) =>
            t2.setAttribute("aria-expanded", i === null ? "false" : "true"),
          ),
          e !== null || (i !== "" && i !== "immediate"))
        ) {
          if (e !== null && i === null) {
            (this.dispatchEvent(new CustomEvent("dialog:beforeClose")),
              this.removeAttribute("opened"));
            const t2 = this.animateClose();
            this.getAttribute("closing") === "immediate" && t2.finish();
            const e2 = t2.finished;
            (e2.then(() => {
              (this.dispatchEvent(new CustomEvent("dialog:doneClose")),
                this.parentElement === document.body &&
                  collectableGet(this, _originalParentBeforeAppend) &&
                  (collectableGet(
                    this,
                    _originalParentBeforeAppend,
                  ).appendChild(this),
                  collectableSet(this, _originalParentBeforeAppend, null)),
                this.style.setProperty("display", "none"),
                this.dispatchEvent(new CustomEvent("dialog:afterClose")),
                this.style.removeProperty("z-index"),
                this.removeAttribute("closing"));
            }),
              this.focusTrap?.deactivate({ checkCanReturnFocus: () => e2 }),
              this.config.noScroll &&
                (collectableSet(this, _isLocked, !1),
                fnCheck(this, _locked, locked_fn).call(this)));
          }
        } else {
          (collectableSet(this, _originalParentBeforeAppend, null),
            this.style.setProperty("display", "block"),
            (this.style.zIndex =
              parseInt(this.config.zIndex || 99999999) +
              $$4("[open-dialog]").length),
            this.dispatchEvent(new CustomEvent("dialog:beforeOpen")),
            this.config.appendToBody &&
              this.parentElement !== document.body &&
              (collectableSet(
                this,
                _originalParentBeforeAppend,
                this.parentElement,
              ),
              document.body.append(this),
              ++counterDialogOpened));
          const t2 = this.animateOpen();
          (i === "immediate" && t2.finish(),
            t2.finished.then(() => {
              (this.dispatchEvent(new CustomEvent("dialog:afterOpen")),
                this.setAttribute("opened", ""));
            }),
            this.config.catchFocus &&
              this.focusTrap.activate({ checkCanFocusTrap: () => t2.finished }),
            this.config.noScroll &&
              (++counterDialogOpened,
              collectableSet(this, _isLocked, !0),
              fnCheck(this, _locked, locked_fn).call(this)));
        }
        this.dispatchEvent(new CustomEvent("toggle", { bubbles: !0 }));
    }
  }
  openDialog(t = !0) {
    return this.open
      ? Promise.resolve()
      : (this.setAttribute("open", t ? "" : "immediate"),
        this.setAttribute("open-dialog", ""),
        waitForEvent(this, "dialog:afterOpen"));
  }
  closeDialog(t = !0) {
    return this.open
      ? (this.setAttribute("closing", t ? "" : "immediate"),
        this.removeAttribute("open"),
        this.removeAttribute("open-dialog"),
        waitForEvent(this, "dialog:afterClose"))
      : Promise.resolve();
  }
  animateOpen() {
    return animate(this, {}, { duration: 0 });
  }
  animateClose() {
    return animate(this, {}, { duration: 0 });
  }
  get initialFocus() {
    return this.hasAttribute("initial-focus")
      ? this.getAttribute("initial-focus") !== "false" &&
          $4(this.getAttribute("initial-focus"), this)
      : this.hasAttribute("tabindex")
        ? this
        : $4('input:not([type="hidden"])', this) || !1;
  }
  hideForOutsideClickTarget(t) {
    return !this.contains(t);
  }
  allowOutsideClickForTarget(t) {
    return !1;
  }
  get focusTrap() {
    return collectableSet(
      this,
      _focusTrap,
      collectableGet(this, _focusTrap) ||
        new FocusTrap([this, this.shadowRoot], {
          onDeactivate: this.closeDialog.bind(this),
          allowOutsideClick:
            !!this.config.allowOutsideClick &&
            fnCheck(this, _allowOutsideClick, allowOutsideClick_fn).bind(this),
          initialFocus: !!_matchMedia("supports-hover") && this.initialFocus,
          fallbackFocus: this,
          preventScroll: this.config.preventScrollFocus,
        }),
    );
  }
  selectorPartName(t) {
    return this.shadowRoot?.querySelector(`[part="${t}"]`);
  }
  get stringControls() {
    return `[aria-controls="${this.id}"]:not([section-id])`;
  }
  get allButton() {
    return $$4(this.stringControls, this.getRootNode());
  }
}
((_isLocked = new WeakMap()),
  (_config = new WeakMap()),
  (_focusTrap = new WeakMap()),
  (_toggleClicked = new WeakSet()),
  (toggleClicked_fn = function (t) {
    if ((t?.preventDefault(), t)) {
      const e = t.target;
      ((this.btnOpening =
        e.tagName === "BUTTON" || e.tagName === "A"
          ? e
          : e.closest("button") || e),
        this.btnOpening.hasAttribute("close-dialog") &&
          $id4(this.btnOpening.getAttribute("close-dialog"))?.closeDialog(),
        this.btnOpening.hasAttribute("open-mylti") &&
          this.removeAttribute("open"));
    }
    this.open ? this.closeDialog() : this.openDialog(!0, this.btnOpening);
  }),
  (_locked = new WeakSet()),
  (locked_fn = function () {
    if (collectableGet(this, _isLocked)) html.classList.add("no-scroll");
    else {
      if (counterDialogOpened < 1) return void --counterDialogOpened;
      html.classList.toggle("no-scroll", --counterDialogOpened > 0);
    }
  }),
  (_updateSlot = new WeakSet()),
  (updateSlot_fn = function (t) {
    ["header", "sticky", "body", "footer"].includes(t.name) &&
      (t.parentElement.hidden =
        t.assignedElements({ flatten: !0 }).length === 0);
  }),
  (_originalParentBeforeAppend = new WeakMap()),
  (_allowOutsideClick = new WeakSet()),
  (allowOutsideClick_fn = function (t) {
    return "TouchEvent" in window && t instanceof TouchEvent
      ? fnCheck(this, _allowOutsideClickTouch, allowOutsideClickTouch_fn).call(
          this,
          t,
        )
      : fnCheck(this, _allowOutsideClickMouse, allowOutsideClickMouse_fn).call(
          this,
          t,
        );
  }),
  (_allowOutsideClickTouch = new WeakSet()),
  (allowOutsideClickTouch_fn = function (t) {
    return (
      t.target.addEventListener(
        "touchend",
        (t2) => {
          const e = document.elementFromPoint(
            t2.changedTouches.item(0).clientX,
            t2.changedTouches.item(0).clientY,
          );
          this.hideForOutsideClickTarget(e) && this.closeDialog();
        },
        { once: !0, signal: this.abortController.signal },
      ),
      this.allowOutsideClickForTarget(t.target)
    );
  }),
  (_allowOutsideClickMouse = new WeakSet()),
  (allowOutsideClickMouse_fn = function (t) {
    if (t.type !== "click") return !1;
    if (
      (this.hideForOutsideClickTarget(t.target) && this.closeDialog(),
      this.allowOutsideClickForTarget(t.target))
    )
      return !0;
    let e = t.target,
      i = t.target.closest("[aria-controls]");
    return (
      i && i.getAttribute("aria-controls") === this.id && (e = i),
      this.id !== e.getAttribute("aria-controls")
    );
  }),
  customElements.define("hdt-dialog", DialogBase));
class wrappCloseBtn extends HTMLElement {
  constructor() {
    (super(),
      this.addEventListener("click", () =>
        this.dispatchEvent(
          new CustomEvent("dialog:forceClose", {
            bubbles: !0,
            cancelable: !0,
            composed: !0,
          }),
        ),
      ));
  }
}
customElements.define("wrapp-close-btn", wrappCloseBtn);
class cartOpenable extends DialogBase {
  animateOpen() {
    let t = this.selectorPartName("content"),
      e = this.selectorPartName("overlay");
    return timeline([
      [e, { opacity: [0, 1] }, { duration: 0.15 }],
      [
        t,
        { transform: ["translateY(100%)", "translateY(0)"] },
        { duration: 0.2, easing: "ease-in", at: "-0.075" },
      ],
    ]);
  }
  animateClose() {
    let t = this.selectorPartName("content"),
      e = this.selectorPartName("overlay");
    return timeline([
      [
        t,
        { transform: ["translateY(0)", "translateY(100%)"] },
        { duration: 0.2, easing: "ease-out" },
      ],
      [e, { opacity: [1, 0] }, { duration: 0.15, at: "-0.1" }],
    ]);
  }
}
customElements.define("hdt-cart-openable", cartOpenable);
import { computePosition, shift, flip, offset, arrow } from "vendor";
var updatePositionFloatingEl = function (
  t,
  e,
  i,
  n,
  s = !0,
  r = 16,
  a = "-8px",
) {
  (getterAdd(_init, this),
    getterAdd(_translateByDPR, this),
    getterAdd(_roundByDPR, this),
    getterRunFn(_init, this, init_fn).call(this, t, e, i, n, s, r, a));
};
((_dpr = new Map()),
  getterAdd(_dpr, _thu, window.devicePixelRatio || 1),
  (_roundByDPR = new WeakSet()),
  (_translateByDPR = new WeakSet()),
  (_init = new WeakSet()),
  (roundByDPR_fn = function (t) {
    return Math.round(t * getterGet(_dpr, _thu)) / getterGet(_dpr, _thu);
  }),
  (translateByDPR_fn = function (t, e) {
    return getterGet(_dpr, _thu) > 1
      ? `translate3d(${getterRunFn(_roundByDPR, this, roundByDPR_fn).call(
          this,
          t,
        )}px,${getterRunFn(_roundByDPR, this, roundByDPR_fn).call(
          this,
          e,
        )}px,0)`
      : `translate(${getterRunFn(_roundByDPR, this, roundByDPR_fn).call(
          this,
          t,
        )}px,${getterRunFn(_roundByDPR, this, roundByDPR_fn).call(this, e)}px)`;
  }),
  (init_fn = function (t, e, i, n, s, r, a) {
    computePosition(t, e, {
      placement: n,
      middleware: [
        offset(parseInt(r)),
        flip({ fallbackPlacements: ["top", "bottom"] }),
        shift({ padding: 0 }),
        arrow({ element: i }),
      ],
    }).then(({ x: t2, y: n2, placement: r2, middlewareData: o }) => {
      if (
        ((this.objStyle = s
          ? {
              top: "0",
              left: "0",
              transform: getterRunFn(
                _translateByDPR,
                this,
                translateByDPR_fn,
              ).call(this, t2, n2),
            }
          : { left: `${t2}px`, top: `${n2}px` }),
        Object.assign(e.style, this.objStyle),
        o.arrow && i)
      ) {
        const { x: t3, y: e2 } = o.arrow,
          n3 = { top: "bottom", right: "left", bottom: "top", left: "right" }[
            r2.split("-")[0]
          ];
        Object.assign(i.style, {
          left: t3 != null ? `${t3}px` : "",
          top: e2 != null ? `${e2}px` : "",
          right: "",
          bottom: "",
          [n3]: a,
        });
      }
    });
  }));
class Popover extends DialogBase {
  connectedCallback() {
    (super.connectedCallback(),
      this.allButton.forEach((t) => t.setAttribute("aria-haspopup", "dialog")),
      this.config.closeRichlistSelect &&
        this.addEventListener("richlist:select", this.closeDialog, {
          signal: this.abortController.signal,
        }));
  }
  get defaultTemplate() {
    return "hdt-tmp-popover";
  }
  get userConfig() {
    return Object.assign(
      { noScroll: "smart", appendToBody: "smart" },
      JSON.parse(this.getAttribute("config") || "{}"),
    );
  }
  get placement() {
    return this.getAttribute("placement") || "bottom";
  }
  get arrowEl() {
    return this.selectorPartName("arrow");
  }
  updatePos() {
    updatePositionFloatingEl.call(
      this,
      this.btnOpening,
      this,
      this.arrowEl,
      this.placement,
    );
  }
  animateOpen() {
    let t = this.selectorPartName("content"),
      e = this.selectorPartName("outside-close-button");
    return (
      (this.style.display = "block"),
      _matchMedia("phone")
        ? (Object.assign(this.style, {
            top: null,
            left: "0px",
            right: null,
            bottom: "0px",
            transform: null,
          }),
          timeline([
            [
              this,
              { opacity: [0, 1], visibility: ["hidden", "visible"] },
              { duration: 0.15 },
            ],
            [
              t,
              {
                clipPath: [
                  "inset(100% 0 0 0 round 8px)",
                  "inset(0 0 0 0 round 8px",
                ],
              },
              { duration: 0.4, easing: [0.86, 0, 0.07, 1] },
            ],
            [t.children, { opacity: [0, 1] }, { duration: 0.15 }],
            [e, { opacity: [0, 1] }, { at: "<", duration: 0.15 }],
          ]))
        : (this.updatePos(),
          timeline([
            [
              this,
              { opacity: [0, 1], visibility: ["hidden", "visible"] },
              { duration: 0.15 },
            ],
            [t, { clipPath: "none" }, { at: "<", duration: 0 }],
            [t.children, { opacity: 1 }, { at: "<", duration: 0 }],
          ]))
    );
  }
  animateClose() {
    if (_matchMedia("phone")) {
      let t = this.selectorPartName("content"),
        e = this.selectorPartName("outside-close-button");
      return timeline([
        [e, { opacity: [null, 0] }, { duration: 0.15 }],
        [t.children, { opacity: [null, 0] }, { at: "<", duration: 0.15 }],
        [
          t,
          { clipPath: [null, "inset(100% 0 0 0 round 8px)"] },
          { duration: 0.4, easing: [0.86, 0, 0.07, 1] },
        ],
        [
          this,
          { opacity: [null, 0], visibility: ["visible", "hidden"] },
          { duration: 0.15 },
        ],
      ]);
    }
    return timeline(
      this,
      {
        opacity: [null, 0],
        visibility: ["visible", "hidden"],
        transform: ["translateY(0)", "translateY(25%)"],
      },
      { duration: 0.15 },
    );
  }
}
customElements.define("hdt-popover", Popover);
var _find_title,
  find_title_fn,
  _tooltip_ids,
  _create_tooltip,
  create_tooltip_fn,
  _tooltip_thiss,
  _onOptionClicked,
  onOptionClicked_fn,
  _onKeyDown,
  onKeyDown_fn,
  _reveal,
  reveal_fn,
  _input,
  input_fn,
  dt_original_title = "data-original-title";
_tooltip_thiss = new WeakMap();
class btnTooltip extends HTMLElement {
  constructor() {
    (super(),
      getterAdd(_find_title, this),
      getterAdd(_create_tooltip, this),
      getterAdd(_tooltip_ids, this, getUID()));
  }
  connectedCallback() {
    _matchMedia("supports-hover") &&
      this.placement != "none" &&
      new HoverIntent(
        this,
        {
          onEnter: this.onEnter.bind(this),
          onExit: this.onExit.bind(this),
          exitDelay: 0,
          interval: 80,
          sensitivity: 6,
        },
        this,
      );
  }
  disconnectedCallback() {
    $id4(getterGet(_tooltip_ids, this))?.remove();
  }
  attributeChangedCallback(t, e, i) {
    e != i &&
      e !== null &&
      this.dispatchEvent(
        new CustomEvent("theme4:update:tooltip", {
          bubbles: !0,
          detail: "the4",
        }),
      );
  }
  onEnter = () => {
    if (this.innerText.length && this.hasAttribute("will-hidden-txt")) return;
    ((this.controller = new AbortController()),
      getterRunFn(_create_tooltip, this, create_tooltip_fn).call(
        this,
        getterGet(_tooltip_ids, this),
        getterRunFn(_find_title, this, find_title_fn).call(this),
      ));
    const t = $id4(getterGet(_tooltip_ids, this));
    (updatePositionFloatingEl.call(
      this,
      this,
      t,
      this.arrowEl,
      this.placement,
      !0,
      6,
      "-4px",
    ),
      this.addEventListener(
        "theme4:update:tooltip",
        (e) => {
          (($4(".hdt-tooltip__inner", t).textContent = getterRunFn(
            _find_title,
            this,
            find_title_fn,
          ).call(this)),
            updatePositionFloatingEl.call(
              this,
              this,
              t,
              this.arrowEl,
              this.placement,
              !0,
              6,
              "-4px",
            ));
        },
        { signal: this.controller.signal },
      ));
  };
  onExit = () => {
    const t = $id4(getterGet(_tooltip_ids, this));
    t && (this.controller.abort(), t.remove());
  };
  get placement() {
    return this.getAttribute("placement") || "bottom";
  }
  get arrowEl() {
    return $4(".hdt-tooltip__arrow", $id4(getterGet(_tooltip_ids, this)));
  }
}
((_tooltip_ids = new WeakMap()),
  (_find_title = new WeakSet()),
  (find_title_fn = function () {
    if (this.hasAttribute("data-txt-tt"))
      return this.getAttribute("data-txt-tt");
    const t = this.firstElementChild || this;
    let e = ($4("[tt-title]", this) || this.lastElementChild || this)
      .textContent;
    return (
      t.hasAttribute("aria-label")
        ? (e = t.getAttribute("aria-label"))
        : t.hasAttribute(dt_original_title)
          ? (e = t.getAttribute(dt_original_title))
          : t.hasAttribute("title") &&
            !t.hasAttribute(dt_original_title) &&
            ((e = t.getAttribute("title") || ""),
            t.setAttribute(dt_original_title, e),
            t.setAttribute("title", "")),
      this.hasAttribute("tt-dynamic") ||
        this.setAttribute("data-txt-tt", (e || "").trim()),
      e
    );
  }),
  (_create_tooltip = new WeakSet()),
  (create_tooltip_fn = function (t, e) {
    document.body.append(
      document
        .createRange()
        .createContextualFragment(
          `<hdt-tooltip-dialog id="${t}" class="hdt-tooltip" role="tooltip"><div class="hdt-tooltip__arrow"></div><div class="hdt-tooltip__inner">${e}</div></hdt-tooltip-dialog>`,
        ),
    );
  }));
class Tooltip extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    animate(
      this,
      { opacity: [0, 0.9], visibility: ["visible", "visible"] },
      { duration: 0.3, easing: "ease" },
    );
  }
}
(customElements.define("hdt-tooltip", btnTooltip),
  customElements.define("hdt-tooltip-dialog", Tooltip));
class Richlist extends HTMLElement {
  constructor() {
    (super(),
      collectableAdd(this, _onOptionClicked),
      collectableAdd(this, _onKeyDown),
      this.addEventListener(
        "keydown",
        fnCheck(this, _onKeyDown, onKeyDown_fn),
      ));
  }
  connectedCallback() {
    $$4('[role="option"]', this).forEach((t) => {
      t.addEventListener(
        "click",
        fnCheck(this, _onOptionClicked, onOptionClicked_fn).bind(this),
      );
    });
  }
  static get observedAttributes() {
    return ["selected"];
  }
  set selected(t) {
    this.setAttribute("selected", t);
  }
  attributeChangedCallback(t, e, i) {
    t === "selected" &&
      e !== null &&
      i !== e &&
      $$4('[role="option"]', this).forEach((t2) => {
        t2.value === i
          ? (t2.setAttribute("aria-selected", "true"),
            $$4(`[aria-owns="${this.id}"]`).forEach((e2) => {
              ($4("[change-text]", e2) || e2).textContent =
                t2.getAttribute("title") || t2.innerText || t2.value;
            }),
            t2.dispatchEvent(
              new CustomEvent("richlist:change", {
                bubbles: !0,
                detail: { value: t2.value },
              }),
            ))
          : t2.setAttribute("aria-selected", "false");
      });
  }
}
((_onOptionClicked = new WeakSet()),
  (onOptionClicked_fn = function (t) {
    const e = t.currentTarget.value;
    ((this.selected = e),
      t.currentTarget.dispatchEvent(
        new CustomEvent("richlist:select", {
          bubbles: !0,
          detail: { value: e },
        }),
      ));
  }),
  (_onKeyDown = new WeakSet()),
  (onKeyDown_fn = function (t) {
    t.key === "ArrowUp"
      ? (t.target.previousElementSibling?.focus(), t.preventDefault())
      : t.key === "ArrowDown" &&
        (t.target.nextElementSibling?.focus(), t.preventDefault());
  }),
  customElements.define("hdt-richlist", Richlist));
class Modal extends DialogBase {
  connectedCallback() {
    (super.connectedCallback(), this.setAttribute("aria-modal", "true"));
  }
  get effect() {
    return this.getAttribute("effect") || "fade";
  }
  get defaultTemplate() {
    return "hdt-tmp-modal";
  }
  animateOpen() {
    return _matchMedia("phone")
      ? timeline([
          [
            this.selectorPartName("overlay"),
            { opacity: [0, 1] },
            { duration: 0.3, easing: [0.645, 0.045, 0.355, 1] },
          ],
          [
            this.selectorPartName("content"),
            { transform: ["translateY(100%)", "translateY(0)"] },
            { duration: 0.3, easing: [0.645, 0.045, 0.355, 1], at: "<" },
          ],
        ])
      : this.effect == "fade"
        ? animate(this, { opacity: [0, 1] }, { duration: 0.2 })
        : timeline([
            [
              this.selectorPartName("overlay"),
              { opacity: [0, 1] },
              { duration: 0.2, easing: [0.645, 0.045, 0.355, 1] },
            ],
            [
              this.selectorPartName("content"),
              {
                transform: ["translateX(-200px)", "translateX(0)"],
                opacity: [0, 1],
              },
              { duration: 0.3, easing: [0.645, 0.045, 0.355, 1], at: "<" },
            ],
            [
              this.selectorPartName("close-button"),
              { opacity: [0, 1] },
              { duration: 0.2, easing: [0.645, 0.045, 0.355, 1] },
            ],
          ]);
  }
  animateClose() {
    return _matchMedia("phone")
      ? timeline([
          [
            this.selectorPartName("overlay"),
            { opacity: [1, 0] },
            { duration: 0.3, easing: [0.645, 0.045, 0.355, 1] },
          ],
          [
            this.selectorPartName("content"),
            { transform: ["translateY(0)", "translateY(100%)"] },
            { duration: 0.3, easing: [0.645, 0.045, 0.355, 1], at: "<" },
          ],
        ])
      : this.effect == "fade"
        ? animate(this, { opacity: [1, 0] }, { duration: 0.2 })
        : timeline([
            [
              this.selectorPartName("overlay"),
              { opacity: [1, 0] },
              { duration: 0.2, easing: [0.645, 0.045, 0.355, 1] },
            ],
            [
              this.selectorPartName("content"),
              {
                transform: ["translateX(0)", "translateX(200px)"],
                opacity: [1, 0],
              },
              { duration: 0.3, easing: [0.645, 0.045, 0.355, 1], at: "<" },
            ],
            [
              this.selectorPartName("close-button"),
              { opacity: [1, 0] },
              { duration: 0.2, easing: [0.645, 0.045, 0.355, 1] },
            ],
          ]);
  }
}
customElements.define("hdt-modal", Modal);
class Drawer extends Modal {
  get defaultTemplate() {
    return "hdt-tmp-drawer";
  }
  get effect() {
    let t = this.getAttribute("effect-lg");
    return !t || _matchMedia("phone") || _matchMedia("tablet")
      ? this.getAttribute("effect") || "left"
      : t;
  }
  get codeEffect() {
    switch (this.effect) {
      case "left":
        return [
          "translateX(calc(var(--value-logical-flip) * -100%))",
          "translateX(0)",
        ];
      case "right":
        return [
          "translateX(calc(var(--value-logical-flip) * 100%))",
          "translateX(0)",
        ];
      case "top":
        return ["translateY(-100%)", "translateY(0)"];
      default:
        return ["translateY(100%)", "translateY(0)"];
    }
  }
  animateOpen() {
    this.selectorPartName("content").style.marginInlineStart =
      this.effect === "right" ? "auto" : 0;
    const t = this.codeEffect;
    return timeline([
      [
        this.selectorPartName("overlay"),
        { opacity: [0, 1] },
        { duration: 0.3, easing: [0.645, 0.045, 0.355, 1] },
      ],
      [
        this.selectorPartName("footer"),
        { opacity: [0, 1] },
        { duration: 0.6, easing: [0.645, 0.045, 0.355, 1], at: "<" },
      ],
      [
        this.selectorPartName("content"),
        { transform: t },
        { duration: 0.3, at: "<", easing: "ease" },
      ],
      [
        this.selectorPartName("outside-close-button"),
        { opacity: [0, 1] },
        { duration: 0.2, at: "<", easing: [0.645, 0.045, 0.355, 1] },
      ],
    ]);
  }
  animateClose() {
    const t = this.codeEffect.reverse();
    return timeline([
      [
        this.selectorPartName("footer"),
        { opacity: [1, 0] },
        { duration: 0.6, easing: [0.645, 0.045, 0.355, 1] },
      ],
      [
        this.selectorPartName("content"),
        { transform: t },
        { duration: 0.3, at: "<", easing: "ease" },
      ],
      [
        this.selectorPartName("outside-close-button"),
        { opacity: [1, 0] },
        { duration: 0.2, at: "<", easing: [0.645, 0.045, 0.355, 1] },
      ],
      [
        this.selectorPartName("overlay"),
        { opacity: [1, 0] },
        { duration: 0.3, easing: [0.645, 0.045, 0.355, 1], at: "<" },
      ],
    ]);
  }
}
customElements.define("hdt-drawer", Drawer);
class BeforeAfter extends HTMLElement {
  constructor() {
    (super(), getterAdd(_reveal, this), getterAdd(_input, this));
  }
  connectedCallback() {
    ($4(".hdt-bf__range", this).addEventListener(
      "input",
      getterRunFn(_input, this, input_fn).bind(this),
    ),
      (this.beforeVal = $4(".hdt-bf__range", this).value),
      inView(this, getterRunFn(_reveal, this, reveal_fn).bind(this), {
        margin: "0px 0px -44% 0px",
      }));
  }
}
((_reveal = new WeakSet()),
  (reveal_fn = function (t) {
    animate(
      (t2) => {
        this.style.setProperty("--percent-val", this.beforeVal * t2);
      },
      { duration: 0.6, easing: [0.85, 0, 0.15, 1] },
    );
  }),
  (_input = new WeakSet()),
  (input_fn = function (t) {
    this.style.setProperty("--percent-val", t.target.value);
  }),
  customElements.define("hdt-before-after", BeforeAfter));
class Countdown extends HTMLElement {
  timezoneString = themeHDN.settings.shopTimezone
    ? ` GMT${themeHDN.settings.shopTimezone}`
    : "";
  constructor() {
    (super(),
      (this.selectors = {
        days: "[data-days]",
        hours: "[data-hours]",
        minutes: "[data-minutes]",
        seconds: "[data-seconds]",
      }),
      (this.classes = {
        enabled: "hdt-cd--enabled",
        hide: "hdt-cd--hide",
        complete: "hdt-cd--complete",
      }),
      (this.arrayMth = {
        1: "january",
        2: "february",
        3: "march",
        4: "april",
        5: "may",
        6: "june",
        7: "july",
        8: "august",
        9: "september",
        10: "october",
        11: "november",
        12: "december",
      }),
      (this.defaults = { idTmp: null, hasZero: !0, hideTimerOnComplete: !0 }),
      cancelAnimationFrame(this.myReq));
    const t = Object.assign(
      {},
      this.defaults,
      JSON.parse(this.getAttribute("config") || "{}"),
    );
    if (
      ((this.date = new Date(
        Date.parse(this.arrayMth[t.month] + " " + t.date + this.timezoneString),
      )),
      !isNaN(this.date))
    ) {
      if (
        ((this.hideTimerOnComplete = t.hideTimerOnComplete),
        (this.countDownTime = this.date.getTime()),
        t.idTmp)
      ) {
        const e = $id4(t.idTmp);
        e && (this.innerHTML = e.innerHTML);
      }
      ((this.daysEl = $4(this.selectors.days, this)),
        (this.hoursEl = $4(this.selectors.hours, this)),
        (this.minutesEl = $4(this.selectors.minutes, this)),
        (this.secondsEl = $4(this.selectors.seconds, this)),
        (this.hasZero = t.hasZero),
        (this.playing = !1),
        this.init(),
        inView(
          this,
          (t2) => (
            this.play(),
            (this.isInview = !0),
            (t3) => {
              (this.pause(), (this.isInview = !1));
            }
          ),
          { margin: "0px 0px 150px 0px" },
        ),
        visibilitychangeFn({
          observes: this,
          play: this.play.bind(this),
          pause: this.pause.bind(this),
        }));
    }
  }
  init() {
    this.playing ||
      (this.myReq || this.classList.add(this.classes.enabled), this.play());
  }
  timerLoop() {
    const t = new Date().getTime(),
      e = this.countDownTime - t,
      i = Math.floor(e / 864e5);
    let n = Math.floor((e % 864e5) / 36e5);
    const s = Math.floor((e % 36e5) / 6e4),
      r = Math.floor((e % 6e4) / 1e3);
    e < 0
      ? (this.destroy(),
        this.classList.add(this.classes.complete),
        this.hideTimerOnComplete && this.classList.add(this.classes.hide))
      : (this.daysEl || (n += 24 * i),
        this.daysEl?.updateValue(i, this.hasZero),
        this.hoursEl?.updateValue(n, this.hasZero),
        this.minutesEl?.updateValue(s, this.hasZero),
        this.secondsEl?.updateValue(r, this.hasZero),
        (this.myReq = requestAnimationFrame(this.timerLoop.bind(this))));
  }
  play() {
    this.playing ||
      ((this.myReq = requestAnimationFrame(this.timerLoop.bind(this))),
      (this.playing = !0));
  }
  pause() {
    this.playing && (cancelAnimationFrame(this.myReq), (this.playing = !1));
  }
  destroy() {
    (this.pause(), this.classList.remove(this.classes.enabled));
  }
}
class CountdownAmount extends HTMLElement {
  constructor() {
    (super(), this.attachShadow({ mode: "open" }));
    let t = [...this.textContent].map(
      () =>
        `<hdt-countdown-number part="number" effect="${this.getAttribute(
          "effect",
        )}" style="display: inline-block">0</hdt-countdown-number>`,
    );
    this.shadowRoot.appendChild(
      document.createRange().createContextualFragment(t.join("")),
    );
  }
  updateValue(t, e) {
    let i = Math.min(99, t).toString().padStart(2, "0");
    if (
      ((this.textContent = i),
      [...i].forEach((t2, e2) => {
        this.shadowRoot.children[e2].setAttribute("number", t2);
      }),
      this.nextElementSibling && this.nextElementSibling.shadowRoot)
    ) {
      let t2 = 0;
      for (; t2 < 2; t2++)
        this.nextElementSibling.shadowRoot.children[t2].setAttribute(
          "amount",
          i,
        );
    }
    e ||
      (this.shadowRoot.children[0].style.display =
        i < 10 ? "none" : "inline-block");
  }
}
class CountdownAmountNumber extends HTMLElement {
  static observedAttributes = ["number"];
  constructor() {
    switch (
      (super(),
      (this.e = { Y: 0, S: 1, R: 0 }),
      (this.runFrist = 0),
      this.getAttribute("effect"))
    ) {
      case "move_top":
        ((this.e.Y = -8), (this.e.Y2 = 8));
        break;
      case "move_bottom":
        ((this.e.Y = 6), (this.e.Y2 = -6));
        break;
      case "scale":
        this.e.S = 0.5;
        break;
      case "rotate":
        ((this.e.R = 180), (this.e.S = 0.68));
    }
    this.attachShadow({ mode: "open" }).appendChild(
      document
        .createRange()
        .createContextualFragment("<div><slot></slot></div>"),
    );
  }
  async attributeChangedCallback(t, e, i) {
    if (
      (++this.runFrist,
      this.getAttribute("effect") == "none" || this.runFrist == 2)
    )
      return (this.textContent = i);
    e !== null &&
      e !== i &&
      (await animate(
        this.shadowRoot.firstElementChild,
        {
          opacity: [1, 0],
          transform: [
            "translateY(0) rotate(0deg) scale(1)",
            `translateY(${this.e.Y}px) rotate(${this.e.R}deg) scale(${this.e.S})`,
          ],
        },
        { duration: 0.25, easing: [0.64, 0, 0.78, 0] },
      ).finished,
      (this.textContent = i),
      animate(
        this.shadowRoot.firstElementChild,
        {
          opacity: [0, 1],
          transform: [
            `translateY(${this.e.Y2 || this.e.Y}px) rotate(${
              this.e.R
            }deg) scale(${this.e.S})`,
            "translateY(0) rotate(0deg) scale(1)",
          ],
        },
        { duration: 0.25, delay: 0.1, easing: [0.22, 1, 0.36, 1] },
      ));
  }
}
class CountdownText extends HTMLElement {
  static observedAttributes = ["amount"];
  constructor() {
    if ((super(), !this.hasAttribute("singular"))) return;
    this.attachShadow({ mode: "open" });
    let t = 0,
      e = "";
    for (; t < 2; t++)
      e += `<hdt-countdown-unit ${
        t ? "singular" : "plural"
      } part="unit" style="grid-area: 1 / -1; will-change: opacity; opacity: ${
        t ? 0 : 1
      };">${
        t ? this.getAttribute("singular") : this.textContent
      }</hdt-countdown-unit>`;
    this.shadowRoot.appendChild(
      document.createRange().createContextualFragment(e),
    );
  }
}
class CountdownUnit extends HTMLElement {
  static observedAttributes = ["amount"];
  constructor() {
    super();
  }
  async attributeChangedCallback(t, e, i) {
    e !== i &&
      (this.style.opacity = this.hasAttribute("plural")
        ? i == 1
          ? 0
          : 1
        : i == 1
          ? 1
          : 0);
  }
}
(customElements.define("hdt-countdown", Countdown),
  customElements.define("hdt-countdown-amount", CountdownAmount),
  customElements.define("hdt-countdown-number", CountdownAmountNumber),
  customElements.define("hdt-countdown-text", CountdownText),
  customElements.define("hdt-countdown-unit", CountdownUnit));
var on_keydown_fn,
  _wrapper,
  _details = new WeakMap(),
  _summary = new WeakMap(),
  _content = new WeakMap(),
  _on_keydown = new WeakSet();
class Accordion extends HTMLElement {
  #t;
  constructor() {
    (super(),
      getterAdd(_details, this, $4("details", this)),
      getterAdd(_summary, this, $4("summary", this)),
      getterAdd(
        _content,
        this,
        getterGet(_summary, this)
          ? getterGet(_summary, this).nextElementSibling
          : null,
      ),
      getterAdd(_on_keydown, this));
  }
  connectedCallback() {
    const summary = getterGet(_summary, this);
    const details = getterGet(_details, this);
    if (!summary || !details) return;

    ((this.#t = new AbortController()),
      summary.addEventListener("click", this._onSummaryClicked.bind(this), {
        signal: this.#t.signal,
      }),
      summary.addEventListener("pick", this._onSummaryClicked.bind(this), {
        signal: this.#t.signal,
      }),
      details.addEventListener(
        "keydown",
        getterRunFn(_on_keydown, this, on_keydown_fn).bind(this),
        { signal: this.#t.signal },
      ),
      Shopify.designMode &&
        (this.addEventListener(adnmEvts.select, () => this.toggle(), {
          signal: this.#t.signal,
        }),
        this.addEventListener(adnmEvts.deselect, () => this.toggle(!1), {
          signal: this.#t.signal,
        })));
  }
  disconnectedCallback() {
    this.#t.abort();
  }
  get open() {
    const details = getterGet(_details, this);
    return details ? details.hasAttribute("open") : false;
  }
  toggle(t = !0) {
    const summary = getterGet(_summary, this);
    if (!summary) return;
    ((t && !this.open) || (!t && this.open)) &&
      summary.dispatchEvent(
        new CustomEvent("pick", { detail: { offClick: !0 } }),
      );
  }
  _onSummaryClicked(t) {
    if (
      (t.preventDefault(),
      !t?.detail?.offClick &&
        getterGet(_summary, this).hasAttribute("data-url") &&
        this.hasAttribute("only-click-icon") &&
        !t.target.hasAttribute("accordion-icon"))
    )
      return (window.location.href = getterGet(_summary, this).getAttribute(
        "data-url",
      ));
    ((getterGet(_details, this).style.overflow = "hidden"),
      getterGet(_summary, this).setAttribute("aria-expanded", `${!this.open}`),
      this.open
        ? (() => {
            const details = getterGet(_details, this);
            const summary = getterGet(_summary, this);
            const content = getterGet(_content, this);
            const startHeight = details.offsetHeight;
            // Calculate closed height by temporarily closing
            details.removeAttribute("open");
            const endHeight = details.offsetHeight;
            details.setAttribute("open", "");
            return timeline([
              [content, { opacity: 0 }, { duration: 0.15 }],
              [
                details,
                { height: [`${startHeight}px`, `${endHeight}px`] },
                { duration: 0.25, at: "<", easing: "ease" },
              ],
            ]).finished.then(() => {
              (details.removeAttribute("open"),
                (details.style.height = null),
                (details.style.overflow = null));
            });
          })()
        : (getterGet(_details, this).setAttribute("open", ""),
          timeline([
            [
              getterGet(_details, this),
              {
                height: [
                  `${getterGet(_summary, this).clientHeight}px`,
                  `${getterGet(_details, this).scrollHeight}px`,
                ],
              },
              { duration: 0.25, easing: "ease" },
            ],
            [
              getterGet(_content, this),
              {
                opacity: [0, 1],
                transform: ["translateY(4px)", "translateY(0)"],
              },
              { duration: 0.15, at: "-0.1" },
            ],
          ]).finished.then(() => {
            ((getterGet(_details, this).style.height = null),
              (getterGet(_details, this).style.overflow = null));
          })));
  }
}
((on_keydown_fn = function (t) {
  t.key == "Enter" &&
    t.target?.hasAttribute("accordion-icon") &&
    (t.preventDefault(), t.stopPropagation(), t.target.click());
}),
  customElements.define("hdt-accordion", Accordion));
class Tab extends HTMLElement {
  #t;
  connectedCallback() {
    this.idControls &&
      ((this.buttons = $$4("button", this)),
      (this.items = $$4("[tab-item]", this.idControls)),
      (this.#t = new AbortController()),
      (this.oldIndex = 0),
      this.buttons.forEach((t) =>
        t.addEventListener(
          "click",
          () => this._onButtonClicked(t, this.buttons.indexOf(t)),
          {
            signal: this.#t.signal,
          },
        ),
      ),
      Shopify.designMode &&
        this.addEventListener(adnmEvts.select, (t) => t.target.click()));
  }
  disconnectedCallback() {
    this.#t.abort();
  }
  get idControls() {
    return $id4(this.getAttribute("aria-controls"));
  }
  animateHide() {
    return animate(
      this.items[this.oldIndex],
      { opacity: [1, 0], transform: ["translateY(0px)", "translateY(19px)"] },
      { duration: 0.3, easing: "ease-in" },
    );
  }
  animateShow(t) {
    return animate(
      this.items[t],
      { opacity: [0, 1], transform: ["translateY(19px)", "translateY(0px)"] },
      { duration: 0.2, delay: 0.2, easing: "ease-out" },
    );
  }
  _onButtonClicked(t, e) {
    t.getAttribute("aria-current") !== "true" &&
      (this.buttons.forEach((t2) => {
        t2.setAttribute("aria-current", "false");
      }),
      this.buttons[e].setAttribute("aria-current", "true"),
      this.animateHide().finished.then(() => {
        (this.items[this.oldIndex].removeAttribute("tab-selected"),
          (this.oldIndex = e),
          this.items[e].setAttribute("tab-selected", ""),
          this.animateShow(e));
      }));
  }
}
customElements.define("hdt-tab", Tab);
class Marquee extends HTMLElement {
  constructor() {
    (super(),
      (this.classes = {
        enabled: "hdt-marquee--enabled",
        duplicate: "hdt-marquee--duplicate",
      }),
      (this.oldWidth = 0),
      this.attachShadow({ mode: "open" }).appendChild(
        document
          .createRange()
          .createContextualFragment("<slot part='wrapper'></slot>"),
      ),
      this.init(),
      new ResizeObserver((t) => this.init()).observe(this),
      _matchMedia("motion") &&
        (inView(
          this,
          (t) => (
            this.animation.play(),
            (this.isInview = !0),
            (t2) => {
              (this.animation.pause(), (this.isInview = !1));
            }
          ),
          { margin: "250px" },
        ),
        visibilitychangeFn({
          observes: this,
          play: this.animation.play,
          pause: this.animation.pause,
        })));
  }
  get wrapper() {
    return getterGet(
      _wrapper,
      this,
      this.shadowRoot.querySelector('[part="wrapper"]'),
    );
  }
  init() {
    this.clientWidth < this.oldWidth ||
      ((this.oldWidth = this.clientWidth),
      this.prepareContent(),
      this.calculateWidthRatio());
  }
  prepareContent() {
    this.classList.remove(this.classes.enabled);
    var t = $$4("." + this.classes.duplicate, this);
    t.length && t.forEach((t2) => t2.remove());
  }
  calculateWidthRatio() {
    let t,
      e,
      i = Math.ceil(this.clientWidth / this.firstElementChild.offsetWidth) + 1;
    const n = document.createDocumentFragment();
    for (e = 0; e < i; e++)
      ((t = this.firstElementChild.cloneNode(!0)),
        t.setAttribute("aria-hidden", !0),
        t.classList.add(this.classes.duplicate),
        t.style.setProperty("--index", e + 1),
        n.appendChild(t));
    (this.append(n),
      this.classList.add(this.classes.enabled),
      _matchMedia("motion") &&
        ((this.animation = animate(
          this.wrapper,
          {
            transform: [
              "translateX(0)",
              "translateX(calc(var(--value-logical-flip) * var(--dir-logical) * 100%))",
            ],
          },
          {
            duration:
              (1 / parseFloat(this.getAttribute("speed"))) *
              (this.wrapper.clientWidth / 350),
            easing: "linear",
            repeat: 1 / 0,
          },
        )),
        this.hasAttribute("pause-on-pointer-enter") &&
          (this.addEventListener("mouseenter", this.onmouseenter),
          this.addEventListener("touchstart", this.onmouseenter))));
  }
  onmouseenter() {
    (this.animation.pause(),
      this.addEventListener("mouseleave", this.onmouseleave),
      this.addEventListener("touchend", this.onmouseleave));
  }
  onmouseleave() {
    (this.animation.play(),
      this.removeEventListener("mouseleave", this.onmouseleave),
      this.removeEventListener("touchend", this.onmouseleave));
  }
  disconnectedCallback() {
    (getterDelete(_wrapper, this),
      this.removeEventListener("mouseenter", this.onmouseenter),
      this.removeEventListener("touchstart", this.onmouseenter));
  }
}
((_wrapper = new WeakMap()), customElements.define("hdt-marquee", Marquee));
var _effect,
  effect_fn,
  _resizeObserver,
  resizeObserver_fn,
  _img_effect = new WeakMap();
class ImageEffect extends HTMLElement {
  constructor() {
    (super(),
      getterAdd(_effect, this),
      getterAdd(_img_effect, this, $4("picture img, img", this)));
  }
  connectedCallback() {
    _matchMedia("motion") &&
      getterGet(_img_effect, this) &&
      getterRunFn(_effect, this, effect_fn).call(this);
  }
}
((_effect = new WeakSet()),
  (effect_fn = function () {
    const t = this.getAttribute("eff");
    if (t === "ambient")
      animate(
        getterGet(_img_effect, this),
        {
          transform: [
            "rotate(0deg) translateX(1em) rotate(0deg) scale(1.2)",
            "rotate(360deg) translateX(1em) rotate(-360deg) scale(1.2)",
          ],
        },
        { duration: 30, easing: "linear", repeat: 1 / 0 },
      );
    else if (t === "parallax") {
      const t2 = parseFloat(
          this.style.getPropertyValue("--parallax-scale") || 1.3,
        ),
        [e, i] = [t2, 15 / t2],
        n = this.closest(".hdt-section").matches(":first-child");
      scroll(
        animate(
          getterGet(_img_effect, this),
          {
            transform: [
              `scale(${e}) translateY(-${i}%)`,
              `scale(${e}) translateY(${i}%)`,
            ],
          },
          { easing: "linear" },
        ),
        {
          target: getterGet(_img_effect, this),
          offset: [n ? "start start" : "start end", "end start"],
        },
      );
    }
  }),
  customElements.define("hdt-effect-img", ImageEffect));
class HeightObserver extends HTMLElement {
  constructor() {
    (super(),
      getterAdd(_resizeObserver, this),
      window.ResizeObserver &&
        new ResizeObserver(
          throttle(
            getterRunFn(_resizeObserver, this, resizeObserver_fn).bind(this),
          ),
        ).observe(this));
  }
  connectedCallback() {
    window.ResizeObserver ||
      html.style.setProperty(
        `--${this.getAttribute("prefix")}-height`,
        `${Math.round(this.clientHeight)}px`,
      );
  }
}
((_resizeObserver = new WeakSet()),
  (resizeObserver_fn = function (t) {
    t.forEach((t2) => {
      if (t2.target === this) {
        const e = t2.borderBoxSize
          ? t2.borderBoxSize.length > 0
            ? t2.borderBoxSize[0].blockSize
            : t2.borderBoxSize.blockSize
          : t2.target.clientHeight;
        html.style.setProperty(
          `--${this.getAttribute("prefix")}-height`,
          `${Math.round(e)}px`,
        );
      }
    });
  }),
  customElements.define("hdt-height-observer", HeightObserver));
class StickyHeader extends HeightObserver {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.checkTransparent(),
      super.connectedCallback(),
      (this.stickyType = this.getAttribute("sticky-type")),
      this.stickyType !== "none" &&
        ((this.header = this.closest(".hdt-section-header")),
        (this.headerIsAlwaysSticky = this.stickyType === "always"),
        (this.headerBounds = {}),
        this.headerIsAlwaysSticky &&
          this.header.classList.add("shopify-section-header-sticky"),
        (this.currentScrollTop = 0),
        (this.preventReveal = !1),
        (this.predictiveSearch = $4("predictive-search", this)),
        (this.onScrollHandler = this.onScroll.bind(this)),
        (this.hideHeaderOnScrollUp = () => (this.preventReveal = !0)),
        this.addEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp),
        window.addEventListener("scroll", this.onScrollHandler, !1),
        this.createObserver()));
  }
  disconnectedCallback() {
    (this.removeEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp),
      window.removeEventListener("scroll", this.onScrollHandler));
  }
  createObserver() {
    new IntersectionObserver((t, e) => {
      ((this.headerBounds = t[0].intersectionRect), e.disconnect());
    }).observe(this.header);
  }
onScroll() {
  const t = window.scrollY || html.scrollTop;
  const tabsHeads = document.querySelectorAll(
    '[data-tab-source="header-templates-carousel"] .hdt-tabs-head-v2, [data-tab-source="templates-carousel"] .hdt-tabs-head-v2',
  );
  const setTabsSticky = (isSticky) => {
    tabsHeads.forEach((tabsHead) => {
       if (
        window.matchMedia("(min-width: 768px)").matches &&
        tabsHead.closest('[data-tab-source="header-templates-carousel"]') &&
        !tabsHead.classList.contains("hdt-tabs-template-head-v2")
      ) {
        return;
      }
      tabsHead.classList.toggle("sticky", isSticky);
    });
  };

  if (!this.predictiveSearch || !this.predictiveSearch.isOpen) {

    if (t > this.currentScrollTop && t > this.headerBounds.bottom) {

      this.header.classList.add("scrolled-past-header");
      setTabsSticky(true);

      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));

    } else if (t < this.currentScrollTop && t > this.headerBounds.bottom) {

      this.header.classList.add("scrolled-past-header");
      setTabsSticky(true);

      if (this.preventReveal) {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      } else {
        requestAnimationFrame(this.reveal.bind(this));
      }

    } else if (t <= this.headerBounds.top) {

      this.header.classList.remove("scrolled-past-header");
      setTabsSticky(false);

      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = t;
  }
}
  hide() {
    this.headerIsAlwaysSticky ||
      (this.header.classList.add(
        "shopify-section-header-hidden",
        "shopify-section-header-sticky",
      ),
      this.closeMenuDisclosure());
  }
  reveal() {
    this.headerIsAlwaysSticky ||
      (this.header.classList.add("shopify-section-header-sticky", "animate"),
      this.header.classList.remove("shopify-section-header-hidden"));
  }
  reset() {
    this.headerIsAlwaysSticky ||
      this.header.classList.remove(
        "shopify-section-header-hidden",
        "shopify-section-header-sticky",
        "animate",
      );
  }
  closeMenuDisclosure() {
    $$4("hdt-header-menu > details[open]", this.header).forEach((t) =>
      t.parentElement.toggle(!1),
    );
  }
  checkTransparent() {
    $4(".section-allow-transparent.hdt-section:first-child") &&
      !$4(".hdt-section-header + .shopify-section-group-header-group") &&
      html.setAttribute("enabled-transparent-header", "");
  }
}
customElements.define("hdt-sticky-header", StickyHeader);
function initAnnouncementBarVisibility() {
  const bar =
    document.getElementById("hdt-announcement-main") ||
    document.querySelector(".hdt-announcement-bar-section");
  if (!bar) return;
  const target =
    bar.id === "hdt-announcement-main"
      ? bar.closest(".hdt-announcement-bar-section") || bar
      : bar;
  new IntersectionObserver(
    ([entry]) => {
      html.classList.toggle("announcement-in-view", entry.isIntersecting);
    },
    { threshold: 0 },
  ).observe(target);
}
document.readyState === "loading"
  ? document.addEventListener(
      "DOMContentLoaded",
      initAnnouncementBarVisibility,
    )
  : initAnnouncementBarVisibility();
var _event,
  _position,
  _isCenterOnScreen,
  _x,
  _needCalc,
  _clickOutside,
  clickOutside_fn,
  _escape,
  escape_fn,
  _click_outside_handler = new WeakMap(),
  _escape_handler = new WeakMap();
class MegaMenu extends Accordion {
  constructor() {
    (super(),
      _matchMedia("phone") ||
        (this.event === "hover" &&
          new HoverIntent(
            getterGet(_details, this),
            {
              onEnter: (t) => {
                (getterGet(_summary, this).classList.add("is_action-hover"),
                  this.toggle());
              },
              onExit: (t) => {
                (getterGet(_summary, this).classList.remove("is_action-hover"),
                  this.toggle(!1));
              },
              exitDelay: 150,
              interval: 35,
              sensitivity: 3,
            },
            getterGet(_summary, this),
          ),
        getterAdd(_clickOutside, this),
        getterAdd(_escape, this),
        getterAdd(
          _escape_handler,
          this,
          getterRunFn(_escape, this, escape_fn).bind(this),
        ),
        getterAdd(
          _click_outside_handler,
          this,
          getterRunFn(_clickOutside, this, clickOutside_fn).bind(this),
        )));
  }
  get expanded() {
    return getterGet(_summary, this).getAttribute("aria-expanded") === "true";
  }
  get event() {
    return getterGet(
      _event,
      this,
      _matchMedia("supports-hover") ? this.getAttribute("event") : "click",
    );
  }
  get position() {
    return getterGet(
      _position,
      this,
      this.getAttribute("position") || "bottom",
    );
  }
  get isCenterOnScreen() {
    return getterGet(
      _isCenterOnScreen,
      this,
      this.position === "center_on_screen",
    );
  }
  get needCalc() {
    return getterGet(
      _needCalc,
      this,
      !getterGet(_details, this).hasAttribute("not-need-calc"),
    );
  }
  get x() {
    return getterGet(_x, this, this.isCenterOnScreen ? "-50%" : "0");
  }
  _onSummaryClicked(t) {
    if (
      !t?.detail?.offClick &&
      getterGet(_summary, this).hasAttribute("data-url") &&
      (this.event === "hover" ||
        (this.expanded && this.hasAttribute("opened-able-click")))
    )
      return (window.location.href = getterGet(_summary, this).getAttribute(
        "data-url",
      ));
    (t.preventDefault(),
      getterGet(_summary, this).setAttribute("aria-expanded", `${!this.open}`),
      this.open
        ? (document.removeEventListener(
            "click",
            getterGet(_click_outside_handler, this),
          ),
          document.removeEventListener(
            "keydown",
            getterGet(_escape_handler, this),
          ),
          timeline([
            [
              getterGet(_content, this),
              {
                opacity: [1, 0],
                visibility: ["visible", "hidden"],
                transform: [
                  `translateX(${this.x}) translateY(0)`,
                  `translateX(${this.x}) translateY(15px)`,
                ],
              },
              { duration: 0.4, easing: [0.19, 1, 0.22, 1] },
            ],
          ]).finished.then(() => {
            getterGet(_details, this).removeAttribute("open");
          }))
        : (document.addEventListener(
            "click",
            getterGet(_click_outside_handler, this),
          ),
          document.addEventListener(
            "keydown",
            getterGet(_escape_handler, this),
          ),
          getterGet(_details, this).setAttribute("open", ""),
          this.needCalc &&
            !this.isCenterOnScreen &&
            updatePositionFloatingEl.call(
              this,
              getterGet(_summary, this),
              getterGet(_content, this),
              null,
              this.position,
              !1,
            ),
          timeline([
            [
              getterGet(_content, this),
              {
                opacity: [0, 1],
                visibility: ["hidden", "visible"],
                transform: [
                  `translateX(${this.x}) translateY(15px)`,
                  `translateX(${this.x}) translateY(0)`,
                ],
              },
              { duration: 0.4, easing: [0.19, 1, 0.22, 1] },
            ],
          ]).finished.then(() => {})));
  }
}
((_event = new WeakMap()),
  (_position = new WeakMap()),
  (_isCenterOnScreen = new WeakMap()),
  (_x = new WeakMap()),
  (_needCalc = new WeakMap()),
  (_clickOutside = new WeakSet()),
  (_escape = new WeakSet()),
  (clickOutside_fn = function (t) {
    this.event === "click" && (this.contains(t.target) || this.toggle(!1));
  }),
  (escape_fn = function (t) {
    t.code === "Escape" &&
      t.target.closest("details[open]") &&
      (this.toggle(!1), t.stopPropagation());
  }),
  customElements.define("hdt-header-menu", MegaMenu));
var _color_limit,
  color_limit_fn,
  _color_item_first,
  _color_item_last,
  _color_resizeObserver,
  color_resizeObserver_fn,
  _width_color_list,
  _click_color_viewmore,
  click_color_viewmore_fn,
  _color_slider,
  _delegate2,
  _even_color,
  _color_changed_data,
  color_changed_data_fn,
  _color_products,
  _color_product_urls,
  _color_product_url_first,
  _color_on_hovered,
  color_on_hovered_fn,
  _create_img,
  create_img_fn,
  _color_vimgs,
  isColorLimit = "is--color-limit",
  _color_fieldset = new WeakMap();
class ColorList extends HTMLElement {
  constructor() {
    (super(),
      getterAdd(_delegate2, this, new Delegate(this)),
      getterAdd(_color_changed_data, this),
      getterAdd(_color_on_hovered, this),
      getterAdd(_create_img, this),
      getterAdd(_color_products, this, this.closest(".hdt-card-product")),
      getterAdd(
        _color_product_urls,
        this,
        $$4("[data-pr-url]", getterGet(_color_products, this)),
      ),
      getterAdd(_color_fieldset, this, $4("fieldset", this)));
  }
  connectedCallback() {
    if (
      ($$4('[type="radio"]:not([disabled])', this).length > 0 &&
        (getterGet(_delegate2, this).on(
          "change",
          '[type="radio"]',
          getterRunFn(_color_changed_data, this, color_changed_data_fn).bind(
            this,
          ),
        ),
        getterGet(_delegate2, this).on(
          "pointerover",
          '[type="radio"][data-vimg] + label',
          getterRunFn(_color_on_hovered, this, color_on_hovered_fn).bind(this),
          !0,
        ),
        _matchMedia("phone") ||
          this.event != "hover" ||
          $$4('[type="radio"] + label', this).forEach((t) => {
            new HoverIntent(t, {
              onEnter: (t2) => t2.click(),
              onExit: (t2) => {},
              exitDelay: 100,
              interval: 100,
              sensitivity: 6,
            });
          })),
      getterGet(_color_fieldset, this).childElementCount > 2)
    ) {
      if (
        (getterAdd(_width_color_list, this, 0),
        getterAdd(
          _color_item_first,
          this,
          getterGet(_color_fieldset, this).firstChild,
        ),
        getterAdd(
          _color_item_last,
          this,
          getterGet(_color_fieldset, this).lastChild,
        ),
        getterAdd(_color_resizeObserver, this),
        getterAdd(_color_slider, this, this.closest(".hdt-slider__products")),
        this.hasAttribute("auto-limit"))
      )
        if ((getterAdd(_color_limit, this), window.ResizeObserver)) {
          let t = new ResizeObserver(
            throttle(
              getterRunFn(
                _color_resizeObserver,
                this,
                color_resizeObserver_fn,
              ).bind(this),
            ),
          );
          (t.observe(this),
            this.addEventListener("unobserve", () => {
              (t.unobserve(this), (t = null));
            }));
        } else getterRunFn(_color_limit, this, color_limit_fn).call(this);
      if (
        this.hasAttribute("action-all") &&
        (getterAdd(_click_color_viewmore, this),
        getterGet(_color_item_last, this).addEventListener(
          "click",
          getterRunFn(
            _click_color_viewmore,
            this,
            click_color_viewmore_fn,
          ).bind(this),
        ),
        window.ResizeObserver && !this.hasAttribute("auto-limit"))
      ) {
        let t = new ResizeObserver(
          throttle(
            getterRunFn(
              _color_resizeObserver,
              this,
              color_resizeObserver_fn,
            ).bind(this),
          ),
        );
        (t.observe(this),
          this.addEventListener("unobserve2", () => {
            (t.unobserve(this), (t = null));
          }));
      }
    }
  }
  disconnectedCallback() {
    getterGet(_delegate2, this).off();
  }
  get event() {
    return getterGet(
      _even_color,
      this,
      _matchMedia("supports-hover") ? this.getAttribute("event") : "click",
    );
  }
}
((_color_limit = new WeakSet()),
  (_color_item_first = new WeakMap()),
  (_color_item_last = new WeakMap()),
  (_color_resizeObserver = new WeakSet()),
  (_click_color_viewmore = new WeakSet()),
  (_width_color_list = new WeakMap()),
  (_color_slider = new WeakMap()),
  (_delegate2 = new WeakMap()),
  (_even_color = new WeakMap()),
  (_color_changed_data = new WeakSet()),
  (_color_products = new WeakMap()),
  (_color_product_urls = new WeakMap()),
  (_color_product_url_first = new WeakMap()),
  (_color_vimgs = new WeakMap()),
  (color_limit_fn = function () {
    const t = getterGet(_color_item_first, this).getBoundingClientRect().width,
      e = getterGet(_color_item_last, this).getBoundingClientRect().width,
      i = getComputedStyle(getterGet(_color_fieldset, this)),
      n = parseFloat(i.gap || i.columnGap || 10),
      s = getterGet(_color_fieldset, this).childElementCount - 1,
      r = t * s + (s - 1) * n,
      { width: a } = getterGet(_color_fieldset, this).getBoundingClientRect(),
      o = Math.floor(a / (t + n)),
      l = Math.floor((a - e) / (t + n));
    o >= s || r <= getterGet(_width_color_list, this)
      ? (getterGet(_color_item_last, this).setAttribute("hidden", ""),
        $4("." + isColorLimit, this)?.classList.remove(isColorLimit))
      : (getterGet(_color_fieldset, this).childNodes[l]?.classList.add(
          isColorLimit,
        ),
        $4("." + isColorLimit, this)?.classList.remove(isColorLimit),
        (getterGet(_color_item_last, this).lastElementChild.textContent =
          "+" + (s - l)),
        (getterGet(_color_item_last, this).style.opacity = 1));
  }),
  (color_resizeObserver_fn = function (t) {
    (getterGet(_color_slider, this) &&
      getterGet(_slider_api, getterGet(_color_slider, this)).reInit(),
      getterGet(_width_color_list, this) != t[0].contentRect.width &&
        (getterAdd(_width_color_list, this, t[0].contentRect.width, !0),
        this.hasAttribute("auto-limit")
          ? ($4("." + isColorLimit, this)?.classList.remove(isColorLimit),
            getterGet(_color_fieldset, this).childNodes[1]?.classList.add(
              isColorLimit,
            ),
            getterGet(_color_item_last, this).removeAttribute("hidden"),
            (getterGet(_color_item_last, this).style.opacity = 0),
            getterRunFn(_color_limit, this, color_limit_fn).call(this))
          : (getterGet(_color_fieldset, this).childNodes[
              parseInt(this.getAttribute("maximum"))
            ]?.classList.add(isColorLimit),
            getterGet(_color_item_last, this).removeAttribute("hidden"))));
  }),
  (click_color_viewmore_fn = function (t) {
    (t.preventDefault(),
      this.dispatchEvent(
        new CustomEvent("unobserve", { cancelable: !0, composed: !0 }),
      ),
      this.dispatchEvent(
        new CustomEvent("unobserve2", { cancelable: !0, composed: !0 }),
      ));
    const e = $4("." + isColorLimit, this);
    (e?.classList.remove(isColorLimit),
      getterGet(_color_item_last, this).setAttribute("hidden", ""),
      (this.style.minHeight = this.clientHeight + "px"),
      animate(
        getterGet(_color_fieldset, this).children,
        {
          opacity: [0, 1],
          transform: ["scale(.5) translateY(10px)", "scale(1) translateY(0)"],
        },
        {
          duration: 0.35,
          delay: stagger(0.05, { easing: "ease-out" }),
          easing: "ease",
        },
      ).finished.then(() => {
        ((this.style.minHeight = null),
          getterGet(_color_slider, this) &&
            getterGet(_slider_api, getterGet(_color_slider, this)).reInit());
      }),
      e?.previousElementSibling.querySelector("input")?.focus());
  }),
  (color_changed_data_fn = function (t, e) {
    if (getterGet(_color_product_urls, this).length) {
      const t2 = UrlWithVariant.get(
        getterGet(
          _color_product_url_first,
          this,
          getterGet(_color_product_urls, this)[0].href,
        ),
        e.dataset.vid,
      );
      getterGet(_color_product_urls, this).forEach((e2) => {
        e2.href = t2;
      });
    }
    const i = getterGet(_color_vimgs, e, e.getAttribute("data-vimg"));
    if (i) {
      const t2 = getterGet(_color_products, this).querySelector(
        ".hdt-card-product__media--main",
      );
      if (i === t2.getAttribute("src")) return;
      (t2.parentElement.removeAttribute("loaded"),
        t2.parentElement.setAttribute("loading", ""),
        t2.replaceWith(
          getterRunFn(_create_img, this, create_img_fn).call(this, i, t2),
        ));
    }
  }),
  (_color_on_hovered = new WeakSet()),
  (color_on_hovered_fn = function (t, e) {
    const i = e.previousElementSibling;
    if (!i) return;
    const n = getterGet(_color_vimgs, i, i.getAttribute("data-vimg"));
    if (n) {
      const t2 = getterGet(_color_products, this).querySelector(
        ".hdt-card-product__media--main",
      );
      n !== t2.getAttribute("src") &&
        getterRunFn(_create_img, this, create_img_fn).call(this, n, t2);
    }
  }),
  (_create_img = new WeakSet()),
  (create_img_fn = function (t, e) {
    return createImg({
      src: t,
      width: e.getAttribute("width"),
      height: e.getAttribute("height"),
      alt: e.alt,
      onload: !0,
      attrs: {
        class: e.className,
        sizes: e.sizes,
        "data-widths": e.getAttribute("data-widths") || "[]",
      },
    });
  }),
  customElements.define("wrapp-hdt-color-list", ColorList));
var cacheUrlVariant = {},
  UrlWithVariant = class {
    static get(t, e) {
      if (t && e)
        return cacheUrlVariant[e]
          ? cacheUrlVariant[e]
          : ((t = new URL(t)).searchParams.set("variant", e),
            (cacheUrlVariant[e] = t.toString()));
    }
  };
const { currencyFormat } = themeHDN.settings,
  variantChange = "variant:change";
var _on_after_close,
  on_after_close_fn,
  _section_ids_modal = new WeakMap();
class LazyModal extends Modal {
  constructor() {
    (super(),
      getterAdd(_on_after_close, this),
      getterAdd(_section_ids_modal, this, this.getAttribute("section-id")),
      this.addEventListener(
        "dialog:doneClose",
        getterRunFn(_on_after_close, this, on_after_close_fn).bind(this),
      ),
      this.addEventListener("dialog:beforeOpen", () => {
        const t = $$4("hdt-badge[update-hidden]", this);
        t.length && t.forEach((t2) => t2.updateHiddenParent());
      }));
  }
  async openDialog(t = !0, e) {
    const i = e ? e.getAttribute("handle") : this.getAttribute("handle");
    if (!i) return;
    (document.dispatchEvent(
      new CustomEvent("theme:loading:doing", { bubbles: !0 }),
    ),
      e?.setAttribute("aria-busy", "true"));
    const n = await (
      await cachedFetch(
        `${window.Shopify.routes.root}products/${i}?section_id=${getterGet(
          _section_ids_modal,
          this,
        )}`,
      )
    ).text();
    (document.dispatchEvent(
      new CustomEvent("theme:loading:done", { bubbles: !0 }),
    ),
      e?.setAttribute("aria-busy", "false"));
    const s = new DOMParser().parseFromString(n, "text/html"),
      r = document
        .createRange()
        .createContextualFragment(
          s.getElementById(
            `shopify-section-${getterGet(_section_ids_modal, this)}`,
          ).innerHTML,
        );
    return (
      this.replaceChildren(...r.children),
      rteWrapTable(this),
      accessibleLinks(this),
      localeUrl(this),
      Shopify?.PaymentButton?.init(),
      document.dispatchEvent(new CustomEvent("currency:update")),
      super.openDialog(t)
    );
  }
  get controls() {
    return $$4(`[aria-controls="${this.id}"]`, this.getRootNode());
  }
}
((_on_after_close = new WeakSet()),
  (on_after_close_fn = function () {
    this.innerHTML = "";
  }));
class FetchButtonModal extends btnTooltip {
  constructor() {
    (super(),
      $id4(
        this.firstElementChild.getAttribute("aria-controls"),
      )?.updateBtbsOpen(this));
  }
  connectedCallback() {
    (super.connectedCallback(),
      $4("hdt-tmp-quick")?.dispatchEvent(
        new CustomEvent("theme:update:id", { bubbles: !1 }),
      ));
  }
}
class TmpQuick extends HTMLElement {
  constructor() {
    (super(),
      this.getIDTemp(),
      this.addEventListener("theme:update:id", () => this.getIDTemp()));
  }
  async getIDTemp() {
    const t = $4(
      '[aria-controls="hdt-quick-view-modal"], [aria-controls="hdt-quick-add-modal"]',
    );
    if (!t || this.hasID) return;
    ((this.hasID = !0),
      this.removeEventListener("theme:update:id", () => this.getIDTemp()));
    let e,
      i = "themeQuick" + window.Shopify.theme.id;
    sessionStorage.getItem(i) && !Shopify.designMode
      ? (e = sessionStorage.getItem(i))
      : ((e = await (
          await fetch(
            `${window.Shopify.routes.root}products/${t.getAttribute(
              "handle",
            )}?view=only_config`,
            {
              priority: "low",
            },
          )
        ).text()),
        sessionStorage.setItem(i, e));
    const n = new DOMParser().parseFromString(e, "text/html");
    ($$4(
      ".hdt-main-section--quick-view, .hdt-main-section--quick-add",
      n,
    ).forEach((t2) => this.insertAdjacentHTML("afterend", t2.innerHTML)),
      this.remove());
  }
}
(customElements.define("hdt-lazy-modal", LazyModal),
  customElements.define("wrapp-hdt-open-modal-btn", FetchButtonModal),
  customElements.define("hdt-tmp-quick", TmpQuick));
var _on_submit,
  on_submit_fn,
  _pr_frm = new WeakMap();
class ProductForm extends HTMLElement {
  constructor() {
    (super(),
      getterAdd(_on_submit, this),
      getterAdd(_pr_frm, this, $4("form", this)),
      getterGet(_pr_frm, this).addEventListener(
        "submit",
        getterRunFn(_on_submit, this, on_submit_fn),
      ));
  }
  connectedCallback() {
    ((this.hideErrors = this.dataset.hideErrors === "true"),
      (getterGet(_pr_frm, this).id.disabled = !1));
  }
}
((_on_submit = new WeakSet()),
  (on_submit_fn = async function (t) {
    if ((t.preventDefault(), this.checkBreak)) return;
    if (!this.checkValidity()) return void this.reportValidity();
    const e = Array.from(this.elements).filter((t2) => t2.type === "submit");
    (e.forEach((t2) => {
      (t2.setAttribute("disabled", "disabled"),
        t2.setAttribute("aria-busy", "true"));
    }),
      document.dispatchEvent(
        new CustomEvent("theme:loading:doing", { bubbles: !0 }),
      ));
    let i = [];
    document.dispatchEvent(
      new CustomEvent("cart:push:section.id", {
        bubbles: !0,
        detail: { sections: i },
      }),
    );
    const n = new FormData(this);
    n.set("sections", i.join(","));
    const s = await fetch(`${Shopify.routes.root}cart/add.js`, {
      body: n,
      method: "POST",
      headers: { "X-Requested-With": "XMLHttpRequest" },
    });
    e.forEach((t2) => {
      (t2.removeAttribute("disabled"), t2.removeAttribute("aria-busy"));
    });
    const r = await s.json();
    if (
      (document.dispatchEvent(
        new CustomEvent("theme:loading:done", { bubbles: !0 }),
      ),
      s.ok)
    ) {
      const t2 = await createCartPromise();
      ((t2.sections = r.sections),
        this.dispatchEvent(
          new CustomEvent("variant:add", {
            bubbles: !0,
            detail: {
              items: r.hasOwnProperty("items") ? r.items : [r],
              actionAfterATC: n.get("action_added"),
              cart: t2,
            },
          }),
        ),
        document.dispatchEvent(
          new CustomEvent("cart:change", {
            bubbles: !0,
            detail: {
              baseEvent: "variant:add",
              actionAfterATC: n.get("action_added"),
              cart: t2,
            },
          }),
        ));
    } else {
      if (this.hideErrors) return;
      this.dispatchEvent(
        new CustomEvent("cart:add:error", {
          bubbles: !0,
          detail: {
            isGiftCardRecipient: this.dataset.giftCardRecipient === "true",
            error: r.description,
          },
        }),
      );
    }
  }));
var _update_bundle_total,
  update_bundle_total_fn,
  _update_total_bundle = new WeakMap();
class ProductFormBundle extends ProductForm {
  constructor() {
    (super(), getterAdd(_update_bundle_total, this));
  }
  connectedCallback() {
    (getterAdd(_update_total_bundle, this, $4("[update-total]", this)),
      (this.totalPrice = Number(
        getterGet(_update_total_bundle, this).dataset.price,
      )),
      (this.totalComparePrice = Number(
        getterGet(_update_total_bundle, this).dataset.cpprice,
      )),
      this.addEventListener(
        "update:bundle:total",
        getterRunFn(_update_bundle_total, this, update_bundle_total_fn).bind(
          this,
        ),
      ));
  }
  disconnectedCallback() {
    this.removeEventListener(
      "update:bundle:total",
      getterRunFn(_update_bundle_total, this, update_bundle_total_fn).bind(
        this,
      ),
    );
  }
}
((_update_bundle_total = new WeakSet()),
  (update_bundle_total_fn = function (t) {
    t.detail.action == "plus"
      ? ((this.totalPrice = this.totalPrice + t.detail.remainPrice),
        (this.totalComparePrice =
          this.totalComparePrice + t.detail.remainComparePrice))
      : ((this.totalPrice = this.totalPrice - t.detail.remainPrice),
        (this.totalComparePrice =
          this.totalComparePrice - t.detail.remainComparePrice));
    const e = $4("hdt-compare-at-price", getterGet(_update_total_bundle, this));
    (e &&
      (e.toggleAttribute("hidden", this.totalComparePrice <= this.totalPrice),
      ($4(".hdt-money", e).outerHTML = `<span class="hdt-money">${formatMoney(
        this.totalComparePrice,
      )}</span>`)),
      ($4(
        "hdt-price .hdt-money",
        getterGet(_update_total_bundle, this),
      ).outerHTML = `<span class="hdt-money">${formatMoney(
        this.totalPrice,
      )}</span>`),
      document.dispatchEvent(new CustomEvent("currency:update")));
  }));
var _bundle_product,
  bundle_product_fn,
  _on_variant_changed,
  on_variant_changed_fn,
  _cart_error,
  _cart_error_fn,
  _on_recipient_form_changed,
  on_recipient_form_changed_fn,
  _cart_error2,
  _cart_error2_fn,
  _displayErrorMessage,
  displayErrorMessage_fn,
  _createErrorListItem,
  createErrorListItem_fn,
  _clearErrorMessage,
  clearErrorMessage_fn,
  _on_value_change,
  on_value_change_fn,
  _variants_data,
  _find_closest_variant,
  find_closest_variant_fn,
  _update_variant_statuses,
  update_variant_statuses_fn,
  _update_url,
  update_url_fn,
  _master_input_change,
  master_input_change_fn,
  _bundle_items = new WeakMap();
class bundleProduct extends HTMLElement {
  #t;
  constructor() {
    (super(),
      getterAdd(_bundle_product, this),
      getterAdd(_bundle_items, this, $$4('[name^="items[]"]', this)));
  }
  connectedCallback() {
    this.#t = new AbortController();
    const t = $4('[name="items[][id]"]', this);
    ((this.price = Number(t.dataset.price)),
      (this.comparePrice = Number(t.dataset.cpprice)),
      this.addEventListener(
        "change",
        getterRunFn(_bundle_product, this, bundle_product_fn).bind(this),
        {
          signal: this.#t.signal,
        },
      ));
  }
  disconnectedCallback() {
    this.#t.abort();
  }
  get observes() {
    return (this._observes =
      this._observes || $id4(this.getAttribute("observes")));
  }
}
((_bundle_product = new WeakSet()),
  (bundle_product_fn = function (t) {
    const e = t.target;
    if (e.tagName == "SELECT") {
      const t2 = e.options[e.selectedIndex],
        r = this.price,
        a = this.comparePrice;
      ((this.price = Number(t2.dataset.price)),
        (this.comparePrice = Number(t2.dataset.cpprice)));
      var i = "plus",
        n = this.price - r,
        s = this.comparePrice - a;
      if (
        ($4("[update-price] hdt-compare-at-price", this).toggleAttribute(
          "hidden",
          this.comparePrice <= this.price,
        ),
        ($4("[update-price] hdt-compare-at-price .hdt-money", this).outerHTML =
          `<span class="hdt-money">${formatMoney(this.comparePrice)}</span>`),
        ($4("[update-price] hdt-price .hdt-money", this).outerHTML =
          `<span class="hdt-money">${formatMoney(this.price)}</span>`),
        ($4("[update-qty]", this).value = t2.dataset.qty),
        ($4("[update-img]", this.observes || this).src = t2.dataset.img),
        document.dispatchEvent(new CustomEvent("currency:update")),
        !this.classList.contains("is-checked"))
      )
        return;
    } else
      e.tagName == "INPUT" &&
        (getterGet(_bundle_items, this).forEach((t2) => {
          t2.toggleAttribute("disabled", !e.checked);
        }),
        this.classList.toggle("is-checked", e.checked),
        (i = e.checked ? "plus" : "minus"),
        (n = this.price),
        (s = this.comparePrice),
        this.observes?.classList.toggle("is-checked", e.checked));
    this.dispatchEvent(
      new CustomEvent("update:bundle:total", {
        bubbles: !0,
        detail: { remainPrice: n, remainComparePrice: s, action: i },
      }),
    );
  }));
class BuyButtons extends HTMLElement {
  #t;
  constructor() {
    (super(),
      getterAdd(_on_variant_changed, this),
      getterAdd(_cart_error, this));
  }
  get form() {
    return document.forms[this.getAttribute("form")];
  }
  connectedCallback() {
    ((this.#t = new AbortController()),
      this.form?.addEventListener(
        variantChange,
        getterRunFn(_on_variant_changed, this, on_variant_changed_fn).bind(
          this,
        ),
        { signal: this.#t.signal },
      ),
      this.form?.addEventListener(
        "cart:add:error",
        getterRunFn(_cart_error, this, _cart_error_fn).bind(this),
        {
          signal: this.#t.signal,
        },
      ));
  }
  disconnectedCallback() {
    this.#t.abort();
  }
}
((_on_variant_changed = new WeakSet()),
  (on_variant_changed_fn = function (t) {
    const e = t.detail.variant,
      i = $4('button[type="submit"]', this);
    ((i.disabled = !e || !e.available),
      (i.firstElementChild.textContent =
        themeHDN.extras[
          e
            ? e.variant_state.pre_order
              ? "preOrder"
              : e.available
                ? "addToCart"
                : "soldOut"
            : "unavailable"
        ]),
      (this.previousElementSibling.hidden = !0),
      $4("hdt-price", this)?.removeAttribute("hidden"));
  }),
  (_cart_error = new WeakSet()),
  (_cart_error_fn = function (t) {
    t.detail.isGiftCardRecipient ||
      ((this.previousElementSibling.hidden = !1),
      (this.previousElementSibling.lastElementChild.textContent =
        t.detail.error),
      this.form?.addEventListener(
        "variant:add",
        () => (this.previousElementSibling.hidden = !0),
        { once: !0 },
      ));
  }));
class RecipientForm extends HTMLElement {
  #t;
  constructor() {
    (super(),
      getterAdd(_on_recipient_form_changed, this),
      getterAdd(_cart_error2, this),
      getterAdd(_displayErrorMessage, this),
      getterAdd(_createErrorListItem, this),
      getterAdd(_clearErrorMessage, this),
      (this.recipientFieldsLiveRegion = $4(
        `#Recipient-fields-live-region-${this.sectionId}`,
        this,
      )),
      (this.checkboxInput = $4(`#Recipient-checkbox-${this.sectionId}`, this)),
      (this.checkboxInput.disabled = !1),
      (this.hiddenControlField = $4(
        `#Recipient-control-${this.sectionId}`,
        this,
      )),
      (this.hiddenControlField.disabled = !0),
      (this.emailInput = $4(`#Recipient-email-${this.sectionId}`, this)),
      (this.nameInput = $4(`#Recipient-name-${this.sectionId}`, this)),
      (this.messageInput = $4(`#Recipient-message-${this.sectionId}`, this)),
      (this.sendonInput = $4(`#Recipient-send-on-${this.sectionId}`, this)),
      (this.offsetProperty = $4(
        `#Recipient-timezone-offset-${this.sectionId}`,
      )),
      this.offsetProperty &&
        (this.offsetProperty.value = new Date().getTimezoneOffset().toString()),
      (this.errorMessageWrapper = $4(".hdt-form__message-wrapper", this)),
      (this.errorMessageList = this.errorMessageWrapper?.querySelector("ul")),
      (this.errorMessage =
        this.errorMessageWrapper?.querySelector(".hdt-error-message")),
      (this.defaultErrorHeader = this.errorMessage?.innerText));
  }
  connectedCallback() {
    ((this.#t = new AbortController()),
      this.checkboxInput.addEventListener(
        "change",
        getterRunFn(
          _on_recipient_form_changed,
          this,
          on_recipient_form_changed_fn,
        ).bind(this),
        { signal: this.#t.signal },
      ),
      this.form?.addEventListener(
        "cart:add:error",
        getterRunFn(_cart_error2, this, _cart_error2_fn).bind(this),
        {
          signal: this.#t.signal,
        },
      ),
      this.form?.addEventListener(
        "variant:add",
        getterRunFn(_clearErrorMessage, this, clearErrorMessage_fn).bind(this),
        { signal: this.#t.signal },
      ));
  }
  disconnectedCallback() {
    this.#t.abort();
  }
  get form() {
    return document.forms[this.getAttribute("form")];
  }
  get sectionId() {
    return this.dataset.sectionId;
  }
  inputFields() {
    return [
      this.emailInput,
      this.nameInput,
      this.messageInput,
      this.sendonInput,
    ];
  }
  disableableFields() {
    return [...this.inputFields(), this.offsetProperty];
  }
  enableInputFields() {
    this.disableableFields().forEach((t) => (t.disabled = !1));
  }
  disableInputFields() {
    this.disableableFields().forEach((t) => (t.disabled = !0));
  }
}
((_on_recipient_form_changed = new WeakSet()),
  (on_recipient_form_changed_fn = function () {
    this.checkboxInput.checked
      ? (this.enableInputFields(),
        (this.recipientFieldsLiveRegion.innerText =
          this.recipientFieldsLiveRegion.dataset.expanded))
      : (this.disableInputFields(),
        (this.recipientFieldsLiveRegion.innerText =
          this.recipientFieldsLiveRegion.dataset.collapsed));
  }),
  (_cart_error2 = new WeakSet()),
  (_cart_error2_fn = function (t) {
    t.detail.isGiftCardRecipient &&
      (console.log(t.detail),
      getterRunFn(_displayErrorMessage, this, displayErrorMessage_fn).call(
        this,
        t.detail.error,
      ));
  }),
  (_displayErrorMessage = new WeakSet()),
  (displayErrorMessage_fn = function (t) {
    if (
      (getterRunFn(_clearErrorMessage, this, clearErrorMessage_fn).call(this),
      (this.errorMessageWrapper.hidden = !1),
      typeof t == "object")
    )
      return (
        (this.errorMessage.innerText = this.defaultErrorHeader),
        Object.entries(t).forEach(([t2, e]) => {
          const i = `RecipientForm-${t2}-error-${this.sectionId}`,
            n = `#Recipient-${t2}-${this.sectionId}`,
            s = `${e.join(", ")}`,
            r = this.querySelector(`#${i}`),
            a = r?.querySelector(".hdt-error-message");
          if (!a) return;
          (this.errorMessageList &&
            this.errorMessageList.appendChild(
              getterRunFn(
                _createErrorListItem,
                this,
                createErrorListItem_fn,
              ).call(this, n, s),
            ),
            (a.innerText = `${s}.`),
            r.removeAttribute("hidden"));
          const o = this[`${t2}Input`];
          o &&
            (o.setAttribute("aria-invalid", !0),
            o.setAttribute("aria-describedby", i));
        })
      );
    this.errorMessage.innerText = t;
  }),
  (_createErrorListItem = new WeakSet()),
  (createErrorListItem_fn = function (t, e) {
    const i = document.createElement("li"),
      n = document.createElement("a");
    return (
      n.setAttribute("href", t),
      (n.innerText = e),
      i.appendChild(n),
      (i.className = "hdt-error-message"),
      i
    );
  }),
  (_clearErrorMessage = new WeakSet()),
  (clearErrorMessage_fn = function () {
    ((this.errorMessageWrapper.hidden = !0),
      this.errorMessageList && (this.errorMessageList.innerHTML = ""),
      this.querySelectorAll(".hdt-recipient-fields .hdt-form__message").forEach(
        (t) => {
          t.setAttribute("hidden", "");
          const e = t.querySelector(".hdt-error-message");
          e && (e.innerText = "");
        },
      ),
      [
        this.emailInput,
        this.messageInput,
        this.nameInput,
        this.sendonInput,
      ].forEach((t) => {
        (t.setAttribute("aria-invalid", !1),
          t.removeAttribute("aria-describedby"));
      }));
  }),
  customElements.define("wrapp-hdt-pr-frm", ProductForm),
  customElements.define("wrapp-hdt-pr-frm-bundle", ProductFormBundle),
  customElements.define("hdt-bundle-product", bundleProduct),
  customElements.define("hdt-buy-buttons", BuyButtons),
  customElements.define("hdt-recipient-form", RecipientForm));
class VariantPicker extends HTMLElement {
  #t;
  constructor() {
    (super(),
      getterAdd(_on_value_change, this),
      getterAdd(_find_closest_variant, this),
      getterAdd(_update_variant_statuses, this),
      getterAdd(_update_url, this));
  }
  async connectedCallback() {
    if (((this.#t = new AbortController()), !this.hasAttribute("handle")))
      return;
    var t = (await await getJSONProduct.load(this.getAttribute("handle")))
      .variants;
    this.hideSoldOutVariants && (t = t.filter((t2) => t2.available));
    const e = new DOMParser().parseFromString(
      this.nextElementSibling.textContent,
      "text/html",
    );
    (e &&
      $$4("select > option", e).forEach((e2, i) => {
        const n = e2.dataset;
        let s = t[i];
        ((s = Object.assign(s, {
          inventory_policy: n.inventorypolicy || null,
          inventory_quantity: parseInt(n.inventoryquantity),
          mdid: n.mdid || null,
        })),
          (s.variant_state = {
            sold_out: !s.available,
            on_sale: s.compare_at_price > s.price,
            pre_order:
              s.inventory_management == "shopify" &&
              s.inventory_quantity <= 0 &&
              s.available,
          }),
          s.quantity_rule ||
            (s.quantity_rule = { min: 1, max: null, increment: 1, max4: !0 }));
        const {
          inventory_quantity: r,
          inventory_management: a,
          inventory_policy: o,
        } = s;
        !s.quantity_rule.max &&
          r > 0 &&
          a != null &&
          o != "continue" &&
          ((s.quantity_rule.max = r), (s.quantity_rule.max4 = !0));
      }),
      getterAdd(_variants_data, this, t),
      (t = null),
      (this.masterInput = this.idELForm),
      getterRunFn(_update_url, this, update_url_fn).call(this, !0),
      this.masterInput &&
        ((this.masterInput.disabled = !1),
        getterAdd(_master_input_change, this),
        this.addEventListener(
          "change",
          getterRunFn(_on_value_change, this, on_value_change_fn).bind(this),
          {
            signal: this.#t.signal,
          },
        ),
        this.masterInput.addEventListener(
          "change",
          getterRunFn(_master_input_change, this, master_input_change_fn).bind(
            this,
          ),
          { signal: this.#t.signal },
        ),
        $$4('fieldset[type^="dropdown"]', this).forEach((t2) => {
          $4("hdt-popover", t2).addEventListener(
            "richlist:change",
            (e2) => {
              const i = $4(
                `input[type="hidden"][name="option${
                  parseInt(t2.dataset.index) + 1
                }"]`,
                t2,
              );
              i.value != e2.detail.value &&
                ((i.value = e2.detail.value),
                i.dispatchEvent(new Event("change", { bubbles: !0 })));
            },
            { signal: this.#t.signal },
          );
        })));
  }
  disconnectedCallback() {
    this.#t.abort();
  }
  get idELForm() {
    const t = this.getAttribute("form");
    if (!document.forms[t]) {
      const e = `<form id="${t}" action="${
        Shopify.routes.root
      }cart/add.js" method="POST" hidden><input type="hidden" name="id" value="${this.getAttribute(
        "selected-variant",
      )}"></form>`;
      this.insertAdjacentHTML("afterend", e);
    }
    return document.forms[t].id;
  }
  get hideSoldOutVariants() {
    return this.hasAttribute("hide-sold-out-variants");
  }
  get updateUrl() {
    return this.getAttribute("update-url");
  }
  get updateStatus() {
    return this.hasAttribute("update-status");
  }
  get productMedia() {
    return (this._productMedia =
      this._productMedia ||
      $4(`hdt-product-media[form="${this.getAttribute("form")}"]`));
  }
  getvariantObjById(t) {
    return getterGet(_variants_data, this).find((e) => e.id == t);
  }
  updateOptions() {
    const t = $$4("fieldset", this);
    this.options = t
      .map(
        (t2) =>
          $$4("input", t2).find((t3) => t3.checked || t3.type == "hidden")
            ?.value,
      )
      .filter(function (t2) {
        return t2 !== void 0 && t2 !== "";
      });
  }
  updateMasterId() {
    this.currentVariant = getterGet(_variants_data, this).find(
      (t) => !t.options.map((t2, e) => this.options[e] === t2).includes(!1),
    );
  }
  selectVariantByID(t, e = !0) {
    this.hasAttribute("no-pick") ||
      this.selectVariantByVariantObj(this.getvariantObjById(t), e);
  }
  selectVariantByVariantObj(t, e = !0, i = !1) {
    typeof t == "object" &&
      getterGet(_variants_data, this).includes(t) &&
      ((this.options = t.options),
      (this.currentVariant = t),
      this.selectVariant(!1, e, i));
  }
  selectVariant(t = !1, e = !0, i = !1) {
    (this.oldVariant && this.oldVariant.id === this.currentVariant.id && !i) ||
      ((this.oldVariant = this.currentVariant),
      (this.masterInput.value = this.currentVariant.id),
      this.masterInput.dispatchEvent(
        new CustomEvent("change", {
          bubbles: !0,
          detail: { hasVariant: !0, untriggerChangeEvent: t },
        }),
      ),
      getterRunFn(
        _update_variant_statuses,
        this,
        update_variant_statuses_fn,
      ).call(this),
      getterRunFn(_update_url, this, update_url_fn).call(this),
      this.masterInput.form.dispatchEvent(
        new CustomEvent(variantChange, {
          bubbles: !0,
          detail: { variant: this.currentVariant, jumpMedia: e },
        }),
      ));
  }
}
function onlyUnique(t, e, i) {
  return i.indexOf(t) === e;
}
((_variants_data = new WeakMap()),
  (_on_value_change = new WeakSet()),
  (on_value_change_fn = function (t) {
    if (!t.target.hasAttribute("is-value")) return;
    const e = t.target.closest("fieldset");
    if (
      ((this.clickedCurrentIndex = parseInt(e.dataset.index)),
      (this.clickedCurrentValue = t.target.value),
      this.updateOptions(),
      this.options.length < parseInt(this.dataset.size))
    ) {
      $4("[update-value]", e).textContent = this.clickedCurrentValue;
      const t2 = ["nanthan94", "nanthan94", "nanthan94"];
      return (
        (t2[this.clickedCurrentIndex] = this.clickedCurrentValue),
        void this.productMedia?.dispatchEvent(
          new CustomEvent("update:value", { detail: { options: t2 } }),
        )
      );
    }
    (this.removeAttribute("no-pick"),
      this.updateMasterId(),
      this.currentVariant ||
        getterRunFn(_find_closest_variant, this, find_closest_variant_fn).call(
          this,
        ),
      this.selectVariant(!0));
  }),
  (_master_input_change = new WeakSet()),
  (master_input_change_fn = function (t) {
    if (
      ((t.detail && t.detail.hasVariant) ||
        (this.currentVariant = this.getvariantObjById(t.target.value)),
      !this.currentVariant)
    )
      return;
    let e = [];
    ($$4("fieldset[data-index]", this).forEach((i, n) => {
      let s = this.currentVariant.options[n],
        r = i.getAttribute("type"),
        a = $4("[update-value]", i),
        o = $4(
          `input[type="radio"][value="${CSS.escape(
            s,
          )}"], input[type="hidden"][name="option${n + 1}"]`,
          i,
        ),
        l = !1;
      if (r.startsWith("dropdown")) {
        ((l = o.value !== s), (o.value = s));
        const t2 = $4("hdt-richlist", i);
        t2 && (t2.selected = s);
      } else ((l = !o.checked && o.value === s), (o.checked = !0));
      (t.detail && t.detail.untriggerChangeEvent && (l = !1),
        a && (a.textContent = s),
        l && e.push(o));
    }),
      e.forEach((t2) =>
        t2.dispatchEvent(new CustomEvent("change", { bubbles: !0 })),
      ),
      (e = []));
  }),
  (_find_closest_variant = new WeakSet()),
  (find_closest_variant_fn = function () {
    let t,
      e = parseInt(this.dataset.size),
      i = !this.hideSoldOutVariants;
    ((t =
      e == 1
        ? getterGet(_variants_data, this).filter((t2) => t2.available)
        : e == 3
          ? getterGet(_variants_data, this).filter(
              (t2) =>
                t2.option1 == this.options[0] &&
                t2.option2 == this.options[1] &&
                (i || t2.available),
            )
          : getterGet(_variants_data, this).filter(
              (t2) => t2.option1 == this.options[0] && (i || t2.available),
            )),
      t[0] ||
        (t = getterGet(_variants_data, this).filter(
          (t2) =>
            t2.options[this.clickedCurrentIndex] == this.clickedCurrentValue &&
            (i || t2.available),
        )),
      (this.currentVariant = t[0]));
  }),
  (_update_variant_statuses = new WeakSet()),
  (update_variant_statuses_fn = function () {
    if (!this.updateStatus) return;
    const t = getterGet(_variants_data, this).filter(
        (t2) => t2.option1 == this.currentVariant.option1,
      ),
      e = getterGet(_variants_data, this).filter(
        (t2) =>
          t2.option1 == this.currentVariant.option1 &&
          t2.option2 == this.currentVariant.option2,
      ),
      i = getterGet(_variants_data, this)
        .map((t2) => t2.option1)
        .filter(onlyUnique),
      n = t.map((t2) => t2.option2).filter(onlyUnique),
      s = e.map((t2) => t2.option3).filter(onlyUnique),
      r = getterGet(_variants_data, this)
        .filter((t2) => t2.available)
        .map((t2) => t2.option1)
        .filter(onlyUnique),
      a = t
        .filter((t2) => t2.available)
        .map((t2) => t2.option2)
        .filter(onlyUnique),
      o = e
        .filter((t2) => t2.available)
        .map((t2) => t2.option3)
        .filter(onlyUnique);
    $$4("fieldset[data-index]", this).forEach((t2, e2) => {
      let l = ++e2;
      $$4('[type="radio"], hdt-richlist > button', t2).forEach((t3) => {
        let e3 = !0,
          d = !0;
        switch (l) {
          case 1:
            (i.includes(t3.value) && (e3 = !1),
              r.includes(t3.value) && (d = !1));
            break;
          case 2:
            (n.includes(t3.value) && (e3 = !1),
              a.includes(t3.value) && (d = !1));
            break;
          default:
            (s.includes(t3.value) && (e3 = !1),
              o.includes(t3.value) && (d = !1));
        }
        (t3.classList.toggle("is-disabled", d),
          t3.classList.toggle("is-unavailable", e3));
      });
    });
  }),
  (_update_url = new WeakSet()),
  (update_url_fn = function (t) {
    if (!this.updateUrl || !history.replaceState) return;
    const e = new URL(window.location.href),
      i = t ? this.updateUrl : this.currentVariant.id;
    (i ? e.searchParams.set("variant", i) : e.searchParams.delete("variant"),
      window.history.replaceState({ path: e.toString() }, "", e.toString()));
  }));
class VariantChangeBase extends HTMLElement {
  constructor() {
    (super(), (this._onVariantChanged = this.onVariantChanged.bind(this)));
  }
  get form() {
    return (this._form =
      this._form || document.forms[this.getAttribute("form")]);
  }
  connectedCallback() {
    this.form?.addEventListener(variantChange, this._onVariantChanged);
  }
  disconnectedCallback() {
    this.form?.removeEventListener(variantChange, this._onVariantChanged);
  }
  onVariantChanged() {}
}
class Price extends VariantChangeBase {
  onVariantChanged(t) {
    const e = t.detail.variant;
    (($4(".hdt-money", this).outerHTML = `<span class="hdt-money">${formatMoney(
      e.price,
      currencyFormat,
    )}</span>`),
      this.classList.toggle("hdt-price-on-sale", e.variant_state.on_sale),
      document.dispatchEvent(new CustomEvent("currency:update")));
  }
}
class CompareAtPrice extends Price {
  onVariantChanged(t) {
    const e = t.detail.variant;
    ((this.hidden = !(e.compare_at_price > e.price)),
      this.hidden ||
        (($4(".hdt-money", this).outerHTML =
          `<span class="hdt-money">${formatMoney(
            e.compare_at_price,
            currencyFormat,
          )}</span>`),
        document.dispatchEvent(new CustomEvent("currency:update"))));
  }
}
class UnitPrice extends Price {
  onVariantChanged(t) {
    const e = t.detail.variant;
    ((this.hidden = !e.unit_price),
      this.hidden ||
        (($4(".hdt-money", this).outerHTML =
          `<span class="hdt-money">${formatMoney(
            e.unit_price,
            currencyFormat,
          )}</span>`),
        document.dispatchEvent(new CustomEvent("currency:update"))));
  }
}
class QtyPrice extends Price {
  constructor() {
    (super(), (this._onVariantChanged = this.onVariantChanged.bind(this)));
  }
  get qty() {
    return (
      this._qty || $4(`[name="quantity"][form="${this.getAttribute("form")}"]`)
    );
  }
  onVariantChanged(t) {
    (this.setAttribute("variant-price", t.detail.variant.price),
      (this.hidden = !1),
      this.updatPrice());
  }
  connectedCallback() {
    (super.connectedCallback(),
      this.qty?.addEventListener("change", this.updatPrice.bind(this)),
      this.qty?.addEventListener(
        "input",
        debounce(this.updatPrice.bind(this), 300),
      ));
  }
  updatPrice() {
    const t = parseFloat(this.getAttribute("variant-price"));
    (($4(".hdt-money", this).outerHTML = `<span class="hdt-money">${formatMoney(
      t * (this.qty ? this.qty.value : 1),
      currencyFormat,
    )}</span>`),
      document.dispatchEvent(new CustomEvent("currency:update")));
  }
}
class Badge extends VariantChangeBase {
  constructor() {
    (super(),
      this.updateHiddenParent(),
      this.parentElement && this.parentElement.classList.add("js-intent"));
  }
  get is() {
    return this.getAttribute("is");
  }
  get type() {
    return this.getAttribute("type");
  }
  updateHiddenParent() {
    this.parentElement &&
      this.hasAttribute("update-hidden") &&
      (this.parentElement.removeAttribute("hidden"),
      (this.parentElement.hidden = !this.parentElement.clientHeight));
  }
  onVariantChanged(t) {
    const e = t.detail.variant;
    ((this.hidden =
      this.is != "available" ? !e.variant_state[this.is] : !e.available),
      this.updateHiddenParent());
    const i = $4("[percent]", this);
    if (!this.hidden && this.type === "percentage" && i) {
      const t2 = (100 * (e.compare_at_price - e.price)) / e.compare_at_price;
      t2 != i.textContent && (i.textContent = Math.max(1, Math.round(t2)));
    }
  }
}
var _update_inventory_status,
  update_inventory_status_fn,
  _pickup_availability,
  pickup_availability_fn,
  _create_img2,
  create_img2_fn,
  _show_quantity_inventory = new WeakMap(),
  _threshold_inventory = new WeakMap(),
  _progressBar_inventory = new WeakMap();
class VariantInventory extends VariantChangeBase {
  constructor() {
    (super(),
      getterAdd(_update_inventory_status, this),
      getterAdd(
        _show_quantity_inventory,
        this,
        this.hasAttribute("show-inventory-quantity"),
      ),
      getterAdd(
        _threshold_inventory,
        this,
        parseInt(this.getAttribute("inventory-threshold")),
      ),
      getterAdd(_progressBar_inventory, this, $4(".hdt-progress-bar", this)));
  }
  get progressBar() {
    return getterGet(_progressBar_inventory, this);
  }
  onVariantChanged(t) {
    getterRunFn(
      _update_inventory_status,
      this,
      update_inventory_status_fn,
    ).call(this, t.detail.variant);
  }
}
((_update_inventory_status = new WeakSet()),
  (update_inventory_status_fn = function (t) {
    let e = "";
    ((e = t.available
      ? t.inventory_quantity > 0
        ? t.inventory_quantity <= getterGet(_threshold_inventory, this) &&
          t.inventory_policy == "deny" &&
          t.requires_shipping
          ? getterGet(_show_quantity_inventory, this)
            ? "low-stock-count"
            : "low-stock"
          : getterGet(_show_quantity_inventory, this)
            ? "in-stock-count"
            : "in-stock"
        : t.inventory_management == "shopify"
          ? "pre-order-stock"
          : "in-stock"
      : "out-of-stock"),
      e == "low-stock" ||
      e == "in-stock" ||
      e == "low-stock-count" ||
      e == "in-stock-count"
        ? ($$4("[data-quantity]", this).forEach(
            (e2) => (e2.textContent = t.inventory_quantity),
          ),
          this.progressBar &&
            ((this.progressBar.hidden = !1),
            (this.progressBar.valueNow =
              t.inventory_quantity > 0
                ? t.inventory_quantity
                : this.progressBar.getAttribute("aria-valuemax"))))
        : this.progressBar?.setAttribute("hidden", ""),
      $4(".hdt-stock-status:not([hidden])", this)?.setAttribute("hidden", ""),
      $4(`.hdt-stock-status[${e || "nt94"}]`, this)?.removeAttribute("hidden"));
  }));
class VariantLive extends VariantChangeBase {
  get is() {
    return this.getAttribute("is");
  }
  onVariantChanged(t) {
    const e = t.detail.variant;
    ((this.hidden = !e || e[this.is] === ""),
      !this.hidden &&
        (($4("[update-value]", this) || this).innerText = e[this.is]));
  }
}
class PickupAvailability extends VariantChangeBase {
  constructor() {
    (super(), getterAdd(_pickup_availability, this));
  }
  onVariantChanged(t) {
    getterRunFn(_pickup_availability, this, pickup_availability_fn).call(
      this,
      t.detail.variant,
    );
  }
}
((_pickup_availability = new WeakSet()),
  (pickup_availability_fn = async function (t) {
    if (t) {
      const e = document.createElement("div");
      (this.setAttribute("loading", ""),
        (e.innerHTML = await (
          await fetch(
            `${Shopify.routes.root}variants/${t.id}?section_id=pickup-availability`,
          )
        ).text()),
        this.replaceChildren(
          ...e.querySelector("hdt-pickup-availability").childNodes,
        ),
        this.removeAttribute("loading", ""));
    } else this.innerHTML = "";
  }));
class VariantPreviewImg extends VariantChangeBase {
  constructor() {
    (super(), getterAdd(_create_img2, this));
  }
  onVariantChanged(t) {
    const e = t.detail.variant,
      i = $4("img", this);
    e &&
      e.featured_image &&
      i &&
      i.replaceWith(
        getterRunFn(_create_img2, this, create_img2_fn).call(
          this,
          e.featured_image,
          i,
        ),
      );
  }
}
((_create_img2 = new WeakSet()),
  (create_img2_fn = function (t, e) {
    return createImg(
      Object.assign(t, {
        onload: !0,
        attrs: {
          class: e.className,
          sizes: e.sizes,
          "data-widths": e.getAttribute("data-widths") || "[]",
        },
      }),
    );
  }));
class PaymentTerms extends VariantChangeBase {
  onVariantChanged(t) {
    if (t.detail.variant) {
      const e = $4('[name="id"]', this);
      ((e.value = t.detail.variant.id),
        e.dispatchEvent(new Event("change", { bubbles: !0 })));
    }
  }
}
class BackInStock extends VariantChangeBase {
  connectedCallback() {
    this.hasAttribute("is-pr-default") ||
      ((this.select = $4("[back-instock-select]", this)),
      (this.originalText = $4("[back-instock-text]", this).textContent),
      (this.elReplace = $4('[name="contact[product]"]', this)),
      this.select.addEventListener("change", (t) => {
        this.elReplace.textContent = this.originalText
          .replace("nt94_name", this.select.selectedOptions[0].textContent)
          .replace("nt94_vid", this.select.value);
      }),
      super.connectedCallback());
  }
  onVariantChanged(t) {
    const e = t.detail.variant;
    (this.hasAttribute("toogle-hidden") && (this.hidden = e && e.available),
      e &&
        !e.available &&
        this.select.value != e.id &&
        ((this.select.value = e.id),
        this.select.dispatchEvent(new Event("change", { bubbles: !1 }))));
  }
}
class IncomingMess extends VariantChangeBase {
  connectedCallback() {
    this.hasAttribute("is-pr-default") || super.connectedCallback();
  }
  onVariantChanged(t) {
    const e = t.detail.variant,
      i = JSON.parse(this.dataset.obj)[e.id];
    ((this.hidden = !e || !i),
      i &&
        (($4(
          "[data-incoming-date]",
          e.available ? this.firstElementChild : this.lastElementChild,
        ).textContent = i),
        (this.firstElementChild.hidden = !e.available || !e.requires_shipping),
        (this.lastElementChild.hidden = !this.firstElementChild.hidden)));
  }
}
var _form_atc_visible,
  form_atc_visible_fn,
  _copy_to_clipboard,
  copy_to_clipboard_fn,
  _native_share,
  native_share_fn,
  _variant_toogle,
  variant_toogle_fn,
  _onLoadingStart,
  onLoadingStart_fn,
  _onLoadingEnd,
  onLoadingEnd_fn,
  _sticky_select = new WeakMap(),
  _formElement = new WeakMap(),
  _quickOrderElement = new WeakMap(),
  _intersection_observer = new WeakMap(),
  _latestFormCondition = new WeakMap(),
  stickyRunOne = !0;
class StickyATC extends VariantChangeBase {
  #e;
  constructor() {
    (super(...arguments),
      getterAdd(_form_atc_visible, this),
      getterAdd(_latestFormCondition, this, !1),
      getterAdd(
        _intersection_observer,
        this,
        new IntersectionObserver(
          getterRunFn(_form_atc_visible, this, form_atc_visible_fn).bind(this),
        ),
      ));
  }
  connectedCallback() {
    (getterAdd(_formElement, this, document.forms[this.getAttribute("form")]),
      getterGet(_formElement, this) &&
        (getterGet(_intersection_observer, this).observe(
          getterGet(_formElement, this),
        ),
        getterAdd(_quickOrderElement, this, $4("hdt-quick-order-list")),
        getterGet(_quickOrderElement, this) &&
          getterGet(_intersection_observer, this).observe(
            getterGet(_quickOrderElement, this),
          )),
      this.hasAttribute("is-pr-default") ||
        (getterAdd(_sticky_select, this, $4("[tag-select]", this)),
        super.connectedCallback(),
        getterGet(_sticky_select, this) &&
          ((this.#e = getterGet(_sticky_select, this).value),
          getterGet(_sticky_select, this).addEventListener("change", (t) => {
            this.variantPicker?.selectVariantByID(
              t.target.value,
              $4(".hdt-product-media__main hdt-slider")?.isActive,
            );
          }))));
  }
  get variantPicker() {
    return (this._variantPicker =
      this._variantPicker ||
      $4(`hdt-variant-picker[form="${this.getAttribute("form")}"]`));
  }
  onVariantChanged(t) {
    const e = t.detail.variant;
    if (e && this.#e != e.id) {
      const stickySelect = getterGet(_sticky_select, this);
      if (stickySelect) {
        stickySelect.value = e.id;
        this.#e = stickySelect.value;
      } else {
        this.#e = e.id;
      }
      const hiddenInput = $4('[name="id"]', this);
      if (hiddenInput) hiddenInput.value = e.id;
      const t2 = $4("[data-v-img]", this),
        i = e.featured_image;
      if (t2 && i) {
        const e2 = createImg({
          src: i.src,
          width: t2.getAttribute("width"),
          height: t2.getAttribute("height"),
          alt: t2.alt,
          onload: !0,
          attrs: {
            class: t2.className,
            sizes: t2.sizes,
            "data-widths": t2.getAttribute("data-widths") || "[]",
            "data-v-img": "",
          },
        });
        t2.replaceWith(e2);
      }
      ($4("wrapp-hdt-pr-frm > form", this).dispatchEvent(
        new CustomEvent(variantChange, {
          bubbles: !1,
          detail: { variant: e, jumpMedia: !1 },
        }),
      ),
        ($4('[name="add"]', this).disabled = !e || !e.available),
        ($4('[name="add"]', this).firstElementChild.textContent =
          themeHDN.extras[
            e
              ? e.variant_state.pre_order
                ? "preOrder"
                : e.available
                  ? "addToCart"
                  : "soldOut"
              : "unavailable"
          ]));
    }
  }
}
((_form_atc_visible = new WeakSet()),
  (form_atc_visible_fn = function (t) {
    if (this.variantPicker?.hasAttribute("no-pick"))
      return (
        (stickyRunOne = !1),
        void document.body.style.setProperty("--sticky-atc-height", "0px")
      );
    document.body.style.removeProperty("--sticky-atc-height");
    const e = t.find((t2) => t2.target === getterGet(_formElement, this)),
      i =
        !!getterGet(_quickOrderElement, this) &&
        t.find((t2) => t2.target === getterGet(_quickOrderElement, this));
    (e &&
      getterAdd(
        _latestFormCondition,
        this,
        !e.isIntersecting && e.boundingClientRect.bottom < 0,
        !0,
      ),
      i &&
        getterGet(_quickOrderElement, this) &&
        getterAdd(_latestFormCondition, this, !i.isIntersecting, !0),
      document.body.classList.toggle(
        "sticky-shown",
        getterGet(_latestFormCondition, this),
      ),
      stickyRunOne &&
        !getterGet(_latestFormCondition, this) &&
        setTimeout(() => {
          (getterAdd(
            _latestFormCondition,
            this,
            window.innerHeight + Math.round(window.scrollY) >=
              document.body.offsetHeight,
            !0,
          ),
            document.body.classList.toggle(
              "sticky-shown",
              getterGet(_latestFormCondition, this),
            ),
            (stickyRunOne = !1));
        }, 100));
  }));
class CopyButton extends HTMLElement {
  constructor() {
    (super(),
      getterAdd(_copy_to_clipboard, this),
      this.addEventListener(
        "click",
        getterRunFn(_copy_to_clipboard, this, copy_to_clipboard_fn).bind(
          this,
          this.input,
        ),
      ),
      (this.actionCopy = this.input ? "value" : "textContent"),
      this.input &&
        this.hasAttribute("get-document") &&
        this.closest("hdt-popover")?.addEventListener(
          "dialog:beforeOpen",
          (t) => {
            this.input[this.actionCopy] = this.textCopy;
          },
        ));
  }
  get input() {
    return $id4(this.getAttribute("text-id"));
  }
  get textCopy() {
    return this.hasAttribute("get-document")
      ? document.location.href
      : this.getAttribute("data-text") || "";
  }
}
((_copy_to_clipboard = new WeakSet()),
  (copy_to_clipboard_fn = async function (t) {
    if (
      navigator.clipboard &&
      (await navigator.clipboard.writeText(this.textCopy),
      this.hasAttribute("data-success-message"))
    ) {
      const e = (t = t || this)[this.actionCopy];
      ((t[this.actionCopy] = this.getAttribute("data-success-message")),
        setTimeout(() => {
          t[this.actionCopy] = e;
        }, 1500));
    }
  }));
class ShareButton extends HTMLElement {
  constructor() {
    (super(),
      getterAdd(_native_share, this),
      navigator.share &&
        !window.matchMedia("screen and (pointer: fine)").matches &&
        ((this.hidden = !1),
        this.addEventListener(
          "click",
          getterRunFn(_native_share, this, native_share_fn),
        )));
  }
}
((_native_share = new WeakSet()),
  (native_share_fn = function () {
    navigator.share({
      title: this.getAttribute("share-title") || document.title,
      url: this.getAttribute("share-link") || document.location.href,
    });
  }));
class VaraintToogle extends HTMLElement {
  constructor() {
    (super(), getterAdd(_variant_toogle, this));
  }
  connectedCallback() {
    this.firstElementChild &&
      document.addEventListener(
        variantChange,
        getterRunFn(_variant_toogle, this, variant_toogle_fn).bind(this),
      );
  }
}
((_variant_toogle = new WeakSet()),
  (variant_toogle_fn = function (t) {
    const e = t.detail.variant;
    ($$4("[variant-id]:not([hidden])", this).forEach((t2) => (t2.hidden = !0)),
      e &&
        e.id &&
        $4(`[variant-id="${e.id}"]`, this)?.removeAttribute("hidden"));
  }),
  customElements.define("hdt-variant-picker", VariantPicker),
  customElements.define("hdt-price", Price),
  customElements.define("hdt-compare-at-price", CompareAtPrice),
  customElements.define("hdt-unit-price", UnitPrice),
  customElements.define("hdt-qty-price", QtyPrice),
  customElements.define("hdt-badge", Badge),
  customElements.define("hdt-variant-inventory", VariantInventory),
  customElements.define("hdt-variant-live", VariantLive),
  customElements.define("hdt-pickup-availability", PickupAvailability),
  customElements.define("hdt-variant-preview-img", VariantPreviewImg),
  customElements.define("hdt-payment-terms", PaymentTerms),
  customElements.define("hdt-back-instock", BackInStock),
  customElements.define("hdt-incoming-mess", IncomingMess),
  customElements.define("hdt-sticky-btn-atc", StickyATC),
  customElements.define("wrapp-hdt-copy-btn", CopyButton),
  customElements.define("wrapp-hdt-share-btn", ShareButton),
  customElements.define("hdt-varaint-toogle-info", VaraintToogle));
class LoadingBar extends HTMLElement {
  constructor() {
    (super(),
      getterAdd(_onLoadingStart, this),
      getterAdd(_onLoadingEnd, this),
      document.addEventListener(
        "theme:loading:doing",
        getterRunFn(_onLoadingStart, this, onLoadingStart_fn).bind(this),
      ),
      document.addEventListener(
        "theme:loading:done",
        getterRunFn(_onLoadingEnd, this, onLoadingEnd_fn).bind(this),
      ));
  }
}
((_onLoadingStart = new WeakSet()),
  (onLoadingStart_fn = function () {
    animate(
      this,
      { opacity: [0, 1], transform: ["scaleX(0)", "scaleX(0.8)"] },
      { duration: 0.5 },
    );
  }),
  (_onLoadingEnd = new WeakSet()),
  (onLoadingEnd_fn = async function () {
    (await animate(this, { transform: [null, "scaleX(1)"] }, { duration: 0.25 })
      .finished,
      animate(this, { opacity: 0 }, { duration: 0.25 }));
  }),
  customElements.define("hdt-loading-bar", LoadingBar));
class RevealItems extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    _matchMedia("motion") &&
      this.enabledReveal &&
      $$4(this.selector, this).length > 0 &&
      inView(this, this.reveal.bind(this));
  }
  get selector() {
    const t = this.getAttribute("selector") || ".hdt-card-product";
    return (
      (this.prependEl || "") +
      t +
      (this.appendEl || "").replaceAll(/nathan/g, t)
    );
  }
  get enabledReveal() {
    return this.getAttribute("reveal-on-scroll") === "true";
  }
  reveal() {
    animate(
      $$4(this.selector, this),
      { opacity: [0, 1], transform: ["translateY(30px)", "translateY(0)"] },
      {
        duration: 0.25,
        easing: "ease",
        delay: stagger(0.05, { start: 0.3, easing: "ease" }),
      },
    );
  }
}
customElements.define("hdt-reval-items", RevealItems);
var _load_more_url,
  load_more_url_fn,
  _lm_render,
  lm_render_fn,
  _lm_a = new WeakMap();
const str_shopify_section = "shopify-section";
class LoadMore extends HTMLElement {
  #t;
  constructor() {
    (super(),
      getterAdd(_load_more_url, this),
      getterAdd(_lm_render, this),
      getterAdd(_lm_a, this, $4("a", this)));
  }
  connectedCallback() {
    ((this.#t = new AbortController()),
      (this.abortController2 = null),
      getterGet(_lm_a, this).addEventListener(
        "click",
        getterRunFn(_load_more_url, this, load_more_url_fn).bind(this),
        { signal: this.#t.signal },
      ));
  }
  disconnectedCallback() {
    this.#t.abort();
  }
  get idcontrol() {
    return "#" + getterGet(_lm_a, this).getAttribute("append");
  }
}
((_load_more_url = new WeakSet()),
  (load_more_url_fn = function (t) {
    t.preventDefault();
    const e = new URL(getterGet(_lm_a, this).href);
    (e.searchParams.set(
      "section_id",
      getterGet(_lm_a, this).getAttribute("section-id"),
    ),
      getterRunFn(_lm_render, this, lm_render_fn).call(this, {
        detail: { url: e, id: this.idcontrol },
      }));
  }),
  (_lm_render = new WeakSet()),
  (lm_render_fn = async function (t) {
    (this.abortController2 && this.abortController2.abort(),
      (this.abortController2 = new AbortController()));
    const e = t.detail.url,
      i = e.searchParams.get("section_id"),
      n = e.searchParams.get("page"),
      s = document.getElementById(`shopify-section-${i}`);
    new URL(e).searchParams.delete("section_id");
    const r = $4(t.detail.id, s),
      a = $4("[loadmore-btn-wrapp]", s);
    try {
      a.setAttribute("loading", "");
      const i2 = new DOMParser().parseFromString(
          await (
            await fetch(e.toString(), {
              signal: this.abortController2.signal,
            }).then((t2) => t2)
          ).text(),
          "text/html",
        ),
        s2 = $4(`.shopify-section ${t.detail.id}`, i2);
      (r.lastElementChild.classList.add(`point-effect-${n}`),
        r.append(...document.importNode(s2, !0).childNodes),
        r.dispatchEvent(new CustomEvent("products:update", { bubbles: !0 })),
        _matchMedia("motion") &&
          ((r.prependEl = `.point-effect-${n} ~ `), r.reveal()));
      const o = $4("[loadmore-btn-wrapp]", i2);
      o
        ? (a.replaceChildren(...document.importNode(o, !0).childNodes),
          a.removeAttribute("loading"))
        : a.remove();
    } catch {}
  }),
  customElements.define("wrapp-hdt-lm-url", LoadMore));
var _qty_forms,
  _qty_inputs,
  _on_variant_changed2,
  on_variant_changed2_fn,
  _on_cart_changed2,
  on_cart_changed2_fn,
  _update_quantity_rules,
  update_quantity_rules_fn,
  _set_quantity_boundries,
  set_quantity_boundries_fn,
  _block_required_froms,
  _block_required_detect,
  _block_required_on_change,
  block_required_on_change_fn,
  _block_required_on_submit,
  block_required_on_submit_fn,
  ON_CHANGE_DEBOUNCE_TIMER = 300,
  _variant_picker2 = new WeakMap();
class QuantityWrapp extends HTMLElement {
  #t;
  constructor() {
    (super(...arguments),
      getterAdd(_qty_inputs, this, $4("input", this)),
      getterAdd(_on_variant_changed2, this),
      getterAdd(_on_cart_changed2, this),
      getterAdd(_update_quantity_rules, this),
      getterAdd(_set_quantity_boundries, this),
      getterAdd(
        _variant_picker2,
        this,
        $4(`hdt-variant-picker[form="${this.getAttribute("form")}"]`),
      ));
  }
  get input() {
    return getterGet(_qty_inputs, this);
  }
  get quantityForm() {
    return $id4(`Quantity-Form-${this.getAttribute("section-id")}`);
  }
  async connectedCallback() {
    if (((this.#t = new AbortController()), this.input)) {
      if (
        (getterAdd(
          _qty_forms,
          this,
          document.forms[
            (
              this.getAttribute("form") ||
              this.input.getAttribute("form") ||
              ""
            ).replace("id:", "")
          ],
        ),
        this.input.addEventListener("change", this.onInputChange.bind(this), {
          signal: this.#t.signal,
        }),
        $$4("button", this).forEach((t) =>
          t.addEventListener("click", this.onButtonClick.bind(this), {
            signal: this.#t.signal,
          }),
        ),
        (this.buttonMinus = $4(".hdt-quantity__button[name='minus']", this)),
        (this.buttonPlus = $4(".hdt-quantity__button[name='plus']", this)),
        this.validateQtyRules(),
        this.quantityForm && this.hasAttribute("handle"))
      ) {
        if (getterGet(_variant_picker2, this))
          (await getJSONProduct.load(this.getAttribute("handle")),
            (this.variants = getterGet(
              _variants_data,
              getterGet(_variant_picker2, this),
            )));
        else {
          this.variants = (
            await await getJSONProduct.load(this.getAttribute("handle"))
          ).variants;
          const t = this.variants[0];
          (t.quantity_rule ||
            (t.quantity_rule = { min: 1, max: null, increment: 1, max4: !0 }),
            t.quantity_rule.max ||
              ((t.quantity_rule.max = this.input.dataset.max),
              (t.quantity_rule.max4 = !0)),
            (this.variants[0] = t));
        }
        (getterRunFn(
          _set_quantity_boundries,
          this,
          set_quantity_boundries_fn,
        ).call(this),
          getterGet(_qty_forms, this)?.addEventListener(
            variantChange,
            getterRunFn(
              _on_variant_changed2,
              this,
              on_variant_changed2_fn,
            ).bind(this),
            { signal: this.#t.signal },
          ),
          document.addEventListener(
            "cart:change",
            getterRunFn(_on_cart_changed2, this, on_cart_changed2_fn).bind(
              this,
            ),
            { signal: this.#t.signal },
          ));
      }
      this.debouncedOnChange = debounce(() => {
        this.input.dispatchEvent(
          new CustomEvent("change", {
            bubbles: !0,
            detail: { target: this.input },
          }),
        );
      }, ON_CHANGE_DEBOUNCE_TIMER);
    }
  }
  disconnectedCallback() {
    this.#t.abort();
  }
  onInputChange() {
    this.validateQtyRules();
  }
  onButtonClick(t) {
    t.preventDefault();
    const e = this.input.value;
    (t.target.name === "plus" ? this.input.stepUp() : this.input.stepDown(),
      e !== this.input.value && this.debouncedOnChange());
  }
  validateQtyRules() {
    const t = parseInt(this.input.value),
      e = this.input.max || 9999,
      i = parseInt(String(e) != "null" ? e : 9999);
    ((this.input.value = Math.min(t, i)),
      this.hasAttribute("form") &&
        getterGet(_qty_forms, this)?.dispatchEvent(
          new CustomEvent("change", {
            bubbles: !0,
            detail: { target: this.input },
          }),
        ),
      this.input.min &&
        this.buttonMinus.classList.toggle(
          "disabled",
          t <= parseInt(this.input.min),
        ),
      this.buttonPlus.classList.toggle("disabled", t >= parseInt(i)));
  }
}
((_qty_forms = new WeakMap()),
  (_qty_inputs = new WeakMap()),
  (_on_variant_changed2 = new WeakSet()),
  (on_variant_changed2_fn = function (t) {
    const e = t.detail.variant;
    (this.setAttribute("variant-id", e ? e.id : ""),
      e &&
        getterRunFn(
          _update_quantity_rules,
          this,
          update_quantity_rules_fn,
        ).call(this, e));
  }),
  (_on_cart_changed2 = new WeakSet()),
  (on_cart_changed2_fn = async function (t) {
    if (!this.variants) return;
    const rulesCartEl = $4(".hdt-quantity__rules-cart", this.quantityForm);
    if (rulesCartEl) rulesCartEl.hidden = !0;
    const e = this.variants.find(
      (t2) => this.getAttribute("variant-id") == t2.id,
    );
    if (!e) return;
    const i = t.detail.cart || (await fetchCart);
    i.items
      .concat(i.items_added || [], i.items_removed || [])
      .find((t2) => e.id == t2.variant_id) &&
      getterRunFn(_update_quantity_rules, this, update_quantity_rules_fn).call(
        this,
        e,
        i,
      );
  }),
  (_set_quantity_boundries = new WeakSet()),
  (set_quantity_boundries_fn = function () {
    const t = {
      cartQuantity: this.input.dataset.cartQuantity
        ? parseInt(this.input.dataset.cartQuantity)
        : 0,
      min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
      max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
      step: this.input.step ? parseInt(this.input.step) : 1,
    };
    let e = t.min;
    const i = t.max == null ? t.max : t.max - t.cartQuantity;
    (i != null && (e = Math.min(e, i)),
      t.cartQuantity >= t.min && (e = Math.min(e, t.step)),
      (this.input.min = e === 0 && t.min > 0 ? t.min : e),
      (this.input.max = e === 0 && t.min > 0 ? t.min : i),
      (this.input.value = e === 0 && t.min > 0 ? t.min : e),
      this.input.dispatchEvent(new Event("change")));
    const form = this.input.form;
    const addBtn = form?.querySelector('button[name="add"]');
    if (addBtn) {
      if (i === 0) {
        addBtn.setAttribute("disabled", "true");
        addBtn.dataset.atMaxDisabled = "true";
      } else if (addBtn.dataset.atMaxDisabled) {
        addBtn.removeAttribute("disabled");
        delete addBtn.dataset.atMaxDisabled;
      }
    }
  }),
  (_update_quantity_rules = new WeakSet()),
  (update_quantity_rules_fn = async function (t, e = null) {
    const i = (e = e || (await fetchCart)).items.find((e2) => e2.id === t.id);
    const rulesCartEl2 = $4(".hdt-quantity__rules-cart", this.quantityForm);
    if (rulesCartEl2) rulesCartEl2.hidden = !i;
    if (i) {
      const qtyCartEl = $4(".hdt-quantity-cart", this.quantityForm);
      if (qtyCartEl) qtyCartEl.textContent = i.quantity;
    }
    t.quantity_rule ||
      (t.quantity_rule = { min: 1, max: null, increment: 1, max4: !0 });
    const n = t.quantity_rule,
      { increment: s, min: r, max: a } = themeHDN.extras.quantity;
    const rulesEl = $4(".hdt-quantity__rules", this.quantityForm);
    if (rulesEl) {
      rulesEl.innerHTML = `${
        n.increment > 1
          ? `<span class="hdt-divider">${s.replace("1904", n.increment)}</span>`
          : ""
      }${
        n.min > 1
          ? `<span class="hdt-divider">${r.replace("1904", n.min)}</span>`
          : ""
      }${
        n.max == null || n.max4
          ? ""
          : `<span class="hdt-divider">${a.replace("1904", n.max)}</span>`
      }`;
    }
    let maxVal = n.max;
    const atcMaxEl = this.getAttribute("data-atc-max")
      ? this
      : this.closest && this.closest("[data-atc-max]");
    const atcMaxStr = atcMaxEl && atcMaxEl.getAttribute("data-atc-max");
    if (atcMaxStr) {
      const atcNum = parseInt(atcMaxStr, 10);
      if (!isNaN(atcNum) && (maxVal == null || atcNum < maxVal))
        maxVal = atcNum;
    }
    if (
      t.inventory_quantity != null &&
      t.inventory_management === "shopify" &&
      t.inventory_policy !== "continue"
    ) {
      const invQty = parseInt(t.inventory_quantity, 10);
      if (!isNaN(invQty) && (maxVal == null || invQty < maxVal)) maxVal = invQty;
    }
    const o = ["data-cart-quantity", "data-min", "data-max", "step"],
      l = ["min", "max", "increment"];
    const values = [
      `${i ? i.quantity : 0}`,
      n.min,
      maxVal,
      n.increment,
    ];
    for (const [t2, e2] of o.entries()) {
      const val = values[t2];
      val !== null && val !== undefined
        ? this.input.setAttribute(e2, val)
        : this.input.removeAttribute(e2);
    }
    getterRunFn(_set_quantity_boundries, this, set_quantity_boundries_fn).call(
      this,
    );
  }),
  customElements.define("hdt-quantity-wrapp", QuantityWrapp));
class BlockRequired extends HTMLElement {
  #t;
  constructor() {
    (super(),
      getterAdd(_block_required_on_submit, this),
      getterAdd(_block_required_on_change, this),
      getterAdd(_block_required_detect, this, this.getAttribute("detect")));
  }
  connectedCallback() {
    this.#t = new AbortController();
    const t = $$4("[required]", this);
    t.length != 0 &&
      (getterAdd(_block_required_froms, this, document.forms[this.attrForm]),
      getterGet(_block_required_froms, this) &&
        (t.forEach((t2) => {
          (t2.removeAttribute("required"), this.classList.add("is-required"));
        }),
        this.updateBreak(),
        this.getAttribute("event") === "change"
          ? (setTimeout(() => (this.checked = $4("input:checked", this)), 100),
            this.addEventListener(
              "change",
              getterRunFn(
                _block_required_on_change,
                this,
                block_required_on_change_fn,
              ).bind(this),
              { signal: this.#t.signal },
            ))
          : this.addEventListener(
              "input",
              debounce(
                getterRunFn(
                  _block_required_on_change,
                  this,
                  block_required_on_change_fn,
                ).bind(this),
                150,
                { signal: this.#t.signal },
              ),
            ),
        getterGet(_block_required_froms, this).addEventListener(
          "submit",
          getterRunFn(
            _block_required_on_submit,
            this,
            block_required_on_submit_fn,
          ).bind(this),
          { signal: this.#t.signal },
        )));
  }
  get attrForm() {
    return (this._attrForm =
      this._attrForm || $4("[form]", this).getAttribute("form"));
  }
  updateBreak() {
    getterGet(_block_required_froms, this).checkBreak =
      $$4(`hdt-block-required [form="${this.attrForm}"]`).length !=
      $$4(
        `hdt-block-required:not(.is-uncheck, .is-required) [form="${this.attrForm}"]`,
      ).length;
  }
  disconnectedCallback() {
    this.#t.abort();
  }
  createStyle() {
    const t = [];
    let e,
      i = 0;
    for (e = 0; e < 10; e++)
      (t.push(`translate3d(${arguments[i++]},0,0)`),
        i === arguments.length && (i = 0));
    return t;
  }
  set checked(t) {
    this.setChecked = t;
  }
  get checked() {
    return this.setChecked;
  }
}
((_block_required_froms = new WeakMap()),
  (_block_required_detect = new WeakMap()),
  (_block_required_on_change = new WeakSet()),
  (block_required_on_change_fn = function () {
    if (
      ((this.checked = !1),
      getterGet(_block_required_detect, this) === "checked")
    )
      $4("input:checked", this) && (this.checked = !0);
    else {
      const t = $4('input[type="text"]', this) || $4("textarea", this);
      t && t.value.length > 0 && (this.checked = !0);
    }
    (this.classList.remove("is-uncheck"),
      this.classList.toggle("is-required", !this.checked),
      this.updateBreak());
  }),
  (_block_required_on_submit = new WeakSet()),
  (block_required_on_submit_fn = function (t) {
    this.checked ||
      (t.preventDefault(),
      t.stopPropagation(),
      this.classList.remove("is-required"),
      this.classList.add("is-uncheck"),
      $4(`hdt-block-required.is-uncheck [form="${this.attrForm}"]`).focus(),
      animate(
        this,
        { transform: this.createStyle(0, "-10px", "10px") },
        {
          offset: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
          duration: 1,
          ease: "ease",
        },
      ));
  }),
  customElements.define("hdt-block-required", BlockRequired));
class CheckedToUse extends HTMLElement {
  #t;
  constructor() {
    super();
  }
  connectedCallback() {
    this.#t = new AbortController();
    const t = $id4(this.getAttribute("get-id"));
    (t
      ? t.addEventListener(
          "change",
          (e) => this.firstElementChild.toggleAttribute("disabled", !t.checked),
          {
            signal: this.#t.signal,
          },
        )
      : this.firstElementChild.removeAttribute("disabled"),
      this.addEventListener(
        "click",
        (e) => {
          t.checked ||
            this.closest("form")?.dispatchEvent(
              new Event("submit", { bubbles: !0 }),
            );
        },
        { signal: this.#t.signal },
      ));
  }
  disconnectedCallback() {
    this.#t.abort();
  }
}
customElements.define("hdt-need-checked-to-use", CheckedToUse);
var _is_cart_dirty,
  _cart_on_change,
  cart_on_change_fn,
  _remove_item_on_cart,
  remove_item_on_cart_fn,
  _remove_forms,
  _cart_note_on_change,
  cart_note_on_change_fn,
  _cart_form = new WeakMap();
class CartForm extends HTMLElement {
  #t;
  constructor() {
    (super(),
      getterAdd(_is_cart_dirty, this, !1),
      getterAdd(_cart_on_change, this),
      getterAdd(_cart_form, this, $4("form", this)));
  }
  connectedCallback() {
    ((this.#t = new AbortController()),
      getterGet(_cart_form, this).addEventListener(
        "change",
        getterRunFn(_cart_on_change, this, cart_on_change_fn),
        { signal: this.#t.signal },
      ));
  }
  disconnectedCallback() {
    this.#t.abort();
  }
}
((_is_cart_dirty = new WeakMap()),
  (_cart_on_change = new WeakSet()),
  (cart_on_change_fn = async function (t) {
    if (
      getterGet(_is_cart_dirty, this) ||
      !t.target.hasAttribute("will-change-cart")
    )
      return;
    getterAdd(_is_cart_dirty, this, !0, !0);
    const e = t.detail && t.detail.target ? t.detail.target : t.target,
      i = e.closest(".hdt-cart-item");
    (document.dispatchEvent(
      new CustomEvent("theme:loading:doing", { bubbles: !0 }),
    ),
      i?.classList.add("hdt-pe-none"));
    let n = [];
    document.dispatchEvent(
      new CustomEvent("cart:push:section.id", {
        bubbles: !0,
        detail: { sections: n },
      }),
    );
    const s = await (
      await fetch(`${Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          line: e.dataset.index,
          quantity: e.value || 0,
          sections: n.join(","),
        }),
      })
    ).json();
    (getterAdd(_is_cart_dirty, this, !1, !0),
      document.dispatchEvent(
        new CustomEvent("theme:loading:done", { bubbles: !0 }),
      ),
      i?.classList.remove("hdt-pe-none"),
      document.dispatchEvent(
        new CustomEvent("cart:change", {
          bubbles: !0,
          detail: { baseEvent: "line-item:change", cart: s },
        }),
      ));
  }));
class RemoveItemOnCart extends btnTooltip {
  #t;
  constructor() {
    (super(), getterAdd(_remove_item_on_cart, this));
  }
  connectedCallback() {
    (super.connectedCallback(),
      getterAdd(
        _remove_forms,
        this,
        document.forms[(this.getAttribute("form") || "").replace("id:", "")] ||
          this.closest("form"),
      ),
      (this.#t = new AbortController()),
      (this.abortController2 = null),
      this.addEventListener(
        "click",
        getterRunFn(_remove_item_on_cart, this, remove_item_on_cart_fn).bind(
          this,
        ),
        {
          signal: this.#t.signal,
        },
      ));
  }
  disconnectedCallback() {
    (super.disconnectedCallback(), this.#t.abort());
  }
}
((_remove_forms = new WeakMap()),
  (_remove_item_on_cart = new WeakSet()),
  (remove_item_on_cart_fn = async function (t) {
    (t.preventDefault(),
      getterGet(_remove_forms, this).dispatchEvent(
        new CustomEvent("change", { bubbles: !0, detail: { target: this } }),
      ));
  }));
class CartNote extends HTMLElement {
  #t;
  constructor() {
    (super(), getterAdd(_cart_note_on_change, this));
  }
  connectedCallback() {
    ((this.#t = new AbortController()),
      this.addEventListener(
        "change",
        getterRunFn(_cart_note_on_change, this, cart_note_on_change_fn).bind(
          this,
        ),
        { signal: this.#t.signal },
      ));
  }
  disconnectedCallback() {
    this.#t.abort();
  }
}
((_cart_note_on_change = new WeakSet()),
  (cart_note_on_change_fn = function (t) {
    const e = t.target.value;
    (fetch(`${Shopify.routes.root}cart/update.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ note: e }),
      keepalive: !0,
    }),
      $$4("[data-label-note]").forEach((t2) => {
        t2.childElementCount === 2 &&
          (t2.firstElementChild.toggleAttribute("hidden", e.length > 0),
          t2.lastElementChild.toggleAttribute("hidden", e.length === 0));
      }));
  }));
var _refresh_cart_count,
  refresh_cart_count_fn,
  _render_cart_drawer,
  render_cart_drawer_fn,
  _cart_bundled_section,
  cart_bundled_section_fn,
  _on_cart_change,
  on_cart_change_fn,
  _on_page_show,
  on_page_show_fn,
  _refresh_cart,
  refresh_cart_fn,
  _cart_section_id,
  _cart_page_bundled_section,
  cart_page_bundled_section_fn,
  _cart_page_section_id,
  _render_cart_page,
  render_cart_page_fn,
  _on_cart_page_change,
  on_cart_page_change_fn,
  _allow_update_progress_bar,
  _update_progress_bar,
  update_progress_bar_fn,
  _color_progress_bar,
  _onCountryChanged,
  onCountryChanged_fn,
  _estimateShipping,
  estimateShipping_fn,
  _getAsyncShippingRates,
  getAsyncShippingRates_fn,
  _formatShippingRates,
  formatShippingRates_fn,
  _formatError,
  formatError_fn,
  createCartPromise = () =>
    new Promise(async (t) => {
      t(await (await fetch(`${Shopify.routes.root}cart.js`)).json());
    }),
  fetchCart = createCartPromise();
(document.addEventListener("cart:change", (t) => {
  // Only update fetchCart if cart data is valid to prevent undefined issues
  if (t?.detail?.cart && typeof t.detail.cart === "object") {
    fetchCart = t.detail.cart;
  }
}),
  document.addEventListener("cart:refresh", () => {
    fetchCart = createCartPromise();
  }),
  window.addEventListener("pageshow", (t) => {
    t.persisted && (fetchCart = createCartPromise());
  }));
class CartCount extends HTMLElement {
  #t;
  constructor() {
    (super(), getterAdd(_refresh_cart_count, this));
  }
  connectedCallback() {
    ((this.#t = new AbortController()),
      document.addEventListener(
        "cart:change",
        (t) => {
          // Safely extract item_count with null/undefined checks to prevent "undefined" text
          const itemCount = t?.detail?.cart?.item_count;
          this.itemCount = itemCount != null ? itemCount : 0;
        },
        {
          signal: this.#t.signal,
        },
      ),
      document.addEventListener(
        "cart:refresh",
        getterRunFn(_refresh_cart_count, this, refresh_cart_count_fn).bind(
          this,
        ),
        { signal: this.#t.signal },
      ),
      window.addEventListener(
        "pageshow",
        getterRunFn(_refresh_cart_count, this, refresh_cart_count_fn).bind(
          this,
        ),
        { signal: this.#t.signal },
      ));
  }
  disconnectedCallback() {
    this.#t.abort();
  }
  set itemCount(t) {
    // Prevent "undefined" from being displayed - default to 0 or empty string
    const value = t != null ? t : 0;
    this.innerText = value;
  }
}
((_refresh_cart_count = new WeakSet()),
  (refresh_cart_count_fn = async function () {
    try {
      // fetchCart might be a Promise or a cart object (from cart:change event)
      const cart =
        fetchCart && typeof fetchCart.then === "function"
          ? await fetchCart
          : fetchCart;
      const itemCount = cart?.item_count;
      this.itemCount = itemCount != null ? itemCount : 0;
    } catch (error) {
      console.error("Error refreshing cart count:", error);
      this.itemCount = 0; // Fallback to 0 on error
    }
  }));
class CartDot extends CartCount {
  set itemCount(t) {
    this.classList.toggle("is-visible", t > 0);
  }
}
class CartDrawer extends Drawer {
  constructor() {
    (super(),
      getterAdd(_cart_section_id, this, this.getAttribute("section-id")),
      getterAdd(_render_cart_drawer, this),
      getterAdd(_cart_bundled_section, this),
      getterAdd(_on_cart_change, this),
      getterAdd(_on_page_show, this),
      getterAdd(_refresh_cart, this));
  }
  connectedCallback() {
    (super.connectedCallback(),
      document.addEventListener(
        "cart:push:section.id",
        getterRunFn(_cart_bundled_section, this, cart_bundled_section_fn).bind(
          this,
        ),
        { signal: this.abortController.signal },
      ),
      document.addEventListener(
        "cart:change",
        getterRunFn(_on_cart_change, this, on_cart_change_fn).bind(this),
        {
          signal: this.abortController.signal,
        },
      ),
      document.addEventListener(
        "cart:refresh",
        getterRunFn(_refresh_cart, this, refresh_cart_fn).bind(this),
        {
          signal: this.abortController.signal,
        },
      ),
      window.addEventListener(
        "pageshow",
        getterRunFn(_on_page_show, this, on_page_show_fn).bind(this),
        {
          signal: this.abortController.signal,
        },
      ));
  }
}
((_cart_section_id = new WeakMap()),
  (_render_cart_drawer = new WeakSet()),
  (render_cart_drawer_fn = async function (t, e = null) {
    const i = new DOMParser().parseFromString(t, "text/html"),
      n = $4(".hdt-free-shipping-bar", i);
    let s = 0;
    n &&
      ((s = $4(".hdt-progress-bar", n).getAttribute("aria-valuenow")),
      ($4(".hdt-progress-bar", n).valueNow = $4(
        ".hdt-progress-bar",
        this,
      ).getAttribute("aria-valuenow")),
      $4(".hdt-progress-bar", n).style.setProperty(
        "--progress-rate",
        $4(".hdt-progress-bar", this).style.getPropertyValue("--progress-rate"),
      ));
    const r = document
      .createRange()
      .createContextualFragment(
        i
          .getElementById(
            `shopify-section-${getterGet(_cart_section_id, this)}`,
          )
          .querySelector("hdt-cart-drawer").innerHTML,
      );
    ((e || (await fetchCart).item_count) === 0
      ? (await timeline([
          [
            this.selectorPartName("body"),
            { opacity: [1, 0] },
            { duration: 0.15, easing: "ease-in" },
          ],
          [
            this.selectorPartName("footer"),
            {
              opacity: [1, 0],
              transform: ["translateY(0)", "translateY(30px)"],
            },
            { duration: 0.15, at: "<", easing: "ease-in" },
          ],
        ]).finished,
        this.replaceChildren(...r.children),
        animate(
          this.selectorPartName("body"),
          { opacity: [0, 1], transform: ["translateY(30px)", "translateY(0)"] },
          { duration: 0.25, easing: [0.25, 0.46, 0.45, 0.94] },
        ))
      : this.replaceChildren(...r.children),
      n && ($4(".hdt-progress-bar", this).valueNow = s),
      document.dispatchEvent(new CustomEvent("currency:update")),
      document.dispatchEvent(new CustomEvent("cart:drawer:render")));
  }),
  (_cart_bundled_section = new WeakSet()),
  (cart_bundled_section_fn = function (t) {
    t.detail.sections.push(getterGet(_cart_section_id, this));
  }),
  (_on_cart_change = new WeakSet()),
  (on_cart_change_fn = function (t) {
    Shopify?._on_cart_change?.(t?.detail?.cart);
    if (
      (getterRunFn(_render_cart_drawer, this, render_cart_drawer_fn).call(
        this,
        t.detail.cart.sections[getterGet(_cart_section_id, this)],
        t.detail.cart.item_count,
      ),
      t.detail.disabledDrawerChange ||
        document.dispatchEvent(
          new CustomEvent("cart:drawer:change", {
            detail: { sections: t.detail.cart.sections },
          }),
        ),
      t.detail.baseEvent === "variant:add")
    ) {
      const e = t.detail.actionAfterATC || themeHDN.settings.actionAfterATC;
      e.indexOf("go_") > -1
        ? (window.location.href = `${Shopify.routes.root}${
            e == "go_cart_page" ? "cart" : "checkout"
          }`)
        : e == "open_cart_drawer" && Shopify.cartNotification();
    }
  }),
  (_on_page_show = new WeakSet()),
  (on_page_show_fn = function (t) {
    t.persisted && getterRunFn(_refresh_cart, this, refresh_cart_fn).call(this);
  }),
  (_refresh_cart = new WeakSet()),
  (refresh_cart_fn = async function () {
    getterRunFn(_render_cart_drawer, this, render_cart_drawer_fn).call(
      this,
      await (
        await fetch(
          `${Shopify.routes.root}?section_id=${getterGet(
            _cart_section_id,
            this,
          )}`,
        )
      ).text(),
    );
  }));
class CartPageForm extends CartForm {
  #t;
  constructor() {
    (super(),
      getterAdd(
        _cart_page_section_id,
        this,
        getterGet(_cart_form, this).getAttribute("section-id"),
      ),
      getterAdd(_render_cart_page, this),
      getterAdd(_cart_page_bundled_section, this),
      getterAdd(_on_cart_page_change, this));
  }
  connectedCallback() {
    (super.connectedCallback(),
      (this.#t = new AbortController()),
      document.addEventListener(
        "cart:change",
        getterRunFn(_on_cart_page_change, this, on_cart_page_change_fn).bind(
          this,
        ),
        { signal: this.#t.signal },
      ),
      document.addEventListener(
        "cart:push:section.id",
        getterRunFn(
          _cart_page_bundled_section,
          this,
          cart_page_bundled_section_fn,
        ).bind(this),
        { signal: this.#t.signal },
      ));
  }
  disconnectedCallback() {
    (super.disconnectedCallback(), this.#t.abort());
  }
}
((_cart_page_section_id = new WeakMap()),
  (_render_cart_page = new WeakSet()),
  (render_cart_page_fn = async function (t, e = null) {
    const i = new DOMParser().parseFromString(t, "text/html"),
      n = $4(".hdt-free-shipping-bar", i),
      s = this.closest(".shopify-section");
    let r = 0;
    n &&
      ((r = $4(".hdt-progress-bar", n).getAttribute("aria-valuenow")),
      ($4(".hdt-progress-bar", n).valueNow = $4(
        ".hdt-progress-bar",
        s,
      ).getAttribute("aria-valuenow")),
      $4(".hdt-progress-bar", n).style.setProperty(
        "--progress-rate",
        $4(".hdt-progress-bar", s).style.getPropertyValue("--progress-rate"),
      ));
    const a = $4(".shopify-section [main-content]", i).innerHTML;
    ((e || (await fetchCart).item_count) === 0
      ? (await animate(
          s,
          { opacity: [1, 0], transform: ["translateY(0)", "translateY(30px)"] },
          { duration: 0.25, easing: [0.25, 0.46, 0.45, 0.94] },
        ).finished,
        ($4("[main-content]", s).innerHTML = a),
        animate(
          s,
          { opacity: [0, 1], transform: ["translateY(30px)", "translateY(0)"] },
          { duration: 0.25, easing: [0.25, 0.46, 0.45, 0.94] },
        ))
      : ($4("[main-content]", s).innerHTML = a),
      n && ($4(".hdt-progress-bar", s).valueNow = r),
      document.dispatchEvent(new CustomEvent("currency:update")));
  }),
  (_on_cart_page_change = new WeakSet()),
  (on_cart_page_change_fn = function (t) {
    if (t.detail.baseEvent === "variant:add")
      return (window.location.href = `${Shopify.routes.root}cart`);
    getterRunFn(_render_cart_page, this, render_cart_page_fn).call(
      this,
      t.detail.cart.sections[getterGet(_cart_page_section_id, this)],
      t.detail.cart.item_count,
    );
  }),
  (_cart_page_bundled_section = new WeakSet()),
  (cart_page_bundled_section_fn = function (t) {
    t.detail.sections.push(getterGet(_cart_page_section_id, this));
  }),
  customElements.define("wrapp-hdt-cart-form", CartForm),
  customElements.define("wrapp-hdt-cart-page-form", CartPageForm),
  customElements.define("wrapp-remove-item-oncart", RemoveItemOnCart),
  customElements.define("hdt-cart-note", CartNote),
  customElements.define("hdt-cart-count", CartCount),
  customElements.define("hdt-cart-dot", CartDot),
  customElements.define("hdt-cart-drawer", CartDrawer));
class ProgressBar extends HTMLElement {
  constructor() {
    (super(),
      getterAdd(_update_progress_bar, this),
      getterAdd(
        _allow_update_progress_bar,
        this,
        !this.hasAttribute("reveal-in-view"),
      ),
      getterAdd(_color_progress_bar, this, this.getAttribute("data-colors")));
  }
  static get observedAttributes() {
    return ["aria-valuenow", "aria-valuemax"];
  }
  connectedCallback() {
    this.hasAttribute("reveal-in-view") &&
      inView(
        this,
        () => {
          (getterAdd(_allow_update_progress_bar, this, !0, !0),
            getterRunFn(
              _update_progress_bar,
              this,
              update_progress_bar_fn,
            ).call(this));
        },
        { margin: "-50px 0px" },
      );
  }
  get progress() {
    return Math.min(
      1,
      this.getAttribute("aria-valuenow") / this.getAttribute("aria-valuemax"),
    );
  }
  set valueMax(t) {
    this.setAttribute("aria-valuemax", t);
  }
  set valueNow(t) {
    this.setAttribute("aria-valuenow", t);
  }
  attributeChangedCallback() {
    getterGet(_allow_update_progress_bar, this) &&
      getterRunFn(_update_progress_bar, this, update_progress_bar_fn).call(
        this,
      );
  }
}
((_color_progress_bar = new WeakMap()),
  (_allow_update_progress_bar = new WeakMap()),
  (_update_progress_bar = new WeakSet()),
  (update_progress_bar_fn = function () {
    const t = JSON.parse(getterGet(_color_progress_bar, this)),
      e = (this.progress + "").slice(0, 3);
    if (t && t[e])
      for (let [i, n] of Object.entries(t))
        this.parentElement.classList.toggle(n, i == e);
    this.style.setProperty("--progress-rate", `${this.progress}`);
  }),
  customElements.define("hdt-progress-bar", ProgressBar));
class CountryProvinceSelector extends HTMLElement {
  #t;
  constructor() {
    (super(...arguments), getterAdd(_onCountryChanged, this));
  }
  connectedCallback() {
    ((this.#t = new AbortController()),
      (this.countryEl = $4('[name="address[country]"]', this)),
      (this.provinceEl = $4('[name="address[province]"]', this)),
      this.countryEl.addEventListener(
        "change",
        getterRunFn(_onCountryChanged, this, onCountryChanged_fn).bind(this),
        { signal: this.#t.signal },
      ),
      this.getAttribute("country") !== "" &&
        (this.countryEl.selectedIndex = Math.max(
          0,
          Array.from(this.countryEl.options).findIndex(
            (t) => t.textContent === this.getAttribute("country"),
          ),
        )),
      this.countryEl.dispatchEvent(new Event("change")));
  }
  disconnectedCallback() {
    this.#t.abort();
  }
}
((_onCountryChanged = new WeakSet()),
  (onCountryChanged_fn = function () {
    const t = this.countryEl.options[this.countryEl.selectedIndex],
      e = JSON.parse(t.getAttribute("data-provinces"));
    ((this.provinceEl.parentElement.hidden = e.length === 0),
      (this.provinceEl.disabled = e.length === 0),
      e.length !== 0 &&
        ((this.provinceEl.innerHTML = ""),
        e.forEach((t2) => {
          const e2 =
            t2[1] === this.getAttribute("province") ||
            t2[0] === this.getAttribute("province");
          this.provinceEl.options.add(new Option(t2[1], t2[0], e2, e2));
        })));
  }),
  customElements.define(
    "hdt-country-province-selector",
    CountryProvinceSelector,
  ));
var ShippingCalculator = class extends HTMLElement {
  #t;
  constructor() {
    (super(),
      getterAdd(_estimateShipping, this),
      getterAdd(_getAsyncShippingRates, this),
      getterAdd(_formatShippingRates, this),
      getterAdd(_formatError, this),
      (this.langRates = JSON.parse(
        $4("template[data-lang-rates]", this).innerHTML,
      )));
  }
  currencyMulti(t) {
    return (
      themeHDN.settings.currencyFormat.indexOf("with_comma_separator") !== -1 &&
        (t = t.replace(/[,.]/g, function (t2) {
          return t2 === "," ? "." : ",";
        })),
      parseFloat(t.replace(/^[^0-9]+|[^0-9.]/g, "", ""), 10) *
        parseFloat(Shopify.currency.rate)
    );
  }
  connectedCallback() {
    ((this.#t = new AbortController()),
      (this.submitButton = $4('[type="button"]', this)),
      (this.resultsElement = $4('[aria-live="polite"]', this)),
      this.submitButton.addEventListener(
        "click",
        getterRunFn(_estimateShipping, this, estimateShipping_fn).bind(this),
        { signal: this.#t.signal },
      ));
  }
  disconnectedCallback() {
    this.#t.abort();
  }
};
((_estimateShipping = new WeakSet()),
  (estimateShipping_fn = async function (t) {
    t.preventDefault();
    const e = $4('[name="address[zip]"]', this).value,
      i = $4('[name="address[country]"]', this).value,
      n = $4('[name="address[province]"]', this),
      s = n.disabled ? "" : n.value;
    (this.submitButton.setAttribute("aria-busy", "true"),
      document.dispatchEvent(
        new CustomEvent("theme:loading:doing", { bubbles: !0 }),
      ));
    const r = await fetch(
      `${Shopify.routes.root}cart/prepare_shipping_rates.json?shipping_address[zip]=${e}&shipping_address[country]=${i}&shipping_address[province]=${s}`,
      { method: "POST" },
    );
    if (
      (document.dispatchEvent(
        new CustomEvent("theme:loading:done", { bubbles: !0 }),
      ),
      r.ok)
    ) {
      const t2 = await getterRunFn(
        _getAsyncShippingRates,
        this,
        getAsyncShippingRates_fn,
      ).call(this, e, i, s);
      getterRunFn(_formatShippingRates, this, formatShippingRates_fn).call(
        this,
        t2,
      );
    } else {
      const t2 = await r.json();
      getterRunFn(_formatError, this, formatError_fn).call(this, t2);
    }
    ((this.resultsElement.hidden = !1),
      this.submitButton.removeAttribute("aria-busy"));
  }),
  (_getAsyncShippingRates = new WeakSet()),
  (getAsyncShippingRates_fn = async function (t, e, i) {
    const n = await fetch(
        `${Shopify.routes.root}cart/async_shipping_rates.json?shipping_address[zip]=${t}&shipping_address[country]=${e}&shipping_address[province]=${i}`,
      ),
      s = await n.text();
    return s === "null"
      ? getterRunFn(
          _getAsyncShippingRates,
          this,
          getAsyncShippingRates_fn,
        ).call(this, t, e, i)
      : JSON.parse(s).shipping_rates;
  }),
  (_formatShippingRates = new WeakSet()),
  (formatShippingRates_fn = function (t) {
    let e = t.map(
      (t2) =>
        `<li>${t2.presentment_name}: ${
          t2.price == "0.00"
            ? this.langRates.free
            : `${formatMoney(
                this.currencyMulti(t2.price),
                themeHDN.settings.currencyFormat,
              )}`
        }</li>`,
    );
    this.resultsElement.innerHTML = `
    <div class="hdt-mess__rates is--rates-success">
      <p>${
        t.length === 0
          ? this.langRates.no_rates
          : t.length === 1
            ? this.langRates.one_rate
            : this.langRates.multiple_rates
      }</p>
      ${e === "" ? "" : `<ul role="list">${e.join("")}</ul>`}
    </div>
  `;
  }),
  (_formatError = new WeakSet()),
  (formatError_fn = function (t) {
    let e = Object.keys(t).map(
      (e2) => `<li><span class="hdt-key__rate">${e2}:</span> ${t[e2]}</li>`,
    );
    this.resultsElement.innerHTML = `
      <div class="hdt-mess__rates is--rates-error">
        <p>${this.langRates.errors}</p>
        <ul role="list">${e.join("")}</ul>
      </div>
    `;
  }),
  customElements.define("hdt-shipping-calculator", ShippingCalculator));
class player extends HTMLElement {
  static get observedAttributes() {
    return ["playing"];
  }
  connectedCallback() {
    ((this._abortController = new AbortController()),
      this.hasAttribute("autoplay") &&
        inView(this, this.play.bind(this), { margin: "0px 0px 0px 0px" }));
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
  get playing() {
    return this.hasAttribute("playing");
  }
  get player() {
    return (this._playerProxy =
      this._playerProxy ||
      new Proxy(this._createPlayer(), {
        get: (t, e) => async () => {
          ((t = await t), this._playerApi(t, e));
        },
      }));
  }
  play() {
    this.playing || this.player.play();
  }
  pause() {
    this.playing && this.player.pause();
  }
  attributeChangedCallback(t, e, i) {
    t === "playing" &&
      (e === null && i === ""
        ? (this.dispatchEvent(new CustomEvent("media:play", { bubbles: !0 })),
          this.hasAttribute("group") &&
            Array.from(
              document.querySelectorAll(
                `[group="${this.getAttribute("group")}"]`,
              ),
            )
              .filter((t2) => t2 !== this)
              .forEach((t2) => {
                t2.pause();
              }))
        : i === null &&
          this.dispatchEvent(new CustomEvent("media:pause", { bubbles: !0 })));
  }
}
class ModelPlayer extends player {
  connectedCallback() {
    (super.connectedCallback(), this.player);
  }
  _createPlayer() {
    return new Promise((t) => {
      (this.setAttribute("loaded", ""),
        window.Shopify.loadFeatures([
          {
            name: "shopify-xr",
            version: "1.0",
            onLoad: this._setupShopifyXr.bind(this),
          },
          {
            name: "model-viewer-ui",
            version: "1.0",
            onLoad: () => {
              const e = $4("model-viewer", this);
              (e.addEventListener("shopify_model_viewer_ui_toggle_play", () =>
                this.setAttribute("playing", ""),
              ),
                e.addEventListener("shopify_model_viewer_ui_toggle_pause", () =>
                  this.removeAttribute("playing"),
                ),
                t(new window.Shopify.ModelViewerUI(e, { focusOnPlay: !0 })));
            },
          },
        ]));
    });
  }
  _playerApi(t, e) {}
  async _setupShopifyXr() {
    if (window.ShopifyXR) {
      const t = $id4("ModelJson-" + this.getAttribute("section-id"));
      (window.ShopifyXR.addModels(JSON.parse(t.textContent)),
        window.ShopifyXR.setupXRElements(),
        this.closest("hdt-slider")?.reInit());
    } else
      document.addEventListener(
        "shopify_xr_initialized",
        this._setupShopifyXr.bind(this),
      );
  }
}
var onYouTubePromise = new Promise((t) => {
  window.onYouTubeIframeAPIReady = () => t();
});
class VideoPlayer extends player {
  #i = !1;
  connectedCallback() {
    (super.connectedCallback(),
      this.hasAttribute("autoplay") ||
        this.addEventListener("click", this.play, {
          once: !0,
          signal: this._abortController.signal,
        }),
      this.getAttribute("type") === "video" &&
        inView(
          this,
          () => {
            $4("video", this)?.setAttribute("preload", "metadata");
          },
          { margin: "800px" },
        ));
  }
  _createPlayer() {
    if (this.hasAttribute("host"))
      return (
        this.setAttribute("loaded", ""),
        new Promise(async (t) => {
          const e = $4("template", this);
          (e && e.replaceWith(e.content.firstElementChild.cloneNode(!0)),
            this.getAttribute("type") === "background" &&
              (this.sizeBackgroundVideo(),
              window.addEventListener(
                "resize",
                debounce(this.sizeBackgroundVideo.bind(this), 300),
              )));
          const i = this.hasAttribute("autoplay") || _matchMedia("phone"),
            n = document.createElement("script");
          if (
            ((n.type = "text/javascript"),
            this.getAttribute("host") === "youtube")
          ) {
            ((window.YT && window.YT.Player) ||
              ((n.src = "https://www.youtube.com/iframe_api"),
              document.head.appendChild(n),
              await new Promise((t2) => {
                n.onload = t2;
              })),
              await onYouTubePromise);
            const e2 = new YT.Player($4("iframe", this), {
              events: {
                onReady: () => {
                  (i && e2.mute(), t(e2));
                },
                onStateChange: (t2) => {
                  t2.data === YT.PlayerState.PLAYING
                    ? this.setAttribute("playing", "")
                    : (t2.data !== YT.PlayerState.ENDED &&
                        t2.data !== YT.PlayerState.PAUSED) ||
                      this.removeAttribute("playing");
                },
              },
            });
          }
          if (this.getAttribute("host") === "vimeo") {
            (window.Vimeo && window.Vimeo.Player) ||
              ((n.src = "https://player.vimeo.com/api/player.js"),
              document.head.appendChild(n),
              await new Promise((t2) => {
                n.onload = t2;
              }));
            const e2 = new Vimeo.Player($4("iframe", this));
            (i && e2.setMuted(!0),
              e2.on("play", () => {
                this.setAttribute("playing", "");
              }),
              e2.on("pause", () => this.removeAttribute("playing")),
              e2.on("ended", () => this.removeAttribute("playing")),
              t(e2));
          }
        })
      );
    {
      const t = $4("video", this);
      return (
        this.setAttribute("loaded", ""),
        t.addEventListener("play", () => {
          (this.setAttribute("playing", ""),
            this.removeAttribute("suspended"),
            this.#i && (t.controls = !1));
        }),
        t.addEventListener("pause", () => {
          !t.seeking && t.paused && this.removeAttribute("playing");
        }),
        t
      );
    }
  }
  _playerApi(t, e) {
    this.getAttribute("host") === "youtube"
      ? t[`${e}Video`]()
      : e !== "play" || this.hasAttribute("host")
        ? t[e]()
        : t.play().catch((e2) => {
            e2.name === "NotAllowedError" &&
              (this.setAttribute("suspended", ""),
              this.hasAttribute("controls") ||
                ((this.#i = !0), (t.controls = !0)));
          });
  }
  sizeBackgroundVideo() {
    var t,
      e,
      i,
      n,
      s = this.clientWidth,
      r = this.clientHeight;
    (s / r < 16 / 9
      ? ((t = r * (16 / 9)),
        (e = r),
        (i = -Math.round((t - s) / 2)),
        (n = -Math.round((e - r) / 2)))
      : ((e = (t = s) * (9 / 16)),
        (n = -Math.round((e - r) / 2)),
        (i = -Math.round((t - s) / 2))),
      ($4("iframe", this).style.cssText =
        `max-width: 1000%; margin-left: ${i}px; margin-top: ${n}px; width: ${t}px; height: ${e}px;`));
  }
}
import { PhotoSwipeLightbox, Zoom } from "vendor";
var _on_variant_changed_media,
  on_variant_changed_media_fn,
  _slider_main_select,
  slider_main_select_fn,
  _media_image_click,
  media_image_click_fn,
  _media_image_zoom,
  media_image_zoom_fn,
  _update_group_media,
  update_group_media_fn,
  _lightbox_psw_media_init = new WeakMap();
class ProductMedia extends HTMLElement {
  #t;
  constructor() {
    (super(),
      getterAdd(_on_variant_changed_media, this),
      getterAdd(_update_group_media, this),
      getterAdd(_slider_main_select, this),
      getterAdd(_media_image_click, this),
      getterAdd(_media_image_zoom, this));
  }
  connectedCallback() {
    ((this.#t = new AbortController()),
      this.form?.addEventListener(
        variantChange,
        getterRunFn(
          _on_variant_changed_media,
          this,
          on_variant_changed_media_fn,
        ).bind(this),
        { signal: this.#t.signal },
      ),
      this.sliderMain &&
        this.sliderMain.addEventListener(
          "select:slide",
          getterRunFn(_slider_main_select, this, slider_main_select_fn).bind(
            this,
          ),
          { signal: this.#t.signal },
        ),
      this.updateGroupFilter &&
        this.addEventListener(
          "update:value",
          getterRunFn(_update_group_media, this, update_group_media_fn).bind(
            this,
          ),
          { signal: this.#t.signal },
        ),
      this.imageZoom != "no" &&
        ($$4(
          '.hdt-product-media__main [data-media-type="image"]',
          this,
        ).forEach((t) => {
          t.addEventListener(
            "click",
            getterRunFn(_media_image_click, this, media_image_click_fn).bind(
              this,
              t,
            ),
            { signal: this.#t.signal },
          );
        }),
        this.addEventListener("lightbox:psw:open", (t) =>
          this.openLightBox(t?.detail?.index),
        )),
      (this.imageZoom != "zoom" && this.imageZoom != "zoom_lightbox") ||
        !_matchMedia("supports-hover") ||
        getterRunFn(_media_image_zoom, this, media_image_zoom_fn).call(this));
  }
  disconnectedCallback() {
    this.#t.abort();
  }
  get form() {
    return (this._form =
      this._form || document.forms[this.getAttribute("form")]);
  }
  get sliderMain() {
    return (this._sliderMain =
      this._sliderMain || $4(".hdt-product-media__main hdt-slider", this));
  }
  get sliderThumb() {
    return (this._sliderThumb =
      this._sliderThumb || $4("hdt-slider-thumb", this));
  }
  get variantPicker() {
    return (this._variantPicker =
      this._variantPicker ||
      $4(`hdt-variant-picker[form="${this.getAttribute("form")}"]`));
  }
  get updateGroupFilter() {
    return this.hasAttribute("can-has-media-group");
  }
  get imageZoom() {
    return this.getAttribute("image-zoom");
  }
  get sectionId() {
    return this.getAttribute("section-id");
  }
  get lightBox() {
    if (getterGet(_lightbox_psw_media_init, this))
      return getterGet(_lightbox_psw_media_init, this);
    let t = parseInt(this.getAttribute("max-zoom")) || 2;
    return (
      getterAdd(
        _lightbox_psw_media_init,
        this,
        new PhotoSwipeLightbox({
          pswpModule: () => import("photoswipe"),
          bgOpacity: 1,
          secondaryZoomLevel: t,
          maxZoomLevel: ++t,
          closeTitle: themeHDN.extras.pswp.close,
          zoomTitle: themeHDN.extras.pswp.zoom,
          arrowPrevTitle: themeHDN.extras.pswp.prev,
          arrowNextTitle: themeHDN.extras.pswp.next,
          errorMsg: themeHDN.extras.pswp.errorMsg,
        }),
      ),
      getterGet(_lightbox_psw_media_init, this).addFilter(
        "thumbEl",
        (t2, e) => e.thumbEl,
      ),
      getterGet(_lightbox_psw_media_init, this).on("close", () => {
        const t2 = $$4(
          '.hdt-product-media__main [data-media-type="image"]:not([hidden])',
        )[getterGet(_lightbox_psw_media_init, this).pswp.currIndex];
        t2 &&
          (this.sliderMain && this.sliderMain.isActive
            ? this.sliderMain.goToTarget(t2, !0)
            : t2.scrollIntoView({ block: "start", behavior: "instant" }));
      }),
      getterGet(_lightbox_psw_media_init, this).init(),
      getterGet(_lightbox_psw_media_init, this)
    );
  }
  openLightBox(t = 0) {
    const e = $$4(
      '.hdt-product-media__main [data-media-type="image"]:not([hidden]) img[hdt-el]',
      this,
    ).map((t2) => ({
      thumbEl: t2,
      src: t2.src,
      srcset: t2.srcset,
      msrc: t2.currentSrc || t2.src,
      width: parseInt(t2.getAttribute("width")),
      height: parseInt(t2.getAttribute("height")),
      alt: t2.alt,
      thumbCropped: !0,
    }));
    this.lightBox.loadAndOpen(t, e);
  }
}
((_on_variant_changed_media = new WeakSet()),
  (on_variant_changed_media_fn = function (t) {
    const e = t.detail.variant;
    if (
      (getterRunFn(_update_group_media, this, update_group_media_fn).call(
        this,
        e,
      ),
      e.mdid && t.detail.jumpMedia)
    ) {
      const t2 = $4(
        `.hdt-product-media__main [data-media-id="${e.mdid}"]`,
        this,
      );
      t2 &&
        (this.sliderMain.isActive
          ? this.sliderMain.goToTarget(t2)
          : t2.scrollIntoView({ block: "start", behavior: "smooth" }));
    }
  }),
  (_update_group_media = new WeakSet()),
  (update_group_media_fn = function (t) {
    const e = t.options || t.detail.options;
    if (!this.updateGroupFilter) return;
    let i = !1;
    (e.forEach((t2, e2) => {
      ($$4(`[data-group-name="option${e2}"][data-group-value="${t2}"][hidden]`)
        .length &&
        this.sliderMain.isActive &&
        ($4(
          "[data-media-type].is-selected hdt-video-player[loaded]",
          this,
        )?.pause(),
        (i = !0)),
        $$4(`[data-group-name="option${e2}"]`, this).forEach((e3) => {
          e3.getAttribute("data-group-value") == t2
            ? e3.removeAttribute("hidden")
            : e3.setAttribute("hidden", "");
        }));
    }),
      i && (this.sliderMain.reInit(), this.sliderThumb?.reInit()));
  }),
  (_slider_main_select = new WeakSet()),
  (slider_main_select_fn = function (t) {
    const e = t.detail.sliderApi,
      i = e.slideNodes()[e.selectedScrollSnap()],
      n = e.slideNodes()[e.previousScrollSnap()],
      s = i.getAttribute("data-media-id") || null,
      r = (i.dataset.variantsId || "").split(";");
    switch (
      (s &&
        this.variantPicker &&
        this.hasAttribute("update-when-variant-change") &&
        r[0] &&
        r.indexOf(this.form.id.value) < 0 &&
        this.variantPicker.selectVariantByID(r[0], !1),
      n.getAttribute("data-media-type"))
    ) {
      case "video":
      case "external_video":
        $4("hdt-video-player[loaded]", n)?.pause();
    }
    switch (i.getAttribute("data-media-type")) {
      case "video":
      case "external_video":
        this.hasAttribute("autoplay-media") && $4("hdt-video-player", i).play();
        break;
      case "model":
        _matchMedia("phone") || $4("hdt-model-player", i).play();
    }
  }),
  (_media_image_click = new WeakSet()),
  (media_image_click_fn = function (t) {
    const e = $$4(
      '.hdt-product-media__main [data-media-type="image"]:not([hidden])',
      this,
    );
    this.dispatchEvent(
      new CustomEvent("lightbox:psw:open", {
        bubbles: !0,
        detail: { index: e.indexOf(t) },
      }),
    );
  }),
  (_media_image_zoom = new WeakSet()),
  (media_image_zoom_fn = function () {
    var t = "zoom_fade_media",
      e = "zoom_fade_info",
      i = JSON.parse(this.getAttribute("zoom-options")),
      n = $id4(`product-zoom-${this.sectionId}`),
      s = $id4(`product-info-${this.sectionId}`),
      r = i.type,
      a = i.magnify,
      o = r == "external";
    (Shopify.designMode &&
      $4(".drift-zoom-pane, .drift-bounding-box")?.remove(),
      html.classList.add(`zoom-type--${r}`),
      $$4(
        '.hdt-product-media__main [data-media-type="image"] img',
        this,
      ).forEach((i2) => {
        new Zoom(i2, {
          sourceAttribute: "src",
          zoomFactor: a,
          inlinePane: !o && r == "inner2",
          containInline: o,
          paneContainer: o ? n : i2.parentElement,
          hoverBoundingBox: o,
          handleTouch: !1,
          onShow: () => {
            (this.classList.add(t), s.classList.add(e));
          },
          onHide: () => {
            (this.classList.remove(t), s.classList.remove(e));
          },
        });
      }));
  }));
class OpenLightboxPSWMedia extends HTMLElement {
  constructor() {
    (super(),
      this.addEventListener("click", () =>
        this.dispatchEvent(
          new CustomEvent("lightbox:psw:open", { bubbles: !0 }),
        ),
      ));
  }
}
var lightbox_psw_init_fn,
  _lightbox_psws = new WeakMap();
class OpenLightboxPSW extends HTMLElement {
  #t;
  constructor() {
    (super(), getterAdd(_lightbox_psw_init, this));
  }
  connectedCallback() {
    ((this.#t = new AbortController()),
      this.dataset.objImg &&
        (getterRunFn(_lightbox_psw_init, this, lightbox_psw_init_fn).call(this),
        this.addEventListener(
          "click",
          () => this.lightBox?.loadAndOpen(this.dataset.index || 0),
          {
            signal: this.#t.signal,
          },
        )));
  }
  disconnectedCallback() {
    this.#t.abort();
  }
  get lightBox() {
    return getterGet(_lightbox_psws, this);
  }
  get objImg() {
    return this.getAttribute("obj-img");
  }
}
((_lightbox_psw_init = new WeakSet()),
  (lightbox_psw_init_fn = function () {
    let t = null;
    const e = JSON.parse(this.dataset.objImg);
    ((e.srcset = renderSrcset(
      e.src,
      JSON.parse(
        this.dataset.widths ||
          `[246, 493, 600, 713, 823, 990, 1100, 1206, 1346, 1426, 1646, 1946, 2200, 2500, 3000, 3500, 4000, ${e.width}]`,
      ),
    )),
      (t = [e]),
      getterAdd(
        _lightbox_psws,
        this,
        new PhotoSwipeLightbox({
          bgOpacity: 1,
          showHideAnimationType: "fade",
          pswpModule: () => import("photoswipe"),
          dataSource: t,
        }),
      ),
      this.lightBox.init(),
      (t = null));
  }));
var _lightbox_psw_init = new WeakMap();
class GalleryModal extends HTMLElement {
  #t;
  constructor() {
    super();
  }
  connectedCallback() {
    ((this.#t = new AbortController()),
      this.images.length != 0 &&
        (console.log(this.lightbox),
        this.images.forEach((t, e) =>
          t.addEventListener("click", this.openLightBox.bind(this, e), {
            signal: this.#t.signal,
          }),
        )));
  }
  disconnectedCallback() {
    this.#t.abort();
  }
  get images() {
    return $$4(this.getAttribute("selector") || "img", this);
  }
  get lightBox() {
    if (getterGet(_lightbox_psw_init, this))
      return getterGet(_lightbox_psw_init, this);
    const {
      close: t,
      zoom: e,
      prev: i,
      next: n,
      errorMsg: s,
    } = themeHDN.extras.pswp;
    let r = parseInt(this.getAttribute("max-zoom")) || 2,
      a = this.images.map((t2) => {
        const { src: e2, currentSrc: i2, alt: n2 } = t2,
          s2 = renderSrcset(
            e2,
            JSON.parse(
              t2.dataset.widths ||
                `[246, 493, 600, 713, 823, 990, 1100, 1206, 1346, 1426, 1646, 1946, 2200, 2500, 3000, 3500, 4000, ${t2.getAttribute(
                  "width",
                )}]`,
            ),
          );
        return {
          thumbnailElement: t2,
          src: e2,
          srcset: s2,
          msrc: i2 || e2,
          width: parseInt(t2.getAttribute("width")),
          height: parseInt(t2.getAttribute("height")),
          alt: n2,
          thumbCropped: !0,
        };
      });
    return (
      getterAdd(
        _lightbox_psw_init,
        this,
        new PhotoSwipeLightbox({
          pswpModule: () => import("photoswipe"),
          dataSource: a,
          bgOpacity: 1,
          secondaryZoomLevel: r,
          maxZoomLevel: ++r,
          closeTitle: t,
          zoomTitle: e,
          arrowPrevTitle: i,
          arrowNextTitle: n,
          errorMsg: s,
        }),
      ),
      getterGet(_lightbox_psw_init, this).init(),
      (a = null),
      getterGet(_lightbox_psw_init, this)
    );
  }
  openLightBox(t = 0) {
    this.lightBox.loadAndOpen(t);
  }
}
(customElements.define("hdt-video-player", VideoPlayer),
  customElements.define("hdt-model-player", ModelPlayer),
  customElements.define("hdt-product-media", ProductMedia),
  customElements.define("wrapp-open-pswp-media", OpenLightboxPSWMedia),
  customElements.define("wrapp-open-pswp-btn", OpenLightboxPSW),
  customElements.define("hdt-gallery-modal", GalleryModal));
var _item_compare_color,
  item_compare_color_fn,
  _items_compare_color = new WeakMap();
class CompareToogle extends HTMLElement {
  #t;
  constructor() {
    (super(),
      getterAdd(
        _items_compare_color,
        this,
        $$4(
          ".hdt-compare-color-item",
          this.closest(".hdt-modal__compare-color"),
        ),
      ),
      getterAdd(_item_compare_color, this));
  }
  connectedCallback() {
    ((this.#t = new AbortController()),
      (this.indexOrder = 0),
      $$4("button", this).forEach((t, e) => {
        (++this.indexOrder,
          t.addEventListener(
            "click",
            getterRunFn(_item_compare_color, this, item_compare_color_fn).bind(
              this,
              t,
              e,
            ),
            { signal: this.#t.signal },
          ));
      }));
  }
  disconnectedCallback() {
    this.#t.abort();
  }
}
((_item_compare_color = new WeakSet()),
  (item_compare_color_fn = function (t, e) {
    const i = t.classList.toggle("is-hide-color");
    (t.firstElementChild.toggleAttribute("hidden", i),
      t.lastElementChild.toggleAttribute("hidden", !i),
      console.log(this.indexOrder, e, getterGet(_items_compare_color, this)),
      i
        ? (--this.indexOrder,
          getterGet(_items_compare_color, this)[e].setAttribute("hidden", ""))
        : (++this.indexOrder,
          getterGet(_items_compare_color, this)[e].removeAttribute("hidden"),
          (getterGet(_items_compare_color, this)[e].style.order =
            this.indexOrder)));
  }),
  customElements.define("hdt-compare-color-toogle", CompareToogle));
class closeAnnounceWrap extends HTMLElement {
  constructor() {
    (super(),
      sessionStorage.getItem(announceSize) !== "true"
        ? this.addEventListener("click", (t) => {
            Shopify.designMode || sessionStorage.setItem(announceSize, "true");
            let e = this.closest(".hdt-section-group");
            (e.style.setProperty("overflow", "hidden"),
              animate(e, {
                height: [`${e.clientHeight}px`, "0px"],
              }).finished.then(() => {
                (e.classList.add("hdt-announcement-hidden"),
                  (announceSize = null));
              }));
          })
        : (announceSize = null));
  }
}
customElements.define("wrapp-close-announce", closeAnnounceWrap);
class lazyHTML extends HTMLElement {
  #t;
  check = !0;
  constructor() {
    super();
  }
  connectedCallback() {
    this.#t = new AbortController();
    const t = {
        priority: this.getAttribute("priority") || "low",
        signal: this.#t.signal,
      },
      e =
        this.url ||
        this.getAttribute("url") ||
        `${Shopify.routes.root}?section_id=${this.getAttribute("section-id")}`;
    e && this.lazyFetch(e, t);
  }
  disconnectedCallback() {
    this.check && this.#t.abort();
  }
  async lazyFetch(t, e) {
    const i = await cachedFetch(t, "", e),
      n = new DOMParser().parseFromString(await i.text(), "text/html");
    this.check = !1;
    const s = $4(".shopify-localization-form", n);
    if (s) {
      const t2 = $id4("localization_form_language");
      $4('[name="return_to"]', s).value =
        t2 && t2.return_to ? t2.return_to.value : location.pathname;
    }
    this._replace(n);
  }
  _replace(t) {
    (this.replaceWith(...t.body.children),
      this.dispatchEvent(new CustomEvent("lazyhtml:added", { bubbles: !0 })));
  }
}
var cachMenuURl = new Map();
class lazySubmenu extends lazyHTML {
  check = !0;
  url = `${Shopify.routes.root}search?type=product&q=submenu${
    this.getAttribute("key") || ""
  }&section_id=${this.dataset.section}`;
  constructor() {
    super();
  }
  async lazyFetch(t, e) {
    if (cachMenuURl.has(t))
      this.addEventListener("loaded:lazy", (t2) =>
        this._replace(t2.detail.tempDiv),
      );
    else {
      cachMenuURl.set(t, !0);
      const i = await cachedFetch(t, "", e),
        n = new DOMParser().parseFromString(await i.text(), "text/html");
      ((this.check = !1),
        this._replace(n),
        $$4(
          `hdt-lazy-submenu[data-section="${this.dataset.section}"]:not([id="${this.id}"])`,
        ).forEach((t2) => {
          t2.dispatchEvent(
            new CustomEvent("loaded:lazy", {
              bubbles: !1,
              detail: { tempDiv: n },
            }),
          );
        }));
    }
  }
  _replace(t) {
    ((this.innerHTML = t.querySelector(`#${this.id}`).innerHTML),
      this.dispatchEvent(new CustomEvent("products:update", { bubbles: !0 })),
      this.dispatchEvent(new CustomEvent("lazyhtml:added", { bubbles: !0 })));
  }
}
(customElements.define("hdt-lazy-html", lazyHTML),
  customElements.define("hdt-lazy-submenu", lazySubmenu),
  (() => {
    const t = "hdt-reveal",
      e = t + "--offscreen",
      i = t + "--cancel",
      n = (t2) => {
        const e2 = t2.target;
        e2.isAnimationend &&
          (e2.setAttribute("animationend", ""),
          e2.removeEventListener("animationend", n));
      };
    function s(t2, s2) {
      t2.forEach((t3, r2) => {
        const a2 = t3.target;
        (a2.setAttribute("observed", ""),
          t3.isIntersecting
            ? (a2.classList.contains(e) &&
                (a2.classList.remove(e),
                a2.hasAttribute("timeline") &&
                  a2.style.setProperty("--animation-order", r2)),
              s2.unobserve(a2))
            : (a2.classList.add(e), a2.classList.remove(i)),
          (a2.isAnimationend = !0),
          a2.addEventListener("animationend", n));
      });
    }
    function r(e2 = document, i2 = !1) {
      const n2 = $$4(`[${t}]:not([observed])`, e2);
      if (n2.length === 0) return;
      if (i2)
        return void n2.forEach((e3) => {
          e3.classList.add(t + "--design-mode");
        });
      const r2 = new IntersectionObserver(s, {
        rootMargin: "0px 0px -50px 0px",
      });
      n2.forEach((t2) => r2.observe(t2));
    }
    themeHDN.settings.revealInView &&
      matchMedia("motion") &&
      (html.classList.add("hdt-reveal-in-view"),
      window.addEventListener("DOMContentLoaded", () => r()),
      Shopify.designMode &&
        (document.addEventListener(adnmEvts.seLoad, (t2) => r(t2.target, !0)),
        document.addEventListener(adnmEvts.seReorder, () => r(document, !0))));
    const a = () => {
      const t2 = window.innerWidth - document.body.clientWidth;
      t2 >= 0 && html.style.setProperty("--scrollbar-w", `${t2}px`);
      const e2 = $4("#MainContent .hdt-section");
      if (!e2) return;
      const i2 = $4(".md\\:hdt-height--full, .hdt-height--full", e2);
      i2 &&
        i2.offsetTop < window.innerHeight &&
        e2.style.setProperty(
          "--fill-height-first",
          100 - i2.offsetTop / (window.innerHeight / 100) + "vh",
        );
    };
    if (
      (a(),
      window.addEventListener("resize", throttle(a)),
      _matchMedia("supports-hover") &&
        $$4(".hdt-btn-effect-3d").forEach((t2) => {
          (t2.addEventListener("mousemove", function (e2) {
            const i2 = t2.getBoundingClientRect(),
              n2 = e2.clientX - i2.left - i2.width / 2,
              s2 = e2.clientY - i2.top - i2.height / 2;
            ((t2.style.transform =
              "translate(" + 0.15 * n2 + "px, " + 0.3 * s2 + "px)"),
              (t2.style.transform +=
                "rotate3d(" + -0.1 * n2 + ", " + -0.3 * s2 + ", 0, 12deg)"),
              t2.children[0] &&
                ((t2.children[0].style.transition = "all .2s linear"),
                (t2.children[0].style.transform =
                  "translate(" + 0.07 * n2 + "px, " + 0.14 * s2 + "px)")));
          }),
            t2.addEventListener("mouseleave", function () {
              ((t2.style.transform = "translate3d(0px, 0px, 0px)"),
                (t2.style.transform += "rotate3d(0, 0, 0, 0deg)"),
                t2.children[0] &&
                  (t2.children[0].style.transform =
                    "translate3d(0px, 0px, 0px)"));
            }));
        }),
      rteWrapTable(),
      accessibleLinks(),
      localeUrl(),
      navigator.userAgent &&
        /iPad|iPhone|iPod/.test(navigator.userAgent) &&
        ($4('meta[name="viewport"]', document.head).content =
          "width=device-width, initial-scale=1.0, height=device-height, minimum-scale=1.0, maximum-scale=1.0"),
      "ontouchend" in document)
    ) {
      let t2 = 0;
      const e2 = () => {
        (++t2, t2 > 1 && document.removeEventListener("touchend", e2));
      };
      document.addEventListener("touchend", e2);
    }
    $4("hdt-cart-drawer") ||
      themeHDN.settings.pageType == "cart" ||
      document.addEventListener("variant:add", (t2) => {
        const e2 = t2.detail.actionAfterATC || themeHDN.settings.actionAfterATC;
        e2.indexOf("go_") > -1 &&
          (window.location.href = `${Shopify.routes.root}${
            e2 == "go_cart_page" ? "cart" : "checkout"
          }`);
      });
  })());

export {
  $4,
  $$4,
  $id4,
  getterAdd,
  getterGet,
  getterRunFn,
  isRTL,
  getUID,
  throttle,
  debounce,
  formatMoney,
  btnTooltip,
  _matchMedia,
  cachedFetch,
  Drawer,
  VariantChangeBase,
  localeUrl,
};
//# sourceMappingURL=/s/files/1/0490/6011/8686/t/158/assets/global.js.map?v=1735798150
